webpackJsonp([0],{

/***/ "+0uh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOverlay)?_c('div',{staticClass:"pause-overlay"},[_c('div',{staticClass:"icon-holder"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.togglePlay($event)}}},[_c('icon',{attrs:{"icon":"play","size":"5x"}})],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Gzs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+UQR":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIxIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMTIxIDMyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNOC40MzQwNCAzLjcyMDdMMCAxMy44OTEySDMuOTY4OTZWMjguMjc4N0MzLjk2ODk2IDMxLjA1NjkgNi42MTQ5NCAzMS45MTY5IDcuOTM3OTIgMzEuOTk5NkgxMy4zOTUyVjI4LjI3ODdIOS42NzQzNUM4LjY4MjExIDI4LjA4MDIgOC40MzQwNCAyNi44NzMgOC40MzQwNCAyNi4yOTQyVjEzLjg5MTJIMTMuNjQzM1YxMC40MTgzSDguNDM0MDRWMy43MjA3WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzFfMjU1MTcpIi8+CjxwYXRoIGQ9Ik0yNC43OTQzIDEwLjQxODZIMjAuMzI5MlYzMS43NTE4SDI0Ljc5NDNWMTAuNDE4NloiIGZpbGw9InVybCgjcGFpbnQxX2xpbmVhcl8xXzI1NTE3KSIvPgo8cGF0aCBkPSJNMjUuMDQzMiAyLjcyODY1QzI1LjA0MzIgNC4wOTg2NSAyMy45MzI2IDUuMjA5MjUgMjIuNTYyNiA1LjIwOTI1QzIxLjE5MjYgNS4yMDkyNSAyMC4wODIgNC4wOTg2NSAyMC4wODIgMi43Mjg2NUMyMC4wODIgMS4zNTg2NSAyMS4xOTI2IDAuMjQ4MDQ3IDIyLjU2MjYgMC4yNDgwNDdDMjMuOTMyNiAwLjI0ODA0NyAyNS4wNDMyIDEuMzU4NjUgMjUuMDQzMiAyLjcyODY1WiIgZmlsbD0idXJsKCNwYWludDJfbGluZWFyXzFfMjU1MTcpIi8+CjxwYXRoIGQ9Ik0zOC40MjUxIDBIMzMuNzExOVYzMS43NTE3SDM4LjQyNTFWMjEuNTgxMkw0Ni44NTkxIDMxLjc1MTdINTMuMDYwNkw0My4zODYzIDIwLjgzNzFMNTIuMzE2NCAxMC40MTg1SDQ2Ljg1OTFMMzguNDI1MSAyMC44MzcxVjBaIiBmaWxsPSJ1cmwoI3BhaW50M19saW5lYXJfMV8yNTUxNykiLz4KPHBhdGggZD0iTTY0LjcwMzYgMy43MjA3TDU2LjI2OTUgMTMuODkxMkg2MC4yMzg1VjI4LjI3ODdDNjAuMjM4NSAzMS4wNTY5IDYyLjg4NDUgMzEuOTE2OSA2NC4yMDc1IDMxLjk5OTZINjkuNjY0OFYyOC4yNzg3SDY1Ljk0MzlDNjQuOTUxNiAyOC4wODAyIDY0LjcwMzYgMjYuODczIDY0LjcwMzYgMjYuMjk0MlYxMy44OTEySDY5LjkxMjhWMTAuNDE4M0g2NC43MDM2VjMuNzIwN1oiIGZpbGw9InVybCgjcGFpbnQ0X2xpbmVhcl8xXzI1NTE3KSIvPgo8cGF0aCBkPSJNODAuODE0NSAxMC40MTg2SDc2LjM0OTVWMzEuNzUxOEg4MC44MTQ1VjEwLjQxODZaIiBmaWxsPSJ1cmwoI3BhaW50NV9saW5lYXJfMV8yNTUxNykiLz4KPHBhdGggZD0iTTgxLjA2MjggMi43Mjg2NUM4MS4wNjI4IDQuMDk4NjUgNzkuOTUyMiA1LjIwOTI1IDc4LjU4MjIgNS4yMDkyNUM3Ny4yMTIyIDUuMjA5MjUgNzYuMTAxNiA0LjA5ODY1IDc2LjEwMTYgMi43Mjg2NUM3Ni4xMDE2IDEuMzU4NjUgNzcuMjEyMiAwLjI0ODA0NyA3OC41ODIyIDAuMjQ4MDQ3Qzc5Ljk1MjIgMC4yNDgwNDcgODEuMDYyOCAxLjM1ODY1IDgxLjA2MjggMi43Mjg2NVoiIGZpbGw9InVybCgjcGFpbnQ2X2xpbmVhcl8xXzI1NTE3KSIvPgo8cGF0aCBkPSJNOTUuOTMyMSAzLjcyMDdMODcuNDk4IDEzLjg5MTJIOTEuNDY3VjI4LjI3ODdDOTEuNDY3IDMxLjA1NjkgOTQuMTEzIDMxLjkxNjkgOTUuNDM2IDMxLjk5OTZIMTAwLjg5M1YyOC4yNzg3SDk3LjE3MjRDOTYuMTgwMiAyOC4wODAyIDk1LjkzMjEgMjYuODczIDk1LjkzMjEgMjYuMjk0MlYxMy44OTEySDEwMS4xNDFWMTAuNDE4M0g5NS45MzIxVjMuNzIwN1oiIGZpbGw9InVybCgjcGFpbnQ3X2xpbmVhcl8xXzI1NTE3KSIvPgo8cGF0aCBkPSJNMTE5Ljc3NSAxMS4wMjIyVjE0LjI4NjVDMTE4LjUzNCAxMy41MDkzIDExNS4zMDcgMTIuMzI3OSAxMTIuMzI5IDEzLjgyMDJDMTA5LjM1IDE1LjMxMjQgMTExLjA4OCAxNy4wODQ0IDExMi4zMjkgMTcuNzgzOUMxMTQuMTkgMTguODMzMSAxMTguNDI1IDIwLjQ0MTkgMTE5LjU0MiAyMi42ODAyQzEyMC42NTkgMjQuOTE4NiAxMjAuMjQgMjcuMTEwMiAxMTkuNTQyIDI4LjI3NjFDMTE4LjE0NiAzMC42MDc3IDExNi4wNTIgMzEuNTQwMyAxMTMuMjU5IDMxLjU0MDNDMTEwLjQ2NyAzMS41NDAzIDEwNy43NTIgMzAuNDUyMiAxMDYuNTExIDI5LjkwODJWMjYuMTc3NkMxMDguOTMxIDI4LjA0MjkgMTEyLjMyOSAyOC4xOTg0IDExMy43MjUgMjguMDQyOUMxMTQuNjU2IDI3Ljk2NTIgMTE2Ljc1IDI3LjYyMzIgMTE2Ljc1IDI1Ljk0NDVDMTE2Ljc1IDIzLjg0NiAxMTQuNDIzIDIyLjQ0NzEgMTEzLjAyNyAyMS45ODA4QzExMC40NjcgMjEuMDQ4MSAxMDkuMzA0IDIwLjM0ODYgMTA3LjkwNyAxOS4xODI4QzEwNi41MTEgMTcuNTUwNyAxMDYuMjc5IDE3LjMxNzYgMTA2LjUxMSAxNC45ODZDMTA2LjY3OCAxMy4zMTU1IDEwOC42ODMgMTEuNjQ0IDEwOS43NjkgMTEuMDIyMkMxMTAuMzg5IDEwLjYzMzYgMTEyLjI4MiA5Ljg1NjQ1IDExNC44ODggOS44NTY0NUMxMTcuNDk0IDkuODU2NDUgMTE5LjIzMiAxMC42MzM2IDExOS43NzUgMTEuMDIyMloiIGZpbGw9InVybCgjcGFpbnQ4X2xpbmVhcl8xXzI1NTE3KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzFfMjU1MTciIHgxPSItMS45ODQ3NCIgeTE9IjQ5LjI3NDkiIHgyPSIxMzUuMDE4IiB5Mj0iNDkuMjc0OSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMzIyRUVEIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0U4MkJENSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfMV8yNTUxNyIgeDE9Ii0zLjk1NDI4IiB5MT0iMzEuNTM0MSIgeDI9IjEzMC4wOTIiIHkyPSIzMS41MzQxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMzMjJFRUQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRTgyQkQ1Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQyX2xpbmVhcl8xXzI1NTE3IiB4MT0iLTMuOTU0MjgiIHkxPSIzMS41MzQxIiB4Mj0iMTMwLjA5MiIgeTI9IjMxLjUzNDEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzMyMkVFRCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNFODJCRDUiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDNfbGluZWFyXzFfMjU1MTciIHgxPSItNS45MjUwOCIgeTE9IjMxLjc1MTciIHgyPSIxMjguMTIxIiB5Mj0iMzEuNzUxNyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMzIyRUVEIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0U4MkJENSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50NF9saW5lYXJfMV8yNTUxNyIgeDE9Ii03Ljg5ODUyIiB5MT0iMzEuOTk5NiIgeDI9IjEyOC4xMTkiIHkyPSIzMS45OTk2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMzMjJFRUQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRTgyQkQ1Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQ1X2xpbmVhcl8xXzI1NTE3IiB4MT0iLTkuODY5NzMiIHkxPSIyOS41NjI5IiB4Mj0iMTI2LjE0NyIgeTI9IjI5LjU2MjkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzMyMkVFRCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNFODJCRDUiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDZfbGluZWFyXzFfMjU1MTciIHgxPSItOS44Njk3MyIgeTE9IjI5LjU2MjkiIHgyPSIxMjYuMTQ3IiB5Mj0iMjkuNTYyOSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMzIyRUVEIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0U4MkJENSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50N19saW5lYXJfMV8yNTUxNyIgeDE9Ii0xMS44NDI4IiB5MT0iMzEuOTk5NiIgeDI9IjEyMy4xODkiIHkyPSIzMS45OTk2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMzMjJFRUQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRTgyQkQ1Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQ4X2xpbmVhcl8xXzI1NTE3IiB4MT0iOS43NjY0OSIgeTE9IjMxLjU0MDMiIHgyPSIxMTkuNzkiIHkyPSIzMS41NDAzIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMzMjJFRUQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRTgyQkQ1Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),

/***/ "+ZGw":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "+mX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPage_vue__ = __webpack_require__("qDxE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d1d7f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPage_vue__ = __webpack_require__("2z4K");
function injectStyle (ssrContext) {
  __webpack_require__("aSz4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d1d7f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/At2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBlogEdit_vue__ = __webpack_require__("iFST");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0947ff6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBlogEdit_vue__ = __webpack_require__("rR5P");
function injectStyle (ssrContext) {
  __webpack_require__("n8L9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBlogEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0947ff6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBlogEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/FyZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"portal-logo"},[_c('a',{attrs:{"href":_vm.post.post.url,"target":"_blank"}},[(_vm.post.post.host=='pornhub')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("pDV8"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='xhamster')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("gr0q"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='tumblr')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("bjyy"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='porndig')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("e8va"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='xnxx')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("Dz/r"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='xvideos')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("4xwk"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='hypnotube')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("duCX"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='motherless')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("TD3i"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='ashemaletube')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("4FT9"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='sex')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("+ZGw"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='sheshaft')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("f87d"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='eroprofile')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("KSwY"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='youjizz')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("9EQo"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='youtrannytube')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("Ty5W"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='fulltrannytube')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("bYy7"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='trannytube')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("wSez"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='spankwire')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("N26K"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='dirtyship')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("eWqp"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='nsfw247')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("UM4+"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='hotscope')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("06U2"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e(),_vm._v(" "),(_vm.post.post.host=='tiktits')?_c('img',{style:(_vm.styles),attrs:{"src":__webpack_require__("+UQR"),"title":_vm.altTitle,"alt":_vm.altTitle}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/G2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("cOjI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7fed25_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("vwIM");
function injectStyle (ssrContext) {
  __webpack_require__("OxFG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e7fed25"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7fed25_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/GO4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/bk7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HowToPostVideo_vue__ = __webpack_require__("rl1C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc05ab6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HowToPostVideo_vue__ = __webpack_require__("eRwP");
function injectStyle (ssrContext) {
  __webpack_require__("5rw8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cc05ab6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HowToPostVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc05ab6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HowToPostVideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/caE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FollowButton_vue__ = __webpack_require__("eUY4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56880ebd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FollowButton_vue__ = __webpack_require__("iXms");
function injectStyle (ssrContext) {
  __webpack_require__("+Gzs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FollowButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56880ebd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FollowButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/hU/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0+gm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "06U2":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "0Add":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogNavigation_vue__ = __webpack_require__("hNKH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff9080a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogNavigation_vue__ = __webpack_require__("dUH4");
function injectStyle (ssrContext) {
  __webpack_require__("F5WI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff9080a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff9080a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0DyY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ApiService__ = __webpack_require__("jZ0l");


/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        isPlaying: false,
        post: null
    },
    getters: {
        isPlaying: function isPlaying(state) {
            return state.isPlaying;
        },
        post: function post(state) {
            return state.post;
        }
    },
    mutations: {
        setPlay: function setPlay(state) {
            state.isPlaying = true;
        },
        setPause: function setPause(state) {
            state.isPlaying = false;
        },
        setPost: function setPost(state, post) {
            state.post = post;
        }
    }
});

/***/ }),

/***/ "0Zpd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.elementId}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('blog-avatar',{attrs:{"blog":_vm.blog,"w":150,"h":150}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('h3',[_vm._v(_vm._s(_vm.blog.title))]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.blog.totalPosts)+" Posts")]),_vm._v(" "),_c('h5',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showFollower()}}},[_vm._v(_vm._s(_vm._f("prettyInt")(_vm.blog.follower))+" Follower "),_c('fa-icon',{attrs:{"icon":_vm.displayFollower ? ['fal','chevron-up'] : ['fal','chevron-down']}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayFollower),expression:"displayFollower"}]},[_c('loading-indicator',{attrs:{"name":"user.getBlogFollower"}}),_vm._v(" "),_c('ul',{staticClass:"user-list"},_vm._l((_vm.follower),function(user){return _c('li',[_c('fa-icon',{attrs:{"icon":['fal', 'user']}}),_vm._v("\n            "+_vm._s(user.name)+"\n            "),_c('router-link',{attrs:{"to":{name:'MessageToUserFromBlog', params: {userId: user._id, blogUrl: _vm.blog.url}}}},[_c('fa-icon',{attrs:{"icon":['fal', 'comment']}})],1)],1)})),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-sm btn-outline-primary",class:{disabled: _vm.hasLessFollower},attrs:{"disabled":_vm.hasLessFollower},on:{"click":function($event){_vm.prevFollowerPage()}}},[_c('fa-icon',{attrs:{"icon":['fal', 'chevron-left']}}),_vm._v(" prev\n          ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-primary",class:{disabled: _vm.hasMoreFollower},attrs:{"disabled":_vm.hasMoreFollower},on:{"click":function($event){_vm.nextFollowerPage()}}},[_vm._v("\n            next "),_c('fa-icon',{attrs:{"icon":['fal', 'chevron-right']}})],1),_vm._v(" "),_c('hr')])],1),_vm._v(" "),(!_vm.isUserBlog)?_c('p',{staticClass:"options"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":_vm.getBlogUrl(_vm.blog)},on:{"click":function($event){$event.preventDefault();_vm.showBlog(_vm.blog)}}},[_c('icon',{attrs:{"icon":"external-link"}}),_vm._v("\n          view\n        ")],1),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{name: 'EditBlog', params:{blogUrl: _vm.blog.url}}}},[_c('icon',{attrs:{"icon":"pencil"}}),_vm._v("\n          edit\n        ")],1),_vm._v(" "),_c('a',{staticClass:"btn btn-danger",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteBlog()}}},[_c('icon',{attrs:{"icon":"trash-alt","scale":"1.5"}}),_vm._v("\n          delete")],1)],1):_vm._e()])]),_vm._v(" "),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0aoe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedbackWidget_vue__ = __webpack_require__("XfE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227464ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedbackWidget_vue__ = __webpack_require__("YVpa");
function injectStyle (ssrContext) {
  __webpack_require__("ZWoj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-227464ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedbackWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227464ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedbackWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0fKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBlogList_vue__ = __webpack_require__("iZtR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d84e44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBlogList_vue__ = __webpack_require__("rq0K");
function injectStyle (ssrContext) {
  __webpack_require__("plbk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBlogList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d84e44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBlogList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "12dL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchPage_vue__ = __webpack_require__("rYUc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25176b14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchPage_vue__ = __webpack_require__("xOaP");
function injectStyle (ssrContext) {
  __webpack_require__("YXHe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25176b14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2JoR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_BlogAvatar_vue__ = __webpack_require__("P0hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_LoadingIndicator__ = __webpack_require__("HToW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Top20",
  props: {
    target: {
      default: '_blank'
    }
  },
  data: function data() {
    return {
      isActive: false,
      topBlogs: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.isActive = true;

    this.$bus.$on('bloglist.exists', function (data) {
      if (_this.isActive) _this.$bus.$emit('blog-modal.listExists', _this.getNextPrevBlogs(data.currentBlog));
    });

    this.$api.getBlogTop20().then(function (res) {
      _this.topBlogs = res.data.blogs;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.isActive = false;
  },

  methods: {
    getBlogUrl: function getBlogUrl(blog) {
      return this.$router.resolve({ name: 'BlogPage', params: { blogUrl: blog.url } }).href;
    },
    showBlog: function showBlog(blog) {
      this.$bus.$emit('blog-modal.open', { blog: blog });
    },
    getNextPrevBlogs: function getNextPrevBlogs(current) {
      var last = null;
      var next = null;
      for (var i in this.topBlogs) {
        var b = this.topBlogs[i];
        if (b === current) {
          next = 1;
          continue;
        }
        if (next === 1) {
          next = b;
          break;
        }
        last = b;
      }
      if (next === 1) next = null;
      return {
        nextBlog: next,
        prevBlog: last
      };
    }
  },
  components: {
    LoadingIndicator: __WEBPACK_IMPORTED_MODULE_1__ui_LoadingIndicator__["a" /* default */],
    BlogAvatar: __WEBPACK_IMPORTED_MODULE_0__ui_BlogAvatar_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "2MWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentTypeSelector_vue__ = __webpack_require__("nglB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28b90048_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentTypeSelector_vue__ = __webpack_require__("ojbn");
function injectStyle (ssrContext) {
  __webpack_require__("r2zH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28b90048"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentTypeSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28b90048_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentTypeSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2m+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playerControls"},[_c('div',{staticClass:"panelCol"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.skip(-15)}}},[_c('icon',{attrs:{"icon":"backward"}})],1)]),_vm._v(" "),_c('div',{staticClass:"panelCol"},[_c('play-btn',{attrs:{"me":_vm.me,"post":_vm.post}})],1),_vm._v(" "),_c('div',{staticClass:"panelCol"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.skip(15)}}},[_c('icon',{attrs:{"icon":"forward"}})],1)]),_vm._v(" "),_c('div',{staticClass:"panelCol center"},[_c('progress-bar',{attrs:{"me":_vm.me,"post":_vm.post}})],1),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"panelCol"},[_c('volume-control',{attrs:{"me":_vm.me,"isMobile":_vm.isMobile}})],1):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"panelCol"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleFullScreen()}}},[_c('icon',{attrs:{"icon":"arrows-alt"}})],1)]):_vm._e(),_vm._v(" "),(_vm.canAirplay)?_c('div',{staticClass:"panelCol"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectAirplayDevice()}}},[_c('icon',{attrs:{"icon":"tv"}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2z4K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('blog-navigation',{attrs:{"blog":_vm.blog}}),_vm._v(" "),_c('blog-header',{attrs:{"blog":_vm.blog}}),_vm._v(" "),(_vm.init)?_c('posts',{attrs:{"blog":_vm.blog,"type":"blog"}}):_vm._e(),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"blog.getPosts"}}),_vm._v(" "),(_vm.noResults)?_c('p',{staticClass:"text-center"},[_vm._v("This blog has no posts yet. Please check back later.")]):_vm._e(),_vm._v(" "),_c('age-block',{attrs:{"accept-action":_vm.displayVideo}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "38dm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginForm_vue__ = __webpack_require__("w3EK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenterLogo_vue__ = __webpack_require__("mMEQ");
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'LoginPage',
    metaInfo: {
        title: 'Login',
        meta: [{ vmid: 'description', name: 'description', content: 'Login into your Pimblr Account' }, { vmid: 'title', name: 'title', content: 'Login' }]
    },
    data: function data() {
        return {};
    },
    created: function created() {
        if (this.$store.getters['user/isLoggedIn']) this.$router.push({ name: 'Dashboard' });
    },

    methods: {},
    components: {
        'login-form': __WEBPACK_IMPORTED_MODULE_0__LoginForm_vue__["a" /* default */],
        Logo: __WEBPACK_IMPORTED_MODULE_1__layout_CenterLogo_vue__["a" /* default */]
    }

});

/***/ }),

/***/ "3Ua5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3ajQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3pv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__ = __webpack_require__("xffA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd1ebf7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__ = __webpack_require__("vkcI");
function injectStyle (ssrContext) {
  __webpack_require__("Z7Wr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cd1ebf7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd1ebf7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3t5A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4AVz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('autocomplete-input',{attrs:{"placeholder":"Search","suggest-method":"searchSuggest"},on:{"input":_vm.search},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4FT9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "4J1n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4KJS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4bYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Startpage_vue__ = __webpack_require__("bBi1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad2bb02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Startpage_vue__ = __webpack_require__("xjOm");
function injectStyle (ssrContext) {
  __webpack_require__("3ajQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ad2bb02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Startpage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad2bb02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Startpage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4jD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        script: function script() {
            var str = "javascript:var pimblrShare = ";
            str += "window.open('";
            str += document.location.protocol + "//";
            str += document.location.host + "/share?b='+";
            str += "btoa(document.location.href)";
            str += ",'pimblrShare','width=600,height=680'";
            str += ");";
            return str;
        }
    }

    /**
     *
     * Instapaper Example
     * javascript:function%20iprl5(){var%20d=document,z=d.createElement('scr'+'ipt'),b=d.body,l=d.location;try{if(!b)throw(0);d.title='(Saving...)%20'+d.title;z.setAttribute('src',l.protocol+'//www.instapaper.com/j/VERYZ5TQuv4w?a=read-later&u='+encodeURIComponent(l.href)+'&t='+(new%20Date().getTime()));b.appendChild(z);}catch(e){alert('Please%20wait%20until%20the%20page%20has%20loaded.');}}iprl5();void(0)
     *
     */

});

/***/ }),

/***/ "4quB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPostPage_vue__ = __webpack_require__("Oiz6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f716d36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPostPage_vue__ = __webpack_require__("QR1H");
function injectStyle (ssrContext) {
  __webpack_require__("gVSD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f716d36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPostPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f716d36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPostPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4xwk":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "54SS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_BlogAvatar_vue__ = __webpack_require__("P0hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_buttons_FollowButton_vue__ = __webpack_require__("/caE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'BlogListItemSmall',
    props: ['blog'],
    data: function data() {
        return {};
    },
    created: function created() {},

    methods: {
        openBlog: function openBlog(blog) {
            this.$bus.$emit('blog-modal.open', { blog: blog });
        },
        getBlogUrl: function getBlogUrl(blog) {
            return this.$router.resolve({ name: 'BlogPage', params: { blogUrl: blog.url } }).href;
        }
    },
    components: {
        BlogAvatar: __WEBPACK_IMPORTED_MODULE_0__ui_BlogAvatar_vue__["a" /* default */],
        fButton: __WEBPACK_IMPORTED_MODULE_1__ui_buttons_FollowButton_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "573T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Fw7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_PortalLogo_vue__ = __webpack_require__("bKCy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_BlogAvatar_vue__ = __webpack_require__("P0hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Icon__ = __webpack_require__("/G2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_buttons_ReblogButton_vue__ = __webpack_require__("TI2p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_buttons_SharePostButton__ = __webpack_require__("HZK9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_buttons_LikePostButton__ = __webpack_require__("aSi7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PostListItem',
    props: ['post'],
    data: function data() {
        return {};
    },

    computed: {
        bgImage: function bgImage() {
            return "url('" + this.post.post.preview + "')";
        },
        isAdmin: function isAdmin() {
            var userId = this.$store.getters['user/id'];
            var found = this.post.blog.admins.find(function (item) {
                return userId == item;
            });
            return found ? true : false;
        }
    },
    created: function created() {},

    methods: {
        playVideo: function playVideo() {
            this.$bus.$emit('playVideo', this.post);
        },
        retweet: function retweet() {
            this.$bus.$emit('postToBlog', { post: this.post });
        },
        deletePost: function deletePost() {
            var _this = this;

            this.$swal({
                title: 'Delete this Post?',
                text: 'This post will not be displayed on your blog anymore',
                showCancelButton: true,
                type: 'warning',
                confirmButtonText: 'Yes, delete it!',
                confirmButtonColor: '#d618e7'
            }).then(function () {
                _this.$api.deletePost(_this.post._id).then(function (res) {
                    _this.$bus.$emit('post.deleted', _this.post);
                });
            });
        },
        getBlogUrl: function getBlogUrl(blog) {
            return this.$router.resolve({ name: 'BlogPage', params: { blogUrl: blog.url } }).href;
        },
        showBlog: function showBlog(blog) {
            if (this.$route.path != this.getBlogUrl(blog)) {
                this.$bus.$emit('blog-modal.open', { blog: blog });
            }
        },
        showPostInfo: function showPostInfo() {
            this.$bus.$emit('postInspector.show', { post: this.post, theme: 'light' });
        }
    },
    components: {
        LikePostButton: __WEBPACK_IMPORTED_MODULE_5__ui_buttons_LikePostButton__["a" /* default */],
        Icon: __WEBPACK_IMPORTED_MODULE_2__ui_Icon__["a" /* default */],
        BlogAvatar: __WEBPACK_IMPORTED_MODULE_1__ui_BlogAvatar_vue__["a" /* default */],
        PortalLogo: __WEBPACK_IMPORTED_MODULE_0__ui_PortalLogo_vue__["a" /* default */],
        ReblogBtn: __WEBPACK_IMPORTED_MODULE_3__ui_buttons_ReblogButton_vue__["a" /* default */],
        ShareBtn: __WEBPACK_IMPORTED_MODULE_4__ui_buttons_SharePostButton__["a" /* default */]
    }

});

/***/ }),

/***/ "5aRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_MessengerNavigation__ = __webpack_require__("B8S1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_CenteredCard__ = __webpack_require__("PP3G");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MessengerDetailPage",
  data: function data() {
    return {
      conversation: { _id: false },
      blog: {},
      messages: [],
      message: '',
      toUserId: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    var blogUrl = this.$route.params.blogUrl;
    var convId = this.$route.params.conversationId;
    var toUserId = this.$route.params.userId;

    if (blogUrl && toUserId) {
      this.toUserId = toUserId;
      this.$api.getConversationByUserIdAndBlogUrl(toUserId, blogUrl).then(function (res) {
        _this.initConversation(res.data);
      });
    }

    if (blogUrl && !toUserId) {
      this.$api.getConversationByBlogUrl(blogUrl).then(function (res) {
        _this.initConversation(res.data);
      });
    }

    if (convId) {
      this.$api.getConversationById(convId).then(function (res) {
        _this.initConversation(res.data);
      });
    }
  },

  sockets: {
    conversationCreated: function conversationCreated(data) {
      this.conversation = data.conversation;
    },
    receiveMessage: function receiveMessage(message) {
      if (this.conversation && this.conversation._id.toString() === message.conversation.toString()) {
        this.addMessage(message);
        message.token = this.$store.state.user.token;
        this.messageRead(message);
      }
    }
  },

  methods: {
    initConversation: function initConversation(convData) {
      var _this2 = this;

      this.blog = convData.blog;
      this.conversation = convData.conversation;
      this.messages = convData.messages.reverse();
      this.$nextTick(function () {
        _this2.scrollToBottom();
        _this2.$bus.$emit('messenger.reloadMessageCount');
      });
    },
    addMessage: function addMessage(msg) {
      this.messages.push(msg);
      this.scrollToBottom();
    },
    messageRead: function messageRead(msg) {
      this.$socket.emit('messageRead', msg);
    },
    sendMessage: function sendMessage() {
      if (this.message.length < 1) return;
      var msg = {
        token: this.$store.state.user.token,
        message: this.message,
        author: this.$store.getters['user/id']
      };

      if (this.conversation) {
        msg.conversationId = this.conversation._id;
      } else {
        msg.blogUrl = this.blog.url;
        if (this.toUserId) msg.toUserId = this.toUserId;
      }
      this.$socket.emit('sendMessage', msg);
      this.addMessage(msg);
      this.message = '';
    },
    amISender: function amISender(message) {
      var userId = this.$store.getters['user/id'];
      return message.author.toString() === userId.toString();
    },
    scrollToBottom: function scrollToBottom() {
      // Animate!
      this.$nextTick(function () {
        window.scrollTo(0, document.body.scrollHeight);
      });
    },
    getHeadline: function getHeadline() {
      var userId = this.$store.getters['user/id'];
      if (!this.conversation || !this.conversation.sender || !this.conversation.recipient) {
        return this.blog.title;
      }
      if (this.conversation.sender === userId || this.conversation.sender._id === userId) {
        return this.conversation.recipient.blog.title;
      } else {
        return this.conversation.sender.name + "@" + this.conversation.recipient.blog.title;
      }
    }
  },
  components: {
    CenteredCard: __WEBPACK_IMPORTED_MODULE_2__layout_CenteredCard__["a" /* default */],
    MainNavigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation__["a" /* default */],
    MessengerNavigation: __WEBPACK_IMPORTED_MODULE_1__layout_MessengerNavigation__["a" /* default */]
  }
});

/***/ }),

/***/ "5h9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-navigation'),_vm._v(" "),_c('centered-card',{attrs:{"headline":"Sync your tumblr-blogs"}},[_c('step-indicator',{attrs:{"steps":4,"step":_vm.currentStep}}),_vm._v(" "),(_vm.tumblrAuthUrl)?_c('div',[_c('h2',[_vm._v("1. connect with tumblr")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.tumblrAuthUrl}},[_vm._v("Login")])])]):_vm._e(),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"user.tumblr.getAuth"}}),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"user.tumblr.verifyAuth"}}),_vm._v(" "),(_vm.blogs.length)?_c('div',[_c('h2',[_vm._v("2. Select your tumblr-blogs")]),_vm._v(" "),_c('p',[_vm._v("Please select all the blogs, you want to import or sync.")]),_vm._v(" "),_c('transition-group',{attrs:{"name":"bloglist","tag":"div"}},_vm._l((_vm.blogList),function(blog){return _c('div',{key:blog.name,staticClass:"media blog",class:{selected:blog.selected},on:{"click":function($event){blog.selected=!blog.selected}}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.getBlogAvatar(blog),"alt":"Generic placeholder image"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(blog.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(blog.info))])])])})),_vm._v(" "),(!_vm.importing)?_c('div',{staticClass:"mt-3 text-center"},[_c('button',{staticClass:"btn btn-lg btn-outline-primary",on:{"click":function($event){_vm.startImport()}}},[_vm._v("Import selected Blogs")])]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"user.tumblr.getUserInfo"}}),_vm._v(" "),(_vm.importing)?_c('div'):_vm._e(),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"user.tumblr.import"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5l9X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/PimblrLogoLarge.c3dd702.png";

/***/ }),

/***/ "5rw8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5s5K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_CenteredCard__ = __webpack_require__("PP3G");
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AccountDeletedPage",
  components: { CenteredCard: __WEBPACK_IMPORTED_MODULE_0__layout_CenteredCard__["a" /* default */] }
});

/***/ }),

/***/ "66ng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgeBlock_vue__ = __webpack_require__("kihP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e72d9a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgeBlock_vue__ = __webpack_require__("JEpR");
function injectStyle (ssrContext) {
  __webpack_require__("Ai52")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e72d9a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgeBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e72d9a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgeBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "68jF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Icon__ = __webpack_require__("/G2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_BlogAvatar_vue__ = __webpack_require__("P0hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_LoadingIndicator__ = __webpack_require__("HToW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { LoadingIndicator: __WEBPACK_IMPORTED_MODULE_2__ui_LoadingIndicator__["a" /* default */], Icon: __WEBPACK_IMPORTED_MODULE_0__ui_Icon__["a" /* default */], BlogAvatar: __WEBPACK_IMPORTED_MODULE_1__ui_BlogAvatar_vue__["a" /* default */] },
  props: ['blog'],
  data: function data() {
    return {
      displayFollower: false,
      followerPage: 1,
      follower: [],
      followerPerPage: 25
    };
  },
  created: function created() {},

  computed: {
    isUserBlog: function isUserBlog() {
      return this.blog.url.indexOf('#') === 0;
    },
    elementId: function elementId() {
      return 'BlogItem-' + this.blog.url;
    },
    hasMoreFollower: function hasMoreFollower() {
      return this.follower.length !== this.followerPerPage;
    },
    hasLessFollower: function hasLessFollower() {
      return this.followerPage <= 1;
    }
  },
  methods: {
    getBlogUrl: function getBlogUrl(blog) {
      return this.$router.resolve({ name: 'BlogPage', params: { blogUrl: blog.url } }).href;
    },
    showBlog: function showBlog(blog) {
      if (this.$route.path !== this.getBlogUrl(blog)) {
        this.$bus.$emit('blog-modal.open', { blog: blog });
      }
    },
    deleteBlog: function deleteBlog() {
      var _this = this;

      this.$swal({
        title: 'Delete this Blog?',
        text: 'This Blog will never come back!',
        showCancelButton: true,
        type: 'warning',
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#d618e7'
      }).then(function () {
        _this.$api.deleteBlog(_this.blog).then(function (res) {
          _this.$bus.$emit('blog-deleted');
        });
      }, function (dismiss) {});
    },
    showFollower: function showFollower() {
      this.displayFollower = !this.displayFollower;
      if (this.displayFollower) {
        this.loadFollower();
      }
    },
    loadFollower: function loadFollower() {
      var _this2 = this;

      this.follower = [];
      this.$api.getUserBlogFollower(this.blog, this.followerPage).then(function (res) {
        _this2.follower = res.data.follower;
        _this2.followerPerPage = res.data.perPage;
      });
    },
    nextFollowerPage: function nextFollowerPage() {
      if (this.follower.length === this.followerPerPage) {
        this.followerPage++;
        this.loadFollower();
      }
    },
    prevFollowerPage: function prevFollowerPage() {
      if (this.followerPage > 1) {
        this.followerPage--;
        this.loadFollower();
      }
    }
  }
});

/***/ }),

/***/ "6MkG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('label',[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.blog.title),expression:"blog.title"}],staticClass:"form-control form-control-lg",attrs:{"type":"text"},domProps:{"value":(_vm.blog.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.blog, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('blog-avatar',{attrs:{"blog":_vm.blog,"w":150,"h":150}})],1)])]),_vm._v(" "),(_vm.edit && !_vm.isUserBlog)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("URL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.blog.url),expression:"blog.url"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.blog.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.blog, "url", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.blog.description),expression:"blog.description"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.blog.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.blog, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Content Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.blog.contentType),expression:"blog.contentType"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.blog, "contentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Straight")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Shemale")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Gay")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tags")]),_vm._v(" "),_c('input-tag',{staticClass:"form-control",attrs:{"tags":_vm.blog.tags,"on-change":_vm.setTags}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v(_vm._s(_vm.buttonLabel))]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{name:'MyBlogs'},"tag":"button"}},[_vm._v("Cancel")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6at5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_AvatarCreator__ = __webpack_require__("fn/m");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        blog: { type: Object },
        w: { type: Number },
        h: { type: Number }
    },
    data: function data() {
        return {
            cr: null,
            cache: null
        };
    },
    mounted: function mounted() {
        this.cr = new __WEBPACK_IMPORTED_MODULE_0__services_AvatarCreator__["a" /* default */](this.$refs['canvas']);
        if (this.blog._id) this.cr.render(this.blog._id);
    },

    watch: {
        blog: function blog(newBlog, oldBlog) {
            if (newBlog._id != oldBlog._id) {
                this.cr.render(this.blog._id);
            }
        }
    },
    methods: {
        render: function render(string) {
            this.cr.render(string);
        },
        openBlog: function openBlog(blog) {
            this.$bus.$emit('blog-modal.open', { blog: blog });
        },
        getBlogUrl: function getBlogUrl(blog) {
            return this.$router.resolve({ name: 'BlogPage', params: { blogUrl: blog.url } }).href;
        }
    }

});

/***/ }),

/***/ "6tKv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPwPage_vue__ = __webpack_require__("nDTj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4526d44e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPwPage_vue__ = __webpack_require__("9OGC");
function injectStyle (ssrContext) {
  __webpack_require__("4KJS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPwPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4526d44e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPwPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6xDh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-container"}},[_c('h1',[_vm._v("What is Pimplr?")]),_vm._v(" "),_c('p',[_vm._v("In short, Pimblr is like tumblr or twitter... but for porn videos only and more annonymous.")]),_vm._v(" "),_c('div',{staticClass:"icon-cont"},[_c('icon',{attrs:{"icon":"lightbulb","size":"5x"}})],1),_vm._v(" "),_c('h2',[_vm._v("A new way of watching porn")]),_vm._v(" "),_c('p',[_vm._v("The idea behind Pimblr is, that you do not have to search for porn anymore. You got it straight delivered to\n        your dashbord! Every day or every hour you will find new videos from blogs you like on your dashbord, so\n        just click play and enjoy!")]),_vm._v(" "),_c('div',{staticClass:"icon-cont"},[_c('icon',{attrs:{"icon":"question","size":"5x"}})],1),_vm._v(" "),_c('h2',[_vm._v("How does it work")]),_vm._v(" "),_c('p',[_vm._v("On Pimblr you can create and follow blogs. A Pimblr-blog is a collection of videos on a specific topic,\n        taste, fetish or whatever. So, if you find some blogs you like, you can follow them with only one click.\n        From there on, you will find the latest videos your favorite blogs postet, right on your dashboard.")]),_vm._v(" "),_c('div',{staticClass:"icon-cont"},[_c('icon',{attrs:{"icon":"list","size":"5x"}})],1),_vm._v(" "),_c('h2',[_vm._v("Blog as Playlist")]),_vm._v(" "),_c('p',[_vm._v("A Blog can also seen as a simple playlist. So your Dashboard is you personal Best-Of-Playlist! And unlike\n    a usual playlist, or a board in pinterest, a blog is always growing!")]),_vm._v(" "),_c('div',{staticClass:"icon-cont"},[_c('icon',{attrs:{"icon":"users","size":"5x"}})],1),_vm._v(" "),_c('h2',[_vm._v("Be part of our community")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',{staticClass:"mt-5"},[_vm._v("Start now!")]),_vm._v(" "),_c('div',{staticClass:"mt-4 text-center big-btns"},[_c('router-link',{staticClass:"btn btn-lg btn-outline-primary",attrs:{"to":{name:'Login'},"tag":"button"}},[_vm._v("Login")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-lg btn-outline-primary",attrs:{"to":{name:'Registration'},"tag":"button"}},[_vm._v("Register")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Contribute to our community is easy! You will get your first blog right with your registration, but it's\n        totally up to you to use it or not. You can also create new blogs with just a few clicks. You can fill ist\n        by just reblog videos you like, or by posting new videos from our supported sites, so far\n        "),_c('a',{attrs:{"href":"https://pornhub.com","target":"_blank"}},[_vm._v("PornHub")]),_vm._v(",\n        "),_c('a',{attrs:{"href":"https://xhamster.com","target":"_blank"}},[_vm._v("xHamster")]),_vm._v("\n        and "),_c('a',{attrs:{"href":"https://tumblr.com","target":"_blank"}},[_vm._v("tumblr")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7BDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-navigation'),_vm._v(" "),_c('followed-blogs')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7EuL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7KgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-sm-10 col-md-8"},_vm._l((_vm.topBlogs),function(blog,n){return _c('div',{staticClass:"row chart-item",on:{"click":function($event){$event.preventDefault();_vm.showBlog(blog)}}},[_c('div',{staticClass:"col-sm-4 col-md-3 col-left"},[_c('div',{staticClass:"chartnum"},[_vm._v("\n              "+_vm._s(n+1)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-9 col-right"},[_c('a',{attrs:{"href":_vm.getBlogUrl(blog)}},[_c('blog-avatar',{attrs:{"blog":blog,"w":600,"h":150}}),_vm._v(" "),_c('h5',{staticClass:"mt-2 mb-3 h3"},[_vm._v(_vm._s(blog.title))])],1)])])}))]),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"blog.top20"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7cS+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogListItemSmall_vue__ = __webpack_require__("54SS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90d470f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogListItemSmall_vue__ = __webpack_require__("Wa1g");
function injectStyle (ssrContext) {
  __webpack_require__("VC2g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90d470f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogListItemSmall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90d470f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogListItemSmall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "85GO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventBus__ = __webpack_require__("n2zA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Notification_vue__ = __webpack_require__("CALq");
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'NotificationCenter',
    data: function data() {
        return {
            notifications: [],
            displayTime: 5000,
            messengerMessagesCount: 0
        };
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* default */].$on('error', function (message) {
            _this.addNotification('error', message);
        });
        __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* default */].$on('success', function (message) {
            _this.addNotification('success', message);
        });
        __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* default */].$on('warning', function (message) {
            _this.addNotification('warning', message);
        });

        __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* default */].$on('user.login', function () {
            _this.loadMessengerMessageCount();
        });
        __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* default */].$on('messenger.reloadMessageCount', function () {
            _this.loadMessengerMessageCount();
        });
    },

    sockets: {
        receiveMessage: function receiveMessage(message) {

            if (this.$route.name !== 'MessengerDetail' && !this.$route.params.conversationId && this.$route.params.conversationId !== message.conversation) {
                this.messengerMessagesCount++;
                this.$store.commit('user/setUnreadMessages', this.messengerMessagesCount);
            }
        }
    },
    methods: {
        addNotification: function addNotification(type, message) {
            var _this2 = this;

            var note = { type: type, message: message };
            this.notifications.push(note);

            setTimeout(function () {
                _this2.notifications = _this2.notifications.filter(function (item) {
                    return item != note;
                });
            }, this.displayTime);
        },
        loadMessengerMessageCount: function loadMessengerMessageCount() {
            var _this3 = this;

            this.$api.getUnreadMessages().then(function (res) {
                _this3.messengerMessagesCount = res.data.unreadMessages;
                _this3.$store.commit('user/setUnreadMessages', _this3.messengerMessagesCount);
            });
        }
    },
    components: {
        notification: __WEBPACK_IMPORTED_MODULE_1__Notification_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "86n6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VolumeControl_vue__ = __webpack_require__("r5J+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16fc4974_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VolumeControl_vue__ = __webpack_require__("u2Iz");
function injectStyle (ssrContext) {
  __webpack_require__("7EuL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16fc4974"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VolumeControl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16fc4974_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VolumeControl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8bbl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('centered-card',[(!_vm.isLoggedIn)?_c('div',[_c('login')],1):_c('div',[_c('post-form',{attrs:{"savedMethod":_vm.afterSave}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9EQo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/youjizz.41d5bc3.png";

/***/ }),

/***/ "9MX5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blogs_BlogListItemSmall_vue__ = __webpack_require__("7cS+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_LoadingIndicator__ = __webpack_require__("HToW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_CenteredCard__ = __webpack_require__("PP3G");
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FollowedBlogs',
  metaInfo: {
    title: 'Blogs you are Following'
  },
  data: function data() {
    return {
      blogs: [],
      search: '',
      isActive: false
    };
  },

  computed: {
    filteredBlogs: function filteredBlogs() {
      var _this = this;

      if (this.search.length > 0) {
        return this.blogs.filter(function (blog) {
          return blog.title.toLowerCase().indexOf(_this.search.toLowerCase()) >= 0;
        });
      } else {
        return this.blogs;
      }
    },
    headline: function headline() {
      var str = 'Followed Blogs';
      var len = this.filteredBlogs.length;
      if (len > 0) str += " (" + len + ")";
      return str;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.isActive = true;

    this.$bus.$on('bloglist.exists', function (data) {
      if (_this2.isActive) _this2.$bus.$emit('blog-modal.listExists', _this2.getNextPrevBlogs(data.currentBlog));
    });

    this.$api.getUserFollowdBlogs().then(function (res) {
      _this2.blogs = res.data.blogs;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.isActive = false;
  },

  methods: {
    getNextPrevBlogs: function getNextPrevBlogs(current) {
      var last = null;
      var next = null;
      for (var i in this.filteredBlogs) {
        var b = this.filteredBlogs[i];
        if (b === current) {
          next = 1;
          continue;
        }
        if (next === 1) {
          next = b;
          break;
        }
        last = b;
      }
      if (next === 1) next = null;
      return {
        nextBlog: next,
        prevBlog: last
      };
    }
  },
  components: {
    CenteredCard: __WEBPACK_IMPORTED_MODULE_2__layout_CenteredCard__["a" /* default */],
    LoadingIndicator: __WEBPACK_IMPORTED_MODULE_1__ui_LoadingIndicator__["a" /* default */],
    Blog: __WEBPACK_IMPORTED_MODULE_0__blogs_BlogListItemSmall_vue__["a" /* default */]
  }

});

/***/ }),

/***/ "9NlZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchField_vue__ = __webpack_require__("i+8x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78baa694_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchField_vue__ = __webpack_require__("4AVz");
function injectStyle (ssrContext) {
  __webpack_require__("bX0x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78baa694_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9OGC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('logo'),_vm._v(" "),_c('centered-card',[(_vm.view=='form')?_c('div',[_c('h2',[_vm._v("Forgot your Password?")]),_vm._v(" "),_c('p',[_vm._v("Just enter you E-Mail below and reset your password.")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("E-Mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('indicator-button',{staticClass:"btn btn-primary",attrs:{"click":_vm.resetPassword,"is-loading":_vm.isLoading}},[_vm._v("Reset Password")])],1):_vm._e(),_vm._v(" "),(_vm.view=='requested')?_c('div',[_c('h2',[_vm._v("You've got Mail!")]),_vm._v(" "),_c('p',[_vm._v("Please check you mails, and maybe take a look into your spam-folder. Sometimes good mails go there...")])]):_vm._e(),_vm._v(" "),(_vm.view=='key')?_c('div',[_c('h2',[_vm._v("Resetting your password")]),_vm._v(" "),_c('p',[_vm._v("Please wait ...")])]):_vm._e(),_vm._v(" "),(_vm.view=='keysent')?_c('div',[_c('h2',[_vm._v("Your password was reset!")]),_vm._v(" "),_c('p',[_vm._v("Please check you mails, there you will find your new password.")])]):_vm._e(),_vm._v(" "),(_vm.view=='error')?_c('div',[_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('p',[_vm._v("Please contact our Support at: "),_c('a',{attrs:{"href":"mailto:feedback@pimblr.com?subject=Password Problems"}},[_vm._v("feedback@pimblr.com")])])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{name:'Login'}}},[_vm._v("Login")]),_vm._v(" | "),_c('router-link',{attrs:{"to":{name:'Registration'}}},[_vm._v("Register")])],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Q6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    data: function data() {
        return {};
    },
    created: function created() {},

    methods: {}
});

/***/ }),

/***/ "9g0r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9s7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_buttons_ReblogButton_vue__ = __webpack_require__("TI2p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_buttons_SharePostButton__ = __webpack_require__("HZK9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Icon__ = __webpack_require__("/G2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_LoadingIndicator_vue__ = __webpack_require__("HToW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ControlPanel_vue__ = __webpack_require__("Lx72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_PortalLogo_vue__ = __webpack_require__("bKCy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_BlogAvatar__ = __webpack_require__("P0hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PauseOverlay__ = __webpack_require__("Z5Ii");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_buttons_LikePostButton__ = __webpack_require__("aSi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TinyProgressBar__ = __webpack_require__("jgr8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_tools__ = __webpack_require__("vuR9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Player',
    data: function data() {
        return {
            isMobile: false,
            isMobileScreen: false,
            post: false,
            blog: false,
            video: false,
            show: false,
            videoUrl: '',
            showControls: true,
            canHideControls: true,
            hideControlsDelay: 3000,
            controlsTo: null,
            hasPlaylist: false,
            showPostTextInfo: true
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.isMobile = 'ontouchstart' in document.documentElement;
        this.isMobileScreen = __WEBPACK_IMPORTED_MODULE_10__services_tools__["a" /* default */].screenSize().width < 768;

        this.video = this.$refs['video'];
        document.getElementById('mainPlayer').onmousemove = this.showControlsAndStartTimer;

        if (this.isMobile) {
            document.getElementById('mainPlayer').ontouchstart = this.showControlsAndStartTimer;
        }

        this.$bus.$on('playVideo', function (post) {

            // TMP PORNHUB FIX
            //if(post.post.host==='pornhub'){
            //  this.$bus.$emit('error', "Sorry, we do have some problems supporting Pornhub videos. We are working hard to fix that.");

            //  setTimeout(()=>{
            //    if(post && this.show) this.$bus.$emit('playNextVideo', post);
            //    this.$bus.$emit('post.deleted', post);
            //  },2000);

            //  return;
            //}
            // TMP PORNHUB FIX

            _this.$bus.$emit('modal.open', 'player');
            _this.showPostTextInfo = false;
            _this.show = true;
            _this.showControls = true;
            _this.hasPlaylist = false;
            _this.$bus.$emit('hasPlaylist', function (hasPl) {
                _this.hasPlaylist = hasPl;
            });

            _this.$api.getVideoUrl(post.post._id).then(function (res) {
                _this.post = post;
                _this.blog = post.blog;
                _this.videoUrl = res.data.url;
                _this.showPostTextInfo = true;
                setTimeout(function () {
                    return _this.video.play();
                }, 10);
                _this.startControlsHideTime();

                var postUrl = _this.$router.resolve({ name: 'BlogPageVideo', params: { blogUrl: _this.post.blog.url, videoId: _this.post._id } });
                _this.$bus.$emit('track.click', {
                    path: postUrl.href,
                    title: 'Play Video'
                });
            }).catch(function () {
                _this.$bus.$emit('success', "I will skip it for you!");

                setTimeout(function () {
                    if (post && _this.show) _this.$bus.$emit('playNextVideo', post);
                    _this.$bus.$emit('post.deleted', post);
                    _this.$bus.$emit('track.click', {
                        path: '/postid/' + post.post._id,
                        title: 'Remove Deleted Video'
                    });
                }, 2000);
            });
        });
    },


    methods: {
        hide: function hide() {
            this.show = false;
            this.video.pause();
            this.videoUrl = '';
            this.$bus.$emit('modal.close', 'player');
            this.$bus.$emit('player.close');
        },
        reblog: function reblog(blog) {
            var _this2 = this;

            this.$api.reblog(blog.url, this.post._id).then(function (res) {
                _this2.$bus.$emit('success', 'Reblogged to ' + blog.title);
            }).catch(function (err) {});
        },
        prevVideo: function prevVideo() {
            this.$bus.$emit('playPrevVideo', this.post);
        },
        nextVideo: function nextVideo() {
            this.$bus.$emit('playNextVideo', this.post);
        },
        showControlsAndStartTimer: function showControlsAndStartTimer() {
            if (!this.showControls) this.showControls = true;
            this.startControlsHideTime();
        },
        startControlsHideTime: function startControlsHideTime() {
            var _this3 = this;

            if (this.controlsTo) clearInterval(this.controlsTo);
            this.controlsTo = setTimeout(function () {
                if (_this3.canHideControls) _this3.showControls = false;
            }, this.hideControlsDelay);
        },
        controlsOver: function controlsOver() {
            this.canHideControls = false;
            if (this.controlsTo) clearTimeout(this.controlsTo);
        },
        controlsOut: function controlsOut() {
            this.canHideControls = true;
        },
        getBlogUrl: function getBlogUrl(blog) {
            return this.$router.resolve({ name: 'BlogPage', params: { blogUrl: blog.url } }).href;
        },
        showBlog: function showBlog(blog) {
            this.hide();
            if (this.$route.path != this.getBlogUrl(blog)) {
                this.$bus.$emit('blog-modal.open', { blog: blog });
            }
        },
        showPostInfo: function showPostInfo() {
            this.$bus.$emit('postInspector.show', { post: this.post, theme: 'dark' });
        },


        // Give Feedback that somthing is happening and remove text, but keep ID etc.
        hidePostTextInfos: function hidePostTextInfos() {}
    },
    components: {
        TinyProgressBar: __WEBPACK_IMPORTED_MODULE_9__TinyProgressBar__["a" /* default */],
        LikePostButton: __WEBPACK_IMPORTED_MODULE_8__ui_buttons_LikePostButton__["a" /* default */],
        PauseOverlay: __WEBPACK_IMPORTED_MODULE_7__PauseOverlay__["a" /* default */],
        BlogAvatar: __WEBPACK_IMPORTED_MODULE_6__ui_BlogAvatar__["a" /* default */],
        LoadingIndicator: __WEBPACK_IMPORTED_MODULE_3__ui_LoadingIndicator_vue__["a" /* default */],
        ControlPanel: __WEBPACK_IMPORTED_MODULE_4__ControlPanel_vue__["a" /* default */],
        Icon: __WEBPACK_IMPORTED_MODULE_2__ui_Icon__["a" /* default */],
        ReblogBtn: __WEBPACK_IMPORTED_MODULE_0__ui_buttons_ReblogButton_vue__["a" /* default */],
        ShareBtn: __WEBPACK_IMPORTED_MODULE_1__ui_buttons_SharePostButton__["a" /* default */],
        PortalLogo: __WEBPACK_IMPORTED_MODULE_5__ui_PortalLogo_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "A6gN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AH4R":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGcAAAAbCAYAAABhoZFDAAAFiklEQVRoge2av27cRhDGf4uwSJd7g9BP4HORJk3oJ/DpCXzqEgSBpCaIK0kI4lZSGQSIKKRIqfMTHFOk9iFNmsChu5SsJZ8nxSx55N4uuXeSDV+QBQ633Jn9dvabneX+oXmFpEBKfFoAVYSeAAXweAPse08SlsyBDDD9etF4deYEOBZ4jKEYwvr1+PugPAGmwHGkbXUqgFP7v3GK6OCA3h3wzDZYMiC/v/rtlLQqHaFR0ddcJvAp6tAMddBJvJHrkl0grK9+X92OzHRLY5yULJFadYGNhB7CCvt/IXCJRlwFnLvmiE5nwelv1whbl21TR0tjoydZmreDYB75AiX/b+AMmAGlU79o19pVwqL1zXb4fSl5w1uvIIKwCp0K6wja9xu3e4Tdh35Ie6N3zhsT4ZxwkznqmKl9Z1UD+rtBmNmMXJ9u2K5492jk3I2wAl0gjDXf6J8AJepAFz+zv1yQsgU5BibAF63ofAHMMFQBS8Zi69CqI0juKkYSNgYm0sX7DZg5tq4wjafMt/BZpSmQirOY+vyHb1LblxGQJ7eeyNlwhL0O6B6jjss9uBlWLurAETo9Tqy8dsTIlh0De9JdTY6Aa0Ey+1xi92sCEwwHtBYlEYSNgEslR2A1C4wsYWfowudU7RvEa5VJx4ECTy0HJwCfPf86Fbi8McusVbVIbs0yAOhrKC58g3r+ETYC5ig5+6KLi5qYFDizhF0Dj6wsFa1TAXtonRpvjDp6DFyLZxPsIWwscG3z+xavatlXD5BDUVI7K1HXUWEnrecePv9yfMNybm05F3gBUv3x7MfFWuRsPCJa4T+g58OrHYPAI5DKGWElSv4cJeVQ4Nw6qsC/CFkAjwVeolGVoREasI0RelowA46k/d40Tb9ykBkaPVNgrvb6+hTjpEYysoNsAez9+eynzjs7uWU5DGTcsial6Ma0BOlsYGMcJXBgs870s5Y7RUl+guETlLD9HqdXwKloBD0BKXrsutZolf0B2yu0zRTIMJy474zNHAQgl0Dx13c/73nUSG7M203A3JySa7halfVHnYOQoaN8bbPqYBVWZ2x/D7zWmE57hZWMw70ANHqPXGkPD/sgL9G+n7u2d6fvQawM5IFHDEBya5bbhuRU4BANyZMggul1UEH7VCKsB7Cw832OTndBi22uRInLBghrtgCRDirRKXAKMpHWgmfdEgdrfQa6+OfbX4KnKMmNcae1QQeNgQOQKc30EjIujGWNvVrrwACWUNfx6ehT63mBOrSPsCJko4PVrn2BvnuegOT9djvtdUtzT9UmJTc0q7X5hiFZ2Hm6jDGuZxSutxd+x/Vhbazjw+88myDWwpalfW1G2F56zGxSEzmoF19HhuSMzp7jgyAsypHbOTuAZer3WT+aH99X2k1t51zhnf93jrAotFjC7qRn4vRCye5z/idsQ7yR/V/4hm7IAT7MjwK60I2cXSfMKdueMHca92Bm9n9x1/Z7nXPL8r9C2Lbtj3FugCNw683zC2lLexcybrnmPg7ogRM5/aDvlbAo3X5cmxsm7ECa7UCULRPRyCnRI50h/TWHDOnXaeuztZBuSP+uI+wd6k/QK4E8qL+6UrGHqgKt/V0fyX3WDDsHe3zzYRE2rL92BxXfcUezvs19iJ7HhXbsmejJ9Qg4pXVeF2gv7ZcPuQaSN2snBCGI90rYO6/Xkuf28Qw99cjRC75SDClK8lNWi4Aj7ActAcLLGs/KS9ShFRt+Sua9bHOMj3i6n3p+uVN/48+ootrPUeLO0GuJQw9yQevzsZ5+5Og1yhS9vKvTjI5zhiPHfDX6PRUdHcEvObckLLN4nuVm85XpgsA9kKfFMToCW3YOEl/XKTx6Hplg7cpY3aqWVqeMMNNtO7W2VnRXhE3b6cE8CPAvhpan9rl4u74AAAAASUVORK5CYII="

/***/ }),

/***/ "Ag/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__ = __webpack_require__("9s7U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6338ffa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__ = __webpack_require__("CSit");
function injectStyle (ssrContext) {
  __webpack_require__("wRPc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6338ffa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ai52":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ar/+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {};
  },

  computed: {
    messagesCount: function messagesCount() {
      return this.$store.getters['user/unreadMessages'];
    }
  }
});

/***/ }),

/***/ "AvC4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addPostform"},[(!_vm.submitted)?_c('div',[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"url"}},[_vm._v("Video URL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.url),expression:"url"}],staticClass:"form-control",class:{'is-invalid':_vm.errorMsg},attrs:{"id":"url","type":"url"},domProps:{"value":(_vm.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.url=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                    "+_vm._s(_vm.errorMsg)+" \n                ")])]),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"post.getVideoInfo"}}),_vm._v(" "),(_vm.preview)?_c('div',{staticClass:"preview"},[_c('post-button',{attrs:{"method":_vm.doPost,"isLoading":_vm.isLoading,"classes":'btn btn-primary btn-lg mb-4'}},[_vm._v("\n                    Post!\n                ")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.preview.title))]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":_vm.preview.preview}})])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('a',{staticClass:"help",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showHowTo()}}},[_vm._v("How to post a video on Pimblr?")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("We proudly support:")]),_vm._v(" "),_c('p',{staticClass:"logos"},[_c('a',{ref:"dirtyship",attrs:{"href":"https://dirtyship.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("eWqp"),"title":"DirtyShip","alt":"DirtyShip"}})]),_vm._v(" "),_c('a',{ref:"youjizz",staticStyle:{"background-color":"#000"},attrs:{"href":"https://www.youjizz.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("9EQo"),"title":"YouJizz","alt":"YouJizz"}})]),_vm._v(" "),_c('a',{ref:"nsfw247",attrs:{"href":"https://nsfw247.to","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("UM4+"),"title":"NSFW on Snap","alt":"NSFW on Snap"}})]),_vm._v(" "),_c('a',{ref:"hotscope",attrs:{"href":"https://hotscope.tv","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("06U2"),"title":"Hotscope","alt":"Hotscope"}})]),_vm._v(" "),_c('a',{ref:"tiktits",attrs:{"href":"https://tiktits.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("+UQR"),"title":"Tiktits","alt":"Tiktits"}})]),_vm._v(" "),_c('a',{ref:"hypnotube",attrs:{"href":"https://www.hypnotube.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("duCX"),"title":"hypnotube","alt":"hypnotube"}})]),_vm._v(" "),_c('a',{ref:"motherless",staticStyle:{"background-color":"#000"},attrs:{"href":"https://www.motherless.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("TD3i"),"title":"motherless","alt":"motherless"}})]),_vm._v(" "),_c('a',{ref:"ashemaletube",staticStyle:{"background-color":"#000"},attrs:{"href":"https://www.ashemaletube.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("4FT9"),"title":"A Shemale Tube","alt":"A Shemale Tube"}})]),_vm._v(" "),_c('a',{ref:"sexdotcom",attrs:{"href":"https://www.sex.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("+ZGw"),"title":"Sex.com","alt":"Sex.com"}})]),_vm._v(" "),_c('a',{ref:"sheshaft",staticStyle:{"background-color":"#2F333F"},attrs:{"href":"https://www.sheshaft.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("f87d"),"title":"SheShaft","alt":"SheShaft"}})]),_vm._v(" "),_c('a',{ref:"eroprofile",staticStyle:{"background-color":"#0069C6"},attrs:{"href":"https://www.eroprofile.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("KSwY"),"title":"EroProfile","alt":"EroProfile"}})]),_vm._v(" "),_c('a',{ref:"youtrannytube",staticStyle:{"background-color":"#2A2A2A"},attrs:{"href":"https://www.youtrannytube.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("Ty5W"),"title":"You Tranny Tube","alt":"You Tranny Tube"}})]),_vm._v(" "),_c('a',{ref:"fulltrannytube",attrs:{"href":"https://www.fulltrannytube.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("bYy7"),"title":"Full Tranny Tube","alt":"Full Tranny Tube"}})]),_vm._v(" "),_c('a',{ref:"trannytubetv",staticStyle:{"background-color":"rgb(28, 40, 49)"},attrs:{"href":"https://www.trannytube.tv","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("wSez"),"title":"Tranny Tube TV","alt":"Tranny Tube TV"}})])]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.missingPortal($event)}}},[_vm._v("Missig a portal?")])])]):_c('div',[_c('success-icon')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AwRe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B+YX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_input_tag__ = __webpack_require__("28+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_input_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_input_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_BlogAvatar_vue__ = __webpack_require__("P0hn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

    name: '',
    props: {
        edit: { default: false },
        blog: {
            default: function _default() {
                return {
                    title: '',
                    description: '',
                    tags: [],
                    contentType: 0,
                    url: ''
                };
            }
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        buttonLabel: function buttonLabel() {
            return this.edit ? 'Save' : 'Create Blog';
        },
        isUserBlog: function isUserBlog() {
            return this.blog.url ? this.blog.url.indexOf('u-') === 0 : false;
        }
    },
    created: function created() {},

    methods: {
        save: function save() {
            var _this = this;

            if (this.edit) {
                this.$api.updateBlog(this.blog).then(function (res) {
                    _this.$bus.$emit('success', 'Your Blog was updated!');
                    _this.$store.dispatch('user/updateBlogs');
                    _this.$router.push({ name: 'MyBlogs' });
                });
            } else {
                this.$api.createBlog(this.blog).then(function (res) {
                    _this.$bus.$emit('success', 'Your Blog was created!');
                    _this.$store.dispatch('user/updateBlogs');
                    _this.$router.push({ name: 'MyBlogs' });
                });
            }
        },
        setTags: function setTags(tags) {
            this.blog.tags = tags;
        }
    },
    components: {
        InputTag: __WEBPACK_IMPORTED_MODULE_0_vue_input_tag___default.a,
        BlogAvatar: __WEBPACK_IMPORTED_MODULE_1__ui_BlogAvatar_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "B8S1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessengerNavigation_vue__ = __webpack_require__("fxk8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513062be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessengerNavigation_vue__ = __webpack_require__("zhx7");
function injectStyle (ssrContext) {
  __webpack_require__("DtWa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-513062be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessengerNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513062be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessengerNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BWyb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BXxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DropDownHeader",
  props: {
    items: {
      type: Array,
      required: true,
      default: [{ key: '', label: 'No Items' }]
    },
    selected: Object,
    callback: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      isOpen: false,
      current: { key: '', label: 'No Items' }

    };
  },
  mounted: function mounted() {
    if (this.selected) {
      this.current = this.selected;
    } else {
      this.current = this.items[0];
    }
  },

  methods: {
    chooseItem: function chooseItem(item) {
      this.isOpen = false;
      this.current = item;
      this.callback(item);
    }
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */]
  }

});

/***/ }),

/***/ "C0Be":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("n7mN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3439b5b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("6xDh");
function injectStyle (ssrContext) {
  __webpack_require__("sP8o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3439b5b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3439b5b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CALq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__("dtaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4b5cb7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__("fAmf");
function injectStyle (ssrContext) {
  __webpack_require__("w/TQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4b5cb7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CScB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsConditions_vue__ = __webpack_require__("Yj4F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e8e48e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsConditions_vue__ = __webpack_require__("sjPv");
function injectStyle (ssrContext) {
  __webpack_require__("y2q9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35e8e48e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsConditions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e8e48e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsConditions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CSit":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"player"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"playerCont",attrs:{"id":"mainPlayer"}},[_c('video',{ref:"video",attrs:{"src":_vm.videoUrl,"playsinline":""}}),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"posts.getVideoUrl"}}),_vm._v(" "),_c('pause-overlay',{attrs:{"me":_vm.video}}),_vm._v(" "),_c('transition',{attrs:{"name":"down"}},[(_vm.showControls)?_c('div',{staticClass:"controls-cont",on:{"mouseenter":_vm.controlsOver,"mouseleave":_vm.controlsOut}},[_c('control-panel',{attrs:{"me":_vm.video,"post":_vm.post,"isMobile":_vm.isMobile}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"left"}},[(_vm.hasPlaylist && _vm.showControls)?_c('div',{staticClass:"left",on:{"mouseenter":_vm.controlsOver,"mouseleave":_vm.controlsOut}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.prevVideo()}}},[_c('icon',{attrs:{"icon":"chevron-left","size":"2x"}})],1)]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"right"}},[(_vm.hasPlaylist && _vm.showControls)?_c('div',{staticClass:"right",on:{"mouseenter":_vm.controlsOver,"mouseleave":_vm.controlsOut}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.nextVideo()}}},[_c('icon',{attrs:{"icon":"chevron-right","size":"2x"}})],1)]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"up"}},[(_vm.showControls)?_c('div',{staticClass:"top",on:{"mouseenter":_vm.controlsOver,"mouseleave":_vm.controlsOut}},[_c('div',{staticClass:"tbl"},[_c('div',{staticClass:"tbl-r"},[(_vm.post && _vm.showPostTextInfo)?_c('div',{staticClass:"tbl-c"},[_c('a',{attrs:{"href":_vm.getBlogUrl(_vm.post.blog)},on:{"click":function($event){$event.preventDefault();_vm.showBlog(_vm.post.blog)}}},[_c('blog-avatar',{attrs:{"blog":_vm.post.blog,"w":_vm.isMobileScreen ? 20 : 30,"h":_vm.isMobileScreen ? 20 : 30}}),_vm._v("\n                    "+_vm._s(_vm._f("maxlen")(_vm.blog.title,30))+"\n                  ")],1),_vm._v("\n                  via "),_c('portal-logo',{attrs:{"post":_vm.post,"mh":_vm.isMobileScreen ? '20px' : '30px'}}),_vm._v(" "),_c('span',{staticClass:"video-title d-none d-md-inline"},[_vm._v(_vm._s(_vm.post.post.title))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tbl-c actions"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showPostInfo($event)}}},[_c('icon',{attrs:{"icon":"comment","size":"2x"}})],1),_vm._v(" "),_c('share-btn',{attrs:{"post":_vm.post,"size":"2x"}}),_vm._v(" "),_c('like-post-button',{attrs:{"post":_vm.post,"size":"2x"}}),_vm._v(" "),_c('reblog-btn',{attrs:{"post":_vm.post,"size":"2x"}}),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.hide($event)}}},[_c('icon',{attrs:{"icon":"times","size":"2x"}})],1)],1)])]),_vm._v(" "),(_vm.post && _vm.showPostTextInfo)?_c('div',{staticClass:"video-title d-md-none"},[_vm._v(_vm._s(_vm._f("maxlen")(_vm.post.post.title,40)))]):_vm._e()]):_c('tiny-progress-bar',{attrs:{"me":_vm.video}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CU2C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__ = __webpack_require__("cxe5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f51b966_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__ = __webpack_require__("G/AJ");
function injectStyle (ssrContext) {
  __webpack_require__("zxC5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f51b966_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cszg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DBjL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DWZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogHeader_vue__ = __webpack_require__("vG5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b84f8e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogHeader_vue__ = __webpack_require__("S9Gm");
function injectStyle (ssrContext) {
  __webpack_require__("SFfW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b84f8e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b84f8e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DWzs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationCenter_vue__ = __webpack_require__("85GO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04e56d76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationCenter_vue__ = __webpack_require__("k79l");
function injectStyle (ssrContext) {
  __webpack_require__("xPNs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationCenter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04e56d76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationCenter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DdGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar fixed-top navbar-expand-lg navbar-light bg-light-tr"},[_c('div',{ref:"navContainer",staticClass:"container"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goHome()}}},[_c('img',{attrs:{"src":__webpack_require__("AH4R"),"alt":"Pimblr"}})]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler",attrs:{"type":"button"},on:{"click":function($event){_vm.toggleNav()}}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('div',{staticClass:" navbar-collapse d-none",attrs:{"id":"navbarSupportedContent"}},[_c('form',{staticClass:"form-inline mr-auto mt-2 mt-lg-0"},[_c('search-field')],1),_vm._v(" "),_c('ul',{staticClass:"navbar-nav my-2 my-lg-0"},[_vm._l((_vm.navigation),function(a){return _c(a.subs?'li':'router-link',{key:a.name,tag:"component",staticClass:"nav-item",class:{dropdown: a.subs, active: _vm.hasActiveSubs(a)},attrs:{"to":{name:a.name},"tag":"li","activeClass":"active"}},[(!a.component && !a.subs)?_c('a',{ref:'navtt-'+a.name,refInFor:true,staticClass:"nav-link",attrs:{"title":a.label}},[_c('fa-icon',{attrs:{"icon":a.icon,"size":_vm.iconSize}})],1):_vm._e(),_vm._v(" "),(!a.component && a.subs)?_c('a',{ref:'navtt-'+a.name,refInFor:true,staticClass:"nav-link",attrs:{"title":a.label,"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleDropdown(a.name)}}},[_c('fa-icon',{attrs:{"icon":a.icon,"size":_vm.iconSize}})],1):_vm._e(),_vm._v(" "),(!a.component && a.subs)?_c('div',{staticClass:"dropdown-menu dropdown-menu-right",class:{show: _vm.dropdowns[a.name]}},[_vm._l((a.subs),function(sub){return _c('a',{staticClass:"dropdown-item",class:{active: _vm.isActive(sub)},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.subnavClick(sub.name, a.name)}}},[_c('span',{staticClass:"icn"},[_c('fa-icon',{attrs:{"icon":sub.icon}})],1),_vm._v("\n                              "+_vm._s(sub.label)+"\n                          ")])}),_vm._v(" "),(a.name === 'TopProfile')?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),_vm._v(" "),(a.name === 'TopProfile')?_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.logout($event)}}},[_c('span',{staticClass:"icn"},[_c('fa-icon',{attrs:{"icon":['fal', 'power-off']}})],1),_vm._v("\n                            Logout\n                          ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(a.component)?_c(a.component,{ref:'navtt-'+a.name,refInFor:true,tag:"component"},[_c('fa-icon',{attrs:{"icon":a.icon,"size":_vm.iconSize}})],1):_vm._e()],1)}),_vm._v(" "),(!_vm.isLoggedIn)?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/login","tag":"li","activeClass":"active"}},[_c('a',{staticClass:"nav-link"},[_vm._v("Login")])]):_vm._e()],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DqrW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogModal_vue__ = __webpack_require__("tVTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8064e04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogModal_vue__ = __webpack_require__("S8UU");
function injectStyle (ssrContext) {
  __webpack_require__("Xq6F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8064e04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8064e04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DtWa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dz/r":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xnxx.ac9b5f0.png";

/***/ }),

/***/ "EC4z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"reloadIndicator",style:({opacity:_vm.refreshAlpha, transform: 'scale('+_vm.refreshAlpha+')'})},[(!_vm.isRefreshing)?_c('span',[_vm._v("refresh")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.posts),function(post){return _c('post-item',{key:post._id,attrs:{"post":post}})}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"indicator-container"},[_c('loading-indicator',{attrs:{"name":"posts.get"}}),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"likedposts.get"}})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EKBn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Top20_vue__ = __webpack_require__("2JoR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214810a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Top20_vue__ = __webpack_require__("7KgD");
function injectStyle (ssrContext) {
  __webpack_require__("sW+W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-214810a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Top20_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214810a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Top20_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EONg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('time', function (seconds) {
  var dt = new Date(null);
  var str = '';
  dt.setSeconds(seconds);
  var h = dt.getHours() - 1;
  var m = dt.getMinutes();
  var s = dt.getSeconds();
  if (h > 0) str += h + ":";
  str += m < 10 && h > 0 ? '0' + m : m;
  str += ':';
  str += s < 10 ? '0' + s : s;
  return str;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('maxlen', function (string, maxLength) {
  var str = string || '';
  if (str.length > maxLength) {
    str = str.substr(0, maxLength) + "...";
  }
  return str;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('prettyInt', function (number) {
  return number.toLocaleString();
});

/***/ }),

/***/ "Ew9K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'LikePostButton',
    props: {
        post: { default: Object },
        size: { type: String, default: '1x' }
    },
    data: function data() {
        return {
            isLoading: false,
            wasLiked: false
        };
    },


    computed: {
        isLoggedIn: function isLoggedIn() {
            return this.$store.getters['user/isLoggedIn'];
        }
    },
    mounted: function mounted() {
        if (this.post.wasLiked) this.wasLiked = this.post.wasLiked;
    },

    methods: {
        like: function like() {
            var _this = this;

            if (!this.isLoggedIn) {
                this.$bus.$emit('error', 'Please login for liking posts!');
                return;
            }

            this.isLoading = true;

            if (this.wasLiked) {
                this.$api.unLikePost(this.post).then(function (res) {
                    _this.isLoading = false;
                    _this.wasLiked = false;
                    _this.$bus.$emit('success', res.data.message);
                    _this.$bus.$emit('post.unliked', _this.post);
                }).catch(function (err) {
                    _this.isLoading = false;
                });
            } else {
                this.$api.likePost(this.post).then(function (res) {
                    _this.isLoading = false;
                    _this.wasLiked = true;
                    _this.$bus.$emit('success', res.data.message);
                }).catch(function (err) {
                    _this.isLoading = false;
                });
            }
        }
    },
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_0__ui_Icon__["a" /* default */]
    }
});

/***/ }),

/***/ "F5WI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FNVM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fj/C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FsqB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__ = __webpack_require__("38dm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f507b55a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__ = __webpack_require__("r9f/");
function injectStyle (ssrContext) {
  __webpack_require__("FNVM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f507b55a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G/AJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('logo'),_vm._v(" "),_c('centered-card',[_c('about')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GARA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_SearchField_vue__ = __webpack_require__("9NlZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_Navigation__ = __webpack_require__("csWb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tooltip_js__ = __webpack_require__("9yHG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'MainNavigation',
    data: function data() {
        return {
            navigation: __WEBPACK_IMPORTED_MODULE_2__store_Navigation__["a" /* default */].main,
            iconSize: '2x',
            dropdowns: {},
            tooltips: {}
        };
    },

    computed: {
        isLoggedIn: function isLoggedIn() {
            return this.$store.state.user.isLoggedIn;
        },
        followingBlogs: function followingBlogs() {
            return this.$store.state.user.follows.length;
        }
    },
    mounted: function mounted() {
        for (var ref in this.$refs) {
            if (ref.substr(0, 6) === 'navtt-') {
                var name = ref.substr(6);
                var el = this.$refs[ref][0] ? this.$refs[ref][0].$el || this.$refs[ref][0] : this.$refs[ref];
                this.tooltips[name] = new __WEBPACK_IMPORTED_MODULE_3_tooltip_js__["a" /* default */](el, {
                    title: el.title,
                    container: this.$refs.navContainer
                });
            }
        };
    },

    methods: {
        toggleNav: function toggleNav() {
            this.$bus.$emit('sidebar.toggle');
        },
        logout: function logout() {
            this.$store.commit('user/unsetToken');
            this.$router.push({ name: 'Login' });
        },
        goHome: function goHome() {
            if (this.isLoggedIn) {
                this.$router.push({ name: 'Dashboard' });
            } else {
                this.$router.push({ name: 'Startpage' });
            }
        },
        subnavClick: function subnavClick(routeName, dropDownName) {
            this.$router.push({ name: routeName });
            this.toggleDropdown(dropDownName);
        },
        toggleDropdown: function toggleDropdown(dropDownName) {
            if (this.dropdowns[dropDownName] === undefined) this.dropdowns[dropDownName] = false;
            this.$set(this.dropdowns, dropDownName, !this.dropdowns[dropDownName]);
            this.dropdowns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.dropdowns);
            if (this.tooltips[dropDownName]) this.tooltips[dropDownName].hide();
        },
        isActive: function isActive(sub) {
            return this.$route.name === sub.name;
        },
        hasActiveSubs: function hasActiveSubs(parent) {
            var _this = this;

            var hasActive = false;
            if (parent.subs) {
                parent.subs.forEach(function (sub) {
                    if (_this.$route.name === sub.name) hasActive = true;
                });
            }
            return hasActive;
        }
    },
    components: {
        SearchField: __WEBPACK_IMPORTED_MODULE_1__ui_SearchField_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "GB2F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogListItem_vue__ = __webpack_require__("VT9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_671c6210_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogListItem_vue__ = __webpack_require__("h5BD");
function injectStyle (ssrContext) {
  __webpack_require__("Ygsw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-671c6210"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_671c6210_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GJXK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},_vm._l((_vm.steps),function(s){return _c('div',{staticClass:"number-cont"},[_c('span',{staticClass:"number",class:{active: s <= _vm.step}},[_vm._v(_vm._s(s))]),_vm._v(" "),(s < _vm.steps)?_c('span',{staticClass:"divider",class:{active: s < _vm.step}}):_vm._e()])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gov8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("/G2m");
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "share-post-button",
    props: {
        post: { default: Object },
        size: { type: String, default: '1x' }
    },
    computed: {},

    methods: {
        showShareMenue: function showShareMenue() {
            this.$bus.$emit('openShareModal', { post: this.post });
        }
    },
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */]
    }
});

/***/ }),

/***/ "Gqr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MessengerNavigation',{attrs:{"title":_vm.getHeadline()}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"messages"},_vm._l((_vm.messages),function(msg){return _c('div',{staticClass:"message-cont",class:{isMine:_vm.amISender(msg)}},[_c('div',{staticClass:"message"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(msg.message))])])])}))])])]),_vm._v(" "),_c('div',{staticClass:"send-panel"},[_c('div',{staticClass:"container"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-row align-items-center"},[_c('div',{staticClass:"col-12 col-xs-11"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"d-xs-block d-sm-none mr-4"},[_vm._v(" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.message.length<1},on:{"click":function($event){$event.preventDefault();_vm.sendMessage($event)}}},[_vm._v("Send")])])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H0JP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountBadge_vue__ = __webpack_require__("Ar/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac59b62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountBadge_vue__ = __webpack_require__("IaXf");
function injectStyle (ssrContext) {
  __webpack_require__("VYvn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ac59b62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountBadge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac59b62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountBadge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H2CP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H5Er":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isSearching)?_c('h1',[_vm._v(_vm._s(_vm.headline))]):_c('div',[_c('drop-down-header',{attrs:{"items":_vm.categories,"callback":_vm.chooseCategory}})],1),_vm._v(" "),_vm._l((_vm.blogs),function(blog){return _c('blog-list-item',{key:blog._id,attrs:{"blog":blog}})}),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"blogs"}}),_vm._v(" "),(_vm.nothingFound)?_c('div',{staticClass:"text-center"},[_c('p',[_vm._v("Sorry... we found nothing for \""+_vm._s(_vm.searchQuery)+"\"")])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HCAz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainNavigation_vue__ = __webpack_require__("GARA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b276bcfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainNavigation_vue__ = __webpack_require__("DdGR");
function injectStyle (ssrContext) {
  __webpack_require__("YMdi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b276bcfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b276bcfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HLli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('logo'),_vm._v(" "),_c('reg-form')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HToW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingIndicator_vue__ = __webpack_require__("u/6j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5833a5df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingIndicator_vue__ = __webpack_require__("Y7jt");
function injectStyle (ssrContext) {
  __webpack_require__("almG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5833a5df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HZK9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharePostButton_vue__ = __webpack_require__("Gov8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364e84a7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharePostButton_vue__ = __webpack_require__("ecnS");
function injectStyle (ssrContext) {
  __webpack_require__("KFn4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-364e84a7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharePostButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364e84a7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharePostButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HcVt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hcs3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"loginForm"}},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',[_vm._v("Login")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Username/E-Mail"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.login()}}},[_vm._v("Login")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Not registered? "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("Create your Account now!")]),_vm._v(" | "),_c('router-link',{attrs:{"to":{name:'ForgotPassword'}}},[_vm._v("Forgot Password?")])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HgfD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareModal_vue__ = __webpack_require__("cZDQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cdd0d64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareModal_vue__ = __webpack_require__("vamd");
function injectStyle (ssrContext) {
  __webpack_require__("o/i9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cdd0d64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cdd0d64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I/Xl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I9D2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-navigation'),_vm._v(" "),_c('centered-card',{attrs:{"headline":"Create a new Blog"}},[_c('blog-form')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IPwU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"disabled":_vm.isLoading},on:{"click":function($event){$event.preventDefault();_vm.click($event)}}},[(_vm.isLoading)?_c('icon',{attrs:{"icon":"circle-notch","spin":""}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IaXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"title":"Messenger","href":"#"}},[_vm._t("default"),_vm._v(" "),(_vm.messagesCount>0)?_c('span',{staticClass:"badge badge-primary"},[_vm._v(_vm._s(_vm.messagesCount))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcMM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation'),_vm._v(" "),_c('h1',[_vm._v("The Top 20 Pimblr Blogs")]),_vm._v(" "),_c('top20',{attrs:{"target":"_self"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsPage_vue__ = __webpack_require__("Uhba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4343af47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsPage_vue__ = __webpack_require__("KzgA");
function injectStyle (ssrContext) {
  __webpack_require__("A6gN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4343af47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__("wMq3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__player__ = __webpack_require__("0DyY");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        waitForStore: false,
        redirectAfterStoreDone: null
    },
    modules: {
        user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
        player: __WEBPACK_IMPORTED_MODULE_3__player__["a" /* default */]
    }
}));

/***/ }),

/***/ "Il6S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ins1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"ProfileForm"}},[_c('form',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Username")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v(_vm._s(_vm.username))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("E-Mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",class:{error: _vm.mailCls},attrs:{"type":"text","placeholder":"E-Mail"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('i-button',{staticClass:"btn btn-primary",attrs:{"click":_vm.changeMail,"isLoading":_vm.mailLoading}},[_vm._v("Change E-Mail")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Change Password")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",class:{error: _vm.pwCls},attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Confirm new Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordConfirm),expression:"passwordConfirm"}],staticClass:"form-control",class:{error: _vm.pwcCls},attrs:{"type":"password","placeholder":"Confirm Password"},domProps:{"value":(_vm.passwordConfirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passwordConfirm=$event.target.value}}})]),_vm._v(" "),_c('i-button',{staticClass:"btn btn-primary",attrs:{"click":_vm.changePassword,"isLoading":_vm.pwLoading}},[_vm._v("Change Password")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Content Filter")]),_vm._v(" "),_c('content-type-selector',{attrs:{"types":_vm.contentTypes}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Delete Account")]),_vm._v(" "),_c('i-button',{staticClass:"btn btn-sm btn-danger",attrs:{"click":_vm.deleteAccount,"isLoading":_vm.deleteLoading}},[_vm._v("Delete your pimblr account")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Irel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('centered-card',{attrs:{"headline":"Your Account was deleted"}},[_c('h3',[_vm._v("Thanks for using pimblr!")]),_vm._v(" "),_c('p',[_vm._v("We hope, you enjoyed your stay and we will be very happy if you will return anytime.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JEpR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.accepted)?_c('div',[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-body text-center"},[_c('h3',[_vm._v("Welcome to")]),_vm._v(" "),_c('img',{staticClass:"logo",attrs:{"title":"Pimblr","src":__webpack_require__("5l9X")}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("\n                            To view this content and become"),_c('br'),_vm._v("part of our community you need to be at least"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("18 years old")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":"http://www.google.com"}},[_vm._v("I'm not yet 18")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.accept($event)}}},[_vm._v("I'm 18 or older")])])])])])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JbwS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationPage_vue__ = __webpack_require__("YNqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2729b206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationPage_vue__ = __webpack_require__("HLli");
function injectStyle (ssrContext) {
  __webpack_require__("n+nU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2729b206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jx+V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfilePage_vue__ = __webpack_require__("cEH5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dd47a5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfilePage_vue__ = __webpack_require__("hSle");
function injectStyle (ssrContext) {
  __webpack_require__("4J1n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfilePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dd47a5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfilePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KFn4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KQb1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__("PIBq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf5a029e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__("tAYt");
function injectStyle (ssrContext) {
  __webpack_require__("AwRe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf5a029e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf5a029e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KSwY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "KcKH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Top20__ = __webpack_require__("EKBn");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'BlogsCharts',
    metaInfo: {
        title: 'Top 20 Blogs'
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {},
    components: {
        Top20: __WEBPACK_IMPORTED_MODULE_1__Top20__["a" /* default */],
        Navigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "KzgA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('logo'),_vm._v(" "),_c('div',{staticClass:"container text-center"},[_c('a',{attrs:{"href":"/"},on:{"click":function($event){$event.preventDefault();_vm.back()}}},[_c('fa-icon',{attrs:{"icon":['fal', 'chevron-left']}}),_vm._v(" go back")],1)]),_vm._v(" "),_c('centered-card',[_c('terms-conditions'),_vm._v(" "),_c('a',{attrs:{"href":"/"},on:{"click":function($event){$event.preventDefault();_vm.back()}}},[_c('fa-icon',{attrs:{"icon":['fal', 'chevron-left']}}),_vm._v(" go back")],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LH+o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"PostToBlogBtn"}},[_c('indicator-button',{class:_vm.btnClasses,attrs:{"click":_vm.click,"isLoading":_vm.isLoading}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lx72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlPanel_vue__ = __webpack_require__("v+Dv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24dbbf26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlPanel_vue__ = __webpack_require__("2m+k");
function injectStyle (ssrContext) {
  __webpack_require__("9g0r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24dbbf26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M+Kk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropDownHeader_vue__ = __webpack_require__("BXxE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ca20b4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropDownHeader_vue__ = __webpack_require__("VdEt");
function injectStyle (ssrContext) {
  __webpack_require__("nDX3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ca20b4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropDownHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ca20b4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropDownHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db9a8f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("TqzE");
function injectStyle (ssrContext) {
  __webpack_require__("/GO4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db9a8f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MMKG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var portalBgs = {
    pornhub: '#000000',
    xvideos: '#000000',
    tumblr: 'rgb(54, 70, 93)',
    motherless: '#000000',
    ashemaletube: '#000000',
    sheshaft: 'rgb(47, 51, 63)',
    eroprofile: 'rgb(0, 105, 198)'
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    props: ['post', 'mh', 'usebg'],
    data: function data() {
        return {};
    },
    created: function created() {},

    computed: {
        styles: function styles() {
            var styles = [];
            if (this.mh) styles.push('max-height:' + this.mh);
            if (this.usebg && portalBgs[this.post.post.host]) {
                styles.push('background-color:' + portalBgs[this.post.post.host]);
                styles.push('padding: 4px');
            }
            return styles.join(';');
        },
        altTitle: function altTitle() {
            return "View " + this.post.post.title + " on " + this.post.post.host;
        }
    },
    methods: {
        getLogo: function getLogo() {
            switch (this.post.post.host) {
                case 'pornhub':
                    return '';
                case 'xhamster':
                    return '';
            }
        }
    }
});

/***/ }),

/***/ "McSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.togglePlay()}}},[(_vm.isPlaying)?_c('icon',{attrs:{"icon":"pause"}}):_c('icon',{attrs:{"icon":"play"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MoqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('centered-card',{attrs:{"headline":_vm.headline}},[_c('div',{staticClass:"mb-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"filter blogs"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"user.follows"}}),_vm._v(" "),_vm._l((_vm.filteredBlogs),function(blog){return _c('blog',{key:blog._id,attrs:{"blog":blog}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N1J+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__posts_PostList_vue__ = __webpack_require__("P8V4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_DropDownHeader__ = __webpack_require__("M+Kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_CenteredCard__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {
      dropdownItems: [{ key: 'dashboard', label: 'Dashboard' }, { key: 'likes', label: 'My Favorite Posts' }],
      listType: 'dashboard',
      noResults: null
    };
  },

  metaInfo: {
    title: 'Dashboard'
  },
  mounted: function mounted() {
    var _this = this;

    this.$bus.$on('postlist.noresults', function (data) {
      _this.noResults = data.type;
    });
  },

  methods: {
    changePostTypes: function changePostTypes(item) {
      this.noResults = null;
      this.listType = item.key;
    }
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4__ui_Icon__["a" /* default */],
    DropDownHeader: __WEBPACK_IMPORTED_MODULE_2__ui_DropDownHeader__["a" /* default */],
    Navigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__["a" /* default */],
    Posts: __WEBPACK_IMPORTED_MODULE_1__posts_PostList_vue__["a" /* default */],
    CenteredCard: __WEBPACK_IMPORTED_MODULE_3__layout_CenteredCard__["a" /* default */]
  }
});

/***/ }),

/***/ "N26K":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/spankwire.6b6cb37.png";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ApiService__ = __webpack_require__("jZ0l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_EventBus__ = __webpack_require__("n2zA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_VueFilters__ = __webpack_require__("EONg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_socket_io__ = __webpack_require__("HI0L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_socket_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_socket_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_sweetalert__ = __webpack_require__("f1Fh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_Icons__ = __webpack_require__("lfiD");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// Filters are directly applied to Vue Instance


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Prototypes
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$api = __WEBPACK_IMPORTED_MODULE_4__services_ApiService__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$bus = __WEBPACK_IMPORTED_MODULE_5__services_EventBus__["a" /* default */];

// Extensions

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(new __WEBPACK_IMPORTED_MODULE_7_vue_socket_io___default.a({
  debug: false,
  connection: "/"
}));


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_sweetalert___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('fa-icon', __WEBPACK_IMPORTED_MODULE_9__services_Icons__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NOnC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Oiz6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard_vue__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddPostForm_vue__ = __webpack_require__("bQLH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_ShareBookmarklet_vue__ = __webpack_require__("rkMl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AddPostPage',
    metaInfo: {
        title: 'Post a Video'
    },
    data: function data() {
        return {};
    },

    methods: {},
    components: {
        Navigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__["a" /* default */],
        CenteredCard: __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard_vue__["a" /* default */],
        PostForm: __WEBPACK_IMPORTED_MODULE_2__AddPostForm_vue__["a" /* default */],

        Favlet: __WEBPACK_IMPORTED_MODULE_3__ui_ShareBookmarklet_vue__["a" /* default */]

    }
});

/***/ }),

/***/ "OxFG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P0hn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogAvatar_vue__ = __webpack_require__("6at5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac31a772_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogAvatar_vue__ = __webpack_require__("Pk1B");
function injectStyle (ssrContext) {
  __webpack_require__("573T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogAvatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac31a772_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogAvatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P8V4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostList_vue__ = __webpack_require__("rAgH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d44e59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostList_vue__ = __webpack_require__("EC4z");
function injectStyle (ssrContext) {
  __webpack_require__("3Ua5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d44e59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PIBq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "modal",
    methods: {
        closeModal: function closeModal() {
            this.$bus.$emit('closeModal');
        }
    }
});

/***/ }),

/***/ "PP3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CenteredCard_vue__ = __webpack_require__("mbE9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99880c8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CenteredCard_vue__ = __webpack_require__("a7Cb");
function injectStyle (ssrContext) {
  __webpack_require__("jYnn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CenteredCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99880c8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CenteredCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PYfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_CenteredCard_vue__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenterLogo_vue__ = __webpack_require__("mMEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_LoginForm_vue__ = __webpack_require__("w3EK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__posts_AddPostForm_vue__ = __webpack_require__("bQLH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_ShareBookmarklet_vue__ = __webpack_require__("rkMl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    metaInfo: {
        title: 'Share on Pimblr'
    },
    data: function data() {
        return {};
    },

    computed: {
        isLoggedIn: function isLoggedIn() {
            return this.$store.getters['user/isLoggedIn'];
        }
    },
    methods: {
        afterSave: function afterSave() {
            window.close();
        }
    },
    components: {
        Login: __WEBPACK_IMPORTED_MODULE_2__user_LoginForm_vue__["a" /* default */],
        PostForm: __WEBPACK_IMPORTED_MODULE_3__posts_AddPostForm_vue__["a" /* default */],
        CenteredCard: __WEBPACK_IMPORTED_MODULE_0__layout_CenteredCard_vue__["a" /* default */],
        CenteresLogo: __WEBPACK_IMPORTED_MODULE_1__layout_CenterLogo_vue__["a" /* default */],
        Favlet: __WEBPACK_IMPORTED_MODULE_4__ui_ShareBookmarklet_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "Pk1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",staticClass:"blog-avatar img-fluid",attrs:{"width":_vm.w,"height":_vm.h,"title":_vm.blog.title},on:{"click":function($event){$event.preventDefault();_vm.openBlog(_vm.blog)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PwP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogForm_vue__ = __webpack_require__("B+YX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b81c019_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogForm_vue__ = __webpack_require__("6MkG");
function injectStyle (ssrContext) {
  __webpack_require__("s064")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b81c019_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QR1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AddPostPage"}},[_c('navigation'),_vm._v(" "),_c('centered-card',{attrs:{"headline":"Post a Video"}},[_c('post-form'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('favlet')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QYSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Icon: __WEBPACK_IMPORTED_MODULE_0__ui_Icon__["a" /* default */] },
    name: "pause-overlay",
    props: ['me'],
    computed: {
        showOverlay: function showOverlay() {
            return !this.$store.getters['player/isPlaying'];
        }
    },
    methods: {
        togglePlay: function togglePlay() {
            this.me.play();
        }
    }
});

/***/ }),

/***/ "QjH2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"reblogDialog"},[_c('a',{staticClass:"closeBtn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.hide()}}},[_c('icon',{attrs:{"icon":"times","size":"2x"}})],1),_vm._v(" "),_c('div',{staticClass:"container reblogCont"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-8 pb-4"},[_c('h2',[_vm._v("Reblog To:")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"dark-form",attrs:{"type":"text","placeholder":"filter blogs"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._l((_vm.selected),function(blog){return _c('div',{staticClass:"reblogBtn"},[_c('div',{staticClass:"media",on:{"click":function($event){$event.preventDefault();_vm.doPost(blog)}}},[_c('blog-avatar',{staticClass:"mr-3",attrs:{"blog":blog,"w":100,"h":100}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',{staticClass:"mt-0"},[_vm._v(_vm._s(blog.title))])])],1)])})],2)])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QvvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogsCharts_vue__ = __webpack_require__("KcKH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99c4754e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogsCharts_vue__ = __webpack_require__("IcMM");
function injectStyle (ssrContext) {
  __webpack_require__("lQ4r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogsCharts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99c4754e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogsCharts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R0wX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"mt-5"},[_vm._v("Use our Favlet")]),_vm._v(" "),_c('p',[_vm._v("\n        Drag this onto your Bookmark Bar => "),_c('a',{staticClass:"btn btn-outline- favlet",attrs:{"href":_vm.script}},[_vm._v("Post on Pimlblr")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        Easily post on Pimblr using our Favelet!"),_c('br'),_vm._v("\n        Just drag the link above onto your Bookmark Bar and share videos\n        with just two clicks.\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('img',{staticClass:"img-fluid rounded",attrs:{"src":__webpack_require__("SPwo")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5QS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-cookie-accept-decline',{attrs:{"elementId":"cookie-banner","position":"bottom-right","showPostponeButton":true,"debug":false},on:{"clicked-decline":_vm.decline}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rxpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IndicatorButton__ = __webpack_require__("mATz");
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { IndicatorButton: __WEBPACK_IMPORTED_MODULE_0__IndicatorButton__["a" /* default */] },
    props: {
        method: {},
        classes: {},
        isLoading: false

    },
    data: function data() {
        return {
            isOpen: false,
            isPosting: false
        };
    },

    computed: {
        btnClasses: function btnClasses() {
            var cls = '';
            if (this.blogs > 1) cls += 'dropdown-toggle ';
            cls += this.classes;
            return cls;
        },
        blogs: function blogs() {
            return this.$store.state.user.blogs;
        }
    },
    created: function created() {},

    methods: {
        click: function click(blog) {
            var _this = this;

            if (!this.blogs || this.blogs.length < 1) {
                this.$bus.$emit('error', "You don't have any Blogs yet!");
                return;
            }
            if (this.blogs.length > 1) {
                this.$bus.$emit('blogPicker', function (blog) {
                    _this.isPosting = true;
                    _this.method(blog, function (err) {
                        _this.isPosting = false;
                    });
                });
            } else {
                this.isPosting = true;
                this.method(this.blogs[0], function (err) {
                    _this.isPosting = false;
                });
            }
        }
    }
});

/***/ }),

/***/ "S3uB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'IndicatorButton',
    props: {
        isLoading: {
            default: false
        },
        click: {}
    },
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */]
    }

});

/***/ }),

/***/ "S4Eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_CenteredCard_vue__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_LoadingIndicator__ = __webpack_require__("HToW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_StepIndicator__ = __webpack_require__("nRmG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var storageDriver = localStorage;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    data: function data() {
        return {
            importing: false,
            tumblrAuthUrl: null,
            currentStep: 1,
            blogs: []
        };
    },

    computed: {
        blogList: function blogList() {
            if (this.importing) {
                return this.blogs.filter(function (blog) {
                    return blog.selected;
                });
            } else {
                return this.blogs;
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (this.$route.query.oauth_verifier) {
            var ov = this.$route.query.oauth_verifier;
            var ta = JSON.parse(storageDriver.getItem('tumblrAuth'));
            if (ta.token && ta.secret) {
                this.$api.tumblrVerifyAuth(ta.token, ta.secret, ov).then(function (res) {
                    _this.$store.commit('user/tumblrAuth', {
                        token: res.data.token,
                        secret: res.data.secret
                    });
                    storageDriver.removeItem('tumblrAuth');
                    _this.loadBlogs();
                    _this.currentStep = 2;
                });
            }
        } else {
            this.$api.tumblrGetAuth().then(function (res) {
                var auth = {
                    token: res.data.token,
                    secret: res.data.secret
                };
                _this.$store.commit('user/tumblrAuth', auth);
                storageDriver.setItem('tumblrAuth', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(auth));
                _this.tumblrAuthUrl = res.data.url;
            });
        }
    },

    methods: {
        loadBlogs: function loadBlogs() {
            var _this2 = this;

            var ta = this.$store.getters['user/tumblrAuth'];
            this.$api.tumblrUserInfo(ta.token, ta.secret).then(function (res) {
                var blogs = [];
                res.data.user.blogs.forEach(function (blog) {
                    blog.selected = false;
                    blog.importing = false;
                    blog.importDone = false;
                    blog.localBlog = '';
                    blog.error = '';
                    blog.info = '';
                    blog.importedPosts = 0;
                    blogs.push(blog);
                });
                _this2.blogs = blogs;
            });
        },
        startImport: function startImport() {
            this.importing = true;
            var selected = this.blogs.filter(function (blog) {
                return blog.selected;
            });

            if (selected.length < 1) {
                this.importing = false;
                this.$bus.$emit('error', 'Please select at least one blog!');
                return;
            }

            this.currentStep = 3;

            selected.forEach(function (b) {
                b.info = 'waiting...';
            });

            //this.blogs = selected;
            var ta = this.$store.getters['user/tumblrAuth'];

            this.importNextBlog();

            /*this.$api.tumblrImportBlogs(
                ta.token, ta.secret, selected
            ).then((res)=>{
                console.log()
            })
            */
        },
        importNextBlog: function importNextBlog() {
            var _this3 = this;

            var nextBlog = this.blogs.find(function (blog) {
                return blog.selected && !blog.importing && !blog.importDone;
            });
            if (nextBlog) {
                nextBlog.importing = true;
                nextBlog.info = 'importing...';
                var ta = this.$store.getters['user/tumblrAuth'];
                this.$api.tumblrSyncBlog(ta.token, ta.secret, nextBlog.name).then(function (res) {
                    nextBlog.importing = false;
                    nextBlog.importDone = true;
                    nextBlog.importedPosts = res.data.postCount;
                    nextBlog.info = 'Imported ' + res.data.postCount + ' Posts';
                    _this3.importNextBlog();
                }).catch(function (err) {
                    nextBlog.importing = false;
                    nextBlog.importDone = true;
                    nextBlog.error = err;
                    nextBlog.info = err;
                    _this3.importNextBlog();
                });
            } else {
                this.currentStep = 4;
            }
        },
        getBlogAvatar: function getBlogAvatar(blog) {
            return 'https://api.tumblr.com/v2/blog/' + blog.name + '/avatar/96';
        }
    },
    components: {
        LoadingIndicator: __WEBPACK_IMPORTED_MODULE_3__ui_LoadingIndicator__["a" /* default */],
        MainNavigation: __WEBPACK_IMPORTED_MODULE_1__layout_MainNavigation_vue__["a" /* default */],
        CenteredCard: __WEBPACK_IMPORTED_MODULE_2__layout_CenteredCard_vue__["a" /* default */],
        StepIndicator: __WEBPACK_IMPORTED_MODULE_4__ui_StepIndicator__["a" /* default */]
    }
});

/***/ }),

/***/ "S8UU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[(_vm.showModal)?_c('div',{attrs:{"id":"blog-modal"}},[_c('div',{ref:"scrollContainer",staticClass:"modal-inner"},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"tbl-t d-none d-sm-none d-md-table header-large"},[_c('div',{staticClass:"tbl-r"},[_c('div',{staticClass:"tbl-c"},[_c('blog-avatar',{staticClass:"d-none d-md-inline-block",attrs:{"blog":_vm.blog,"w":40,"h":40}}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("maxlen")(_vm.blog.title,35)))])],1),_vm._v(" "),_c('div',{staticClass:"tbl-c text-right"},[(_vm.hasBlogList)?_c('button',{staticClass:"btn btn-outline-primary",attrs:{"disabled":(_vm.prevBlog === null)},on:{"click":function($event){$event.preventDefault();_vm.loadPrev()}}},[_c('fa-icon',{attrs:{"icon":['fal','chevron-left']}})],1):_vm._e(),_vm._v(" "),_c('follow-button',{attrs:{"blog":_vm.blog}}),_vm._v(" "),(_vm.isLoggedIn)?_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.sendMessage($event)}}},[_c('fa-icon',{attrs:{"icon":['fal', 'comment']}}),_vm._v(" "),_c('span',{staticClass:"hidden-xs hidden-sm"},[_vm._v("Send Message")])],1):_vm._e(),_vm._v(" "),(_vm.hasBlogList)?_c('button',{staticClass:"btn btn-outline-primary",attrs:{"disabled":(_vm.nextBlog === null)},on:{"click":function($event){$event.preventDefault();_vm.loadNext()}}},[_c('fa-icon',{attrs:{"icon":['fal','chevron-right']}})],1):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn closeBtn",on:{"click":function($event){$event.preventDefault();_vm.closeModal($event)}}},[_c('icon',{attrs:{"icon":"times","size":"2x"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"d-md-none header-small"},[_c('div',{staticClass:"tbl-t"},[_c('div',{staticClass:"tbl-r"},[_c('div',{staticClass:"tbl-c"},[(_vm.hasBlogList)?_c('button',{staticClass:"btn btn-outline-primary",attrs:{"disabled":(_vm.prevBlog === null)},on:{"click":function($event){$event.preventDefault();_vm.loadPrev()}}},[_c('fa-icon',{attrs:{"icon":['fal','chevron-left']}})],1):_vm._e(),_vm._v(" "),_c('follow-button',{attrs:{"blog":_vm.blog}}),_vm._v(" "),(_vm.isLoggedIn)?_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.sendMessage($event)}}},[_c('fa-icon',{attrs:{"icon":['fal', 'comment']}})],1):_vm._e(),_vm._v(" "),(_vm.hasBlogList)?_c('button',{staticClass:"btn btn-outline-primary",attrs:{"disabled":(_vm.nextBlog === null)},on:{"click":function($event){$event.preventDefault();_vm.loadNext()}}},[_c('fa-icon',{attrs:{"icon":['fal','chevron-right']}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"tbl-c text-right"},[_c('button',{staticClass:"btn closeBtn",on:{"click":function($event){$event.preventDefault();_vm.closeModal($event)}}},[_c('icon',{attrs:{"icon":"times","size":"2x"}})],1)])])]),_vm._v(" "),_c('div',[_c('blog-avatar',{attrs:{"blog":_vm.blog,"w":40,"h":40}}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("maxlen")(_vm.blog.title,35)))])],1)])]),_vm._v(" "),(_vm.init)?_c('posts',{attrs:{"blog":_vm.blog,"attach-scroll-listener":_vm.$refs,"type":"blog"}}):_vm._e(),_vm._v(" "),(_vm.noResults)?_c('p',{staticClass:"text-center"},[_vm._v("This blog has no posts yet. Please check back later.")]):_vm._e(),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"blog.getPosts"}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S9Gm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BlogHeader"},[_c('blog-avatar',{attrs:{"blog":_vm.blog,"w":200,"h":200}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.blog.title))]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v(_vm._s(_vm.cleanDesc))]),_vm._v(" "),_c('p',[_c('follow-button',{attrs:{"blog":_vm.blog}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SFfW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SPwo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/favlet.5aa4c75.gif";

/***/ }),

/***/ "T2FU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiny-progressbar-cont"},[_c('div',{staticClass:"bar-cont"},[_c('div',{ref:"outer",staticClass:"prog-bar"},[_c('div',{staticClass:"bar bar-outer"},[_c('div',{ref:"progbar",staticClass:"bar bar-inner",style:({width: _vm.progressStr})})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T98I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_SearchField_vue__ = __webpack_require__("9NlZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_Navigation__ = __webpack_require__("csWb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    data: function data() {
        return {
            navigation: __WEBPACK_IMPORTED_MODULE_1__store_Navigation__["a" /* default */].main,
            isOpen: false
        };
    },

    computed: {
        isLoggedIn: function isLoggedIn() {
            return this.$store.state.user.isLoggedIn;
        }
    },
    created: function created() {
        var _this = this;

        this.$bus.$on('sidebar.toggle', function (str) {
            _this.toggle();
        });
        this.$bus.$on('sidebar.open', function (str) {
            _this.isOpen = true;
            document.body.classList.add('sidebar-open');
            _this.$bus.$emit('modal.open', 'sideNav');
        });
        this.$bus.$on('sidebar.close', function (str) {
            _this.isOpen = false;
            document.body.classList.remove('sidebar-open');
            _this.$bus.$emit('modal.close', 'sideNav');
        });
    },

    methods: {
        toggle: function toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },
        logout: function logout() {
            this.$store.commit('user/unsetToken');
            this.$router.push({ name: 'Login' });
            this.close();
        },
        open: function open() {
            this.$bus.$emit('sidebar.open');
        },
        close: function close() {
            this.$bus.$emit('sidebar.close');
        },
        closeByLink: function closeByLink() {
            setTimeout(this.close, 200);
        }
    },
    components: {
        SearchField: __WEBPACK_IMPORTED_MODULE_0__ui_SearchField_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "TCb9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogList_vue__ = __webpack_require__("cmyg");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'BlogsList',
    metaInfo: {
        title: 'Explore our Blogs'
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {},
    components: {
        Navigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__["a" /* default */],
        BlogList: __WEBPACK_IMPORTED_MODULE_1__BlogList_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "TD3i":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/motherless.43d69d8.png";

/***/ }),

/***/ "TI2p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReblogButton_vue__ = __webpack_require__("a9gA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45d74261_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReblogButton_vue__ = __webpack_require__("owhB");
function injectStyle (ssrContext) {
  __webpack_require__("Xi9u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45d74261"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReblogButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45d74261_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReblogButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TbET":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharePage_vue__ = __webpack_require__("PYfT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0178cba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharePage_vue__ = __webpack_require__("8bbl");
function injectStyle (ssrContext) {
  __webpack_require__("gd8T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0178cba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0178cba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TqzE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('notification-center'),_vm._v(" "),_c('div',{staticClass:"main"},[_c('router-view')],1),_vm._v(" "),_c('blog-modal'),_vm._v(" "),_c('side-nav'),_vm._v(" "),_c('player'),_vm._v(" "),_c('post-inspector'),_vm._v(" "),_c('share-modal'),_vm._v(" "),_c('blog-picker-dialog'),_vm._v(" "),_c('feedback'),_vm._v(" "),_c('how-to-post-video'),_vm._v(" "),_c('cooke-banner')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ty5W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/youtrannytube.c7cf5a7.png";

/***/ }),

/***/ "UAAa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UAOq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuccessIcon_vue__ = __webpack_require__("sxgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8626ac0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SuccessIcon_vue__ = __webpack_require__("YVbJ");
function injectStyle (ssrContext) {
  __webpack_require__("0+gm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuccessIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8626ac0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SuccessIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UFpK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie_accept_decline__ = __webpack_require__("gyeQ");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CookieBanner",
  methods: {
    decline: function decline() {
      _paq.push(['disableCookies']);
      _paq.push(['trackPageView']);
    }
  },
  components: {
    VueCookieAcceptDecline: __WEBPACK_IMPORTED_MODULE_0_vue_cookie_accept_decline__["a" /* default */]
  }
});

/***/ }),

/***/ "UM4+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "UN5Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autocomplete",class:{open: _vm.showList}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldVal),expression:"fieldVal"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.fieldVal)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.fieldVal=$event.target.value},_vm.updateValue],"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.hitEnter($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.preventDefault();_vm.hitDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.preventDefault();_vm.hitUp($event)}]}}),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu suggestions",class:{show: _vm.showList}},_vm._l((_vm.list),function(item, n){return _c('li',{staticClass:"dropdown-item",class:{active: _vm.subIsActive(n)},on:{"click":function($event){$event.preventDefault();_vm.clickItem(item)}}},[_vm._v("\n            "+_vm._s(item.label)+"\n        ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UNM3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_buttons_IndicatorButton_vue__ = __webpack_require__("mATz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_buttons_ContentTypeSelector__ = __webpack_require__("2MWY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RegistrationForm',
    data: function data() {
        return {
            email: '',
            username: '',
            password: '',
            passwordConfirm: '',
            mailCls: '',
            userCls: '',
            pwCls: '',
            pwcCls: '',
            mailLoading: false,
            pwLoading: false,
            deleteLoading: false,
            contentTypes: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$api.getUserInfo().then(function (res) {
            _this.username = res.data.user.name;
            _this.email = res.data.user.email;
            _this.contentTypes = res.data.user.contentTypes;
        });
    },

    methods: {
        changeMail: function changeMail() {
            var _this2 = this;

            this.mailLoading = true;
            this.$api.changeUserEmail(this.email).then(function (res) {
                _this2.$bus.$emit('success', 'The E-Mail address was saved!');
                _this2.mailLoading = false;
            }).catch(function () {
                return _this2.mailLoading = false;
            });
        },
        changePassword: function changePassword() {
            var _this3 = this;

            this.pwCls = false;
            this.pwcCls = false;
            var pwLen = this.password.length;
            if (pwLen < 6) {
                this.pwCls = true;
                this.$bus.$emit('error', 'Please enter a valid password with at least 6 chars');
                return false;
            }
            if (this.password !== this.passwordConfirm) {
                this.pwCls = true;
                this.pwcCls = true;
                this.$bus.$emit('error', 'The passwords do not match');
                return false;
            }

            this.pwLoading = true;
            this.$api.changeUserPassowrd(this.password).then(function (res) {
                _this3.pwLoading = false;
                _this3.password = '';
                _this3.passwordConfirm = '';
                _this3.$bus.$emit('success', res.data.message);
            }).catch(function () {
                return _this3.pwLoading = false;
            });
        },
        deleteAccount: function deleteAccount() {
            var _this4 = this;

            this.deleteLoading = true;
            var conf = confirm('Are you sure, you want to delete your pimblr account? All your blogs, all your posts will be deleted!');
            if (conf) {
                var pw = prompt('Please enter your password to delete your account:');
                this.$api.deleteUserAccount(this.$store.getters['user/id'], pw).then(function (res) {
                    console.log(res);
                    _this4.$store.commit('user/unsetToken');
                    _this4.$router.push({ name: 'AccountDeleted' });
                    _this4.deleteLoading = false;
                }).catch(function () {
                    _this4.deleteLoading = false;
                });
            } else {
                this.deleteLoading = false;
            }
        }
    },
    components: {
        ContentTypeSelector: __WEBPACK_IMPORTED_MODULE_1__ui_buttons_ContentTypeSelector__["a" /* default */],
        iButton: __WEBPACK_IMPORTED_MODULE_0__ui_buttons_IndicatorButton_vue__["a" /* default */]
    }

});

/***/ }),

/***/ "UVkV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_BlogAvatar__ = __webpack_require__("P0hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_LoadingIndicator__ = __webpack_require__("HToW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MessengerPage",
  data: function data() {
    return {
      conversations: [],
      isLoading: false
    };
  },
  mounted: function mounted() {
    this.loadConversations();
  },

  sockets: {
    receiveMessage: function receiveMessage(message) {
      this.loadConversations();
    }
  },
  methods: {
    loadConversations: function loadConversations() {
      var _this = this;

      this.isLoading = true;
      this.$api.getConversations().then(function (res) {
        _this.isLoading = false;
        _this.conversations = res.data.conversations;
      }).catch(function (err) {
        _this.isLoading = false;
      });
    },
    amISender: function amISender(conversation) {
      var userId = this.$store.getters['user/id'];
      return conversation.sender._id === userId;
    }
  },
  components: {
    LoadingIndicator: __WEBPACK_IMPORTED_MODULE_3__ui_LoadingIndicator__["a" /* default */],
    BlogAvatar: __WEBPACK_IMPORTED_MODULE_2__ui_BlogAvatar__["a" /* default */],
    CenteredCard: __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard__["a" /* default */],
    MainNavigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation__["a" /* default */]
  }
});

/***/ }),

/***/ "UdPy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessengerPage_vue__ = __webpack_require__("UVkV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f4c517_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessengerPage_vue__ = __webpack_require__("YU9J");
function injectStyle (ssrContext) {
  __webpack_require__("HcVt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72f4c517"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessengerPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f4c517_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessengerPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uhba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_CenterLogo_vue__ = __webpack_require__("mMEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_TermsConditions__ = __webpack_require__("CScB");
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TermsPage',
    data: function data() {
        return {};
    },


    methods: {
        back: function back() {
            window.history.back();
        }
    },
    components: {
        TermsConditions: __WEBPACK_IMPORTED_MODULE_2__layout_TermsConditions__["a" /* default */],
        CenteredCard: __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard__["a" /* default */],
        Logo: __WEBPACK_IMPORTED_MODULE_0__layout_CenterLogo_vue__["a" /* default */]
    }

});

/***/ }),

/***/ "UtSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationForm_vue__ = __webpack_require__("n51x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5526a29c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationForm_vue__ = __webpack_require__("w3pE");
function injectStyle (ssrContext) {
  __webpack_require__("vj8g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5526a29c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uum2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayBtn_vue__ = __webpack_require__("v1Wd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6188914e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlayBtn_vue__ = __webpack_require__("McSy");
function injectStyle (ssrContext) {
  __webpack_require__("NOnC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayBtn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6188914e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlayBtn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VC2g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VH7W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'LoginForm',
    props: ['redirect'],
    data: function data() {
        return {
            username: '',
            password: ''
        };
    },
    created: function created() {},

    methods: {
        login: function login() {
            var _this = this;

            this.$api.login(this.username, this.password).then(function (res) {
                return _this.$store.dispatch('user/init', res.data.token);
            }).then(function (res) {
                _this.$bus.$emit('success', 'Logged in!');
                if (_this.redirect) _this.$router.push({ name: _this.redirect });
            });
        }
    },
    components: {}

});

/***/ }),

/***/ "VT9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_BlogAvatar_vue__ = __webpack_require__("P0hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_buttons_FollowButton_vue__ = __webpack_require__("/caE");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    props: ['blog'],
    data: function data() {
        return {};
    },

    computed: {
        posts: function posts() {
            var _this = this;

            if (!this.blog.posts) return [];
            var posts = this.blog.posts.map(function (postRaw) {
                var post = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postRaw));
                post.blog = _this.blog;
                return post;
            });
            return posts;
        }
    },
    methods: {
        bgImage: function bgImage(img) {
            return "url('" + img + "')";
        },
        playPost: function playPost(post) {
            this.$bus.$emit('playVideo', post);
        },
        openBlog: function openBlog(blog) {
            this.$bus.$emit('blog-modal.open', { blog: blog });
        },
        getBlogUrl: function getBlogUrl(blog) {
            return this.$router.resolve({ name: 'BlogPage', params: { blogUrl: blog.url } }).href;
        }
    },
    components: {
        BlogAvatar: __WEBPACK_IMPORTED_MODULE_1__ui_BlogAvatar_vue__["a" /* default */],
        FollowButton: __WEBPACK_IMPORTED_MODULE_2__ui_buttons_FollowButton_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "VYvn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VdEt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dd"},[_c('a',{staticClass:"dd-toggle h1",on:{"click":function($event){$event.preventDefault();_vm.isOpen=!_vm.isOpen}}},[_vm._v(_vm._s(_vm.current.label)+" "),_c('icon',{attrs:{"icon":"chevron-down"}})],1),_vm._v(" "),_c('div',{staticClass:"dd-outer"},[(_vm.isOpen)?_c('div',{staticClass:"dd-menu shadow-lg"},_vm._l((_vm.items),function(item){return _c('a',{key:item.key,staticClass:"dd-item h1",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.chooseItem(item)}}},[_vm._v(_vm._s(item.label))])})):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ven1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBlogsListPage_vue__ = __webpack_require__("m84K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716190f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBlogsListPage_vue__ = __webpack_require__("W9PO");
function injectStyle (ssrContext) {
  __webpack_require__("BWyb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBlogsListPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716190f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBlogsListPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VsM4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard_vue__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogForm_vue__ = __webpack_require__("PwP5");
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    metaInfo: {
        title: 'Create a new Blog'
    },
    data: function data() {
        return {};
    },
    created: function created() {},

    methods: {},
    components: {
        MainNavigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__["a" /* default */],
        CenteredCard: __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard_vue__["a" /* default */],
        BlogForm: __WEBPACK_IMPORTED_MODULE_2__BlogForm_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "Vylj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'StepIndicator',
    props: {
        steps: { default: 3 },
        step: { default: 1 }
    },
    data: function data() {
        return {};
    },
    created: function created() {},

    methods: {}
});

/***/ }),

/***/ "W9PO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-navigation'),_vm._v(" "),_c('blog-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wa1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"media blogItem"},[_c('blog-avatar',{staticClass:"mr-3",attrs:{"w":64,"h":64,"blog":_vm.blog}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',{staticClass:"mt-0"},[_c('a',{attrs:{"href":_vm.getBlogUrl(_vm.blog)},on:{"click":function($event){$event.preventDefault();_vm.openBlog(_vm.blog)}}},[_vm._v(_vm._s(_vm.blog.title))])]),_vm._v(" "),_c('f-button',{attrs:{"blog":_vm.blog}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XfE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Icon__ = __webpack_require__("/G2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_buttons_IndicatorButton__ = __webpack_require__("mATz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    data: function data() {
        return {
            show: false,
            loading: false,
            starsOver: 0,
            formData: {
                name: '',
                email: '',
                subject: '',
                message: '',
                stars: 0
            }

        };
    },

    computed: {
        modalStyle: function modalStyle() {
            return this.show ? 'display: block' : '';
        },
        isLoggedIn: function isLoggedIn() {
            return this.$store.state.user.isLoggedIn;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$bus.$on('feedback.open', function (message) {
            if (message) _this.formData.message = message;
            _this.showForm();
        });
    },

    methods: {
        setStars: function setStars(num) {
            this.formData.stars = num;
        },
        starActive: function starActive(i) {
            return i <= this.formData.stars;
        },
        starOver: function starOver(i) {
            return i <= this.starsOver;
        },
        setStarOver: function setStarOver(i) {
            this.starsOver = i;
        },
        setStarOut: function setStarOut(i) {
            this.starsOver = 0;
        },
        showForm: function showForm() {
            this.show = true;
            this.$bus.$emit('modal.open', 'defaultModal');
        },
        hideForm: function hideForm() {
            this.show = false;
            this.$bus.$emit('modal.close', 'defaultModal');
            this.formData = {
                name: '',
                email: '',
                subject: '',
                message: '',
                stars: 0
            };
        },
        sendForm: function sendForm() {
            var _this2 = this;

            this.loading = true;

            this.$api.sendFeedback(this.formData).catch(function (err) {
                _this2.loading = false;
            }).then(function () {
                _this2.$bus.$emit('success', 'Thank you! Your message was sent!');
                _this2.loading = false;
                _this2.hideForm();
            });
        }
    },
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_0__ui_Icon__["a" /* default */],
        IndicatorButton: __WEBPACK_IMPORTED_MODULE_1__ui_buttons_IndicatorButton__["a" /* default */]
    }
});

/***/ }),

/***/ "Xi9u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xq6F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y7jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"loadingIndicator"},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"rect1"}),_vm._v(" "),_c('div',{staticClass:"rect2"}),_vm._v(" "),_c('div',{staticClass:"rect3"}),_vm._v(" "),_c('div',{staticClass:"rect4"}),_vm._v(" "),_c('div',{staticClass:"rect5"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YG6y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YMdi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YNeV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostInspector_vue__ = __webpack_require__("bl7L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_044be468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostInspector_vue__ = __webpack_require__("y3vI");
function injectStyle (ssrContext) {
  __webpack_require__("qsa0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-044be468"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostInspector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_044be468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostInspector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YNqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RegistrationForm_vue__ = __webpack_require__("UtSo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenterLogo_vue__ = __webpack_require__("mMEQ");
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RegistrationPage',
    metaInfo: {
        title: 'Registration',
        meta: [{ vmid: 'description', name: 'description', content: 'Register your free Pimblr Account here!' }, { vmid: 'title', name: 'title', content: 'Registration' }]
    },
    data: function data() {
        return {};
    },
    created: function created() {
        if (this.$store.getters['user/isLoggedIn']) this.$router.push({ name: 'Dashboard' });
    },

    methods: {},
    components: {
        'reg-form': __WEBPACK_IMPORTED_MODULE_0__RegistrationForm_vue__["a" /* default */],
        Logo: __WEBPACK_IMPORTED_MODULE_1__layout_CenterLogo_vue__["a" /* default */]
    }

});

/***/ }),

/***/ "YU9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainNavigation'),_vm._v(" "),_c('centered-card',{attrs:{"headline":"Messenger"}},[_c('div',{staticClass:"container"},[(_vm.conversations.length<1 && !_vm.isLoading)?_c('div',[_c('h4',[_vm._v("You do not have any messages yet.")]),_vm._v(" "),_c('p',[_vm._v("If you would like to start a chat, just visit a blog and click on \"Send Message\" on the upper right.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.conversations),function(conversation){return _c('router-link',{key:conversation._id,staticClass:"conversation",attrs:{"tag":"div","to":{name:'MessengerDetail', params:{conversationId: conversation._id}}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('blog-avatar',{attrs:{"blog":conversation.recipient.blog,"w":100,"h":100}})],1),_vm._v(" "),_c('div',{staticClass:"col-8"},[(_vm.amISender(conversation))?_c('div',[_c('h4',[_vm._v(_vm._s(conversation.recipient.blog.title))])]):_c('div',[_c('h4',[_vm._v(_vm._s(conversation.sender.name)+"@"+_vm._s(conversation.recipient.blog.title))])])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[(conversation.newMessages && conversation.newMessages>0)?_c('span',{staticClass:"badge badge-primary"},[_vm._v("\n                            "+_vm._s(conversation.newMessages)+"\n                        ")]):_vm._e()])])])}),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"messenger.getConversations"}})],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YVbJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"swal2-icon swal2-success swal2-animate-success-icon",staticStyle:{"display":"block"}},[_c('div',{staticClass:"swal2-success-circular-line-left",staticStyle:{"background-color":"rgb(255, 255, 255)","background-position":"initial initial","background-repeat":"initial initial"}}),_vm._v(" "),_c('span',{staticClass:"swal2-success-line-tip swal2-animate-success-line-tip"}),_vm._v(" "),_c('span',{staticClass:"swal2-success-line-long swal2-animate-success-line-long"}),_vm._v(" "),_c('div',{staticClass:"swal2-success-ring"}),_vm._v(" "),_c('div',{staticClass:"swal2-success-fix",staticStyle:{"background-color":"rgb(255, 255, 255)","background-position":"initial initial","background-repeat":"initial initial"}}),_vm._v(" "),_c('div',{staticClass:"swal2-success-circular-line-right",staticStyle:{"background-color":"rgb(255, 255, 255)","background-position":"initial initial","background-repeat":"initial initial"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YVpa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"commentsBtn"}},[(_vm.isLoggedIn)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showForm($event)}}},[_c('icon',{attrs:{"icon":"comments","size":"2x"}})],1):_c('a',{attrs:{"href":"mailto:feedback@pimblr.com","title":"feedback@pimblr.com"}},[_c('icon',{attrs:{"icon":"comments","size":"2x"}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal fade",class:{show: _vm.show},style:(_vm.modalStyle),attrs:{"id":"feedbackModal","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Give us some Feedback!")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){$event.preventDefault();_vm.hideForm($event)}}},[_c('icon',{attrs:{"icon":"times"}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('h3',[_vm._v("We love your Feedback!")]),_vm._v(" "),_c('p',[_vm._v("No matter if it's good or bad! We really would like to know what you are thinking about Pimplr.\n                        So, go on, just send us rating and/or a few lines of feedback.")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("How do your like pimblr?")]),_vm._v(" "),_c('div',{staticClass:"stars"},_vm._l((5),function(i){return _c('span',{staticClass:"star",class:{active: _vm.starActive(i) || _vm.starOver(i), selected: _vm.starActive(i)},on:{"click":function($event){$event.preventDefault();_vm.setStars(i)},"mouseover":function($event){_vm.setStarOver(i)},"mouseout":function($event){_vm.setStarOut(i)}}},[_c('icon',{attrs:{"icon":"star","collection":_vm.starActive(i)?'fas':'fal',"size":"2x"}})],1)}))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Message")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.message),expression:"formData.message"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.formData.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "message", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){$event.preventDefault();_vm.hideForm($event)}}},[_vm._v("Close")]),_vm._v(" "),_c('indicator-button',{staticClass:"btn btn-primary",attrs:{"click":_vm.sendForm,"is-loading":_vm.loading}},[_vm._v("Send")])],1)])])]),_vm._v(" "),(_vm.show)?_c('div',{staticClass:"modal-backdrop fade show"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YXHe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_EventBus__ = __webpack_require__("n2zA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Startpage_vue__ = __webpack_require__("4bYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_posts_AddPostPage_vue__ = __webpack_require__("4quB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_user_LoginPage_vue__ = __webpack_require__("FsqB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_user_RegistrationPage_vue__ = __webpack_require__("JbwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_user_intro_IntroPage_vue__ = __webpack_require__("s6xY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_user_DashboardPage_vue__ = __webpack_require__("ZbUC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_blogs_BlogsPage_vue__ = __webpack_require__("tzYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_blogs_SearchPage_vue__ = __webpack_require__("12dL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_user_blogs_UserBlogsListPage_vue__ = __webpack_require__("Ven1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_user_blogs_CreateBlogPage_vue__ = __webpack_require__("n6ub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_posts_SharePage_vue__ = __webpack_require__("TbET");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_blogs_BlogPage_vue__ = __webpack_require__("+mX2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_user_tumblr_SyncTublrPage_vue__ = __webpack_require__("xy0H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_user_blogs_UserBlogEdit_vue__ = __webpack_require__("/At2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_user_ProfilePage_vue__ = __webpack_require__("Jx+V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_AboutPage_vue__ = __webpack_require__("CU2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_TermsPage_vue__ = __webpack_require__("IcUi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_user_ForgotPwPage_vue__ = __webpack_require__("6tKv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_user_AccountDeletedPage_vue__ = __webpack_require__("oICN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_blogs_BlogsCharts_vue__ = __webpack_require__("QvvJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_messenger_MessengerPage__ = __webpack_require__("UdPy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_messenger_MessengerDetailPage__ = __webpack_require__("uBMO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_user_FollowedBlogsPage__ = __webpack_require__("hc2r");






























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/start',
        name: 'Startpage',
        component: __WEBPACK_IMPORTED_MODULE_5__components_Startpage_vue__["a" /* default */],
        meta: { bgImage: true }
    }, {
        path: '/what-is-pimblr',
        name: 'WhatIsPimblr',
        component: __WEBPACK_IMPORTED_MODULE_20__components_AboutPage_vue__["a" /* default */],
        meta: { bgImage: true }
    }, {
        path: '/terms-and-conditions',
        name: 'TermsConditions',
        component: __WEBPACK_IMPORTED_MODULE_21__components_TermsPage_vue__["a" /* default */],
        meta: { bgImage: true }
    }, {
        path: '/register',
        name: 'Registration',
        component: __WEBPACK_IMPORTED_MODULE_8__components_user_RegistrationPage_vue__["a" /* default */],
        meta: { bgImage: true }
    }, {
        path: '/forgotpw',
        name: 'ForgotPassword',
        component: __WEBPACK_IMPORTED_MODULE_22__components_user_ForgotPwPage_vue__["a" /* default */],
        meta: { bgImage: true }
    }, {
        path: '/retrivepassword/:key',
        name: 'RetrievePassword',
        component: __WEBPACK_IMPORTED_MODULE_22__components_user_ForgotPwPage_vue__["a" /* default */],
        meta: { bgImage: true }
    }, {
        path: '/intro',
        name: 'Intro',
        component: __WEBPACK_IMPORTED_MODULE_9__components_user_intro_IntroPage_vue__["a" /* default */]
    }, {
        path: '/login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_7__components_user_LoginPage_vue__["a" /* default */],
        meta: { bgImage: true }
    }, {
        path: '/dashboard',
        name: 'Dashboard',
        component: __WEBPACK_IMPORTED_MODULE_10__components_user_DashboardPage_vue__["a" /* default */]
    }, {
        path: '/addPost',
        name: 'Add',
        component: __WEBPACK_IMPORTED_MODULE_6__components_posts_AddPostPage_vue__["a" /* default */]
    }, {
        path: '/blogs',
        name: 'Blogs',
        component: __WEBPACK_IMPORTED_MODULE_11__components_blogs_BlogsPage_vue__["a" /* default */]
    }, {
        path: '/charts',
        name: 'Charts',
        component: __WEBPACK_IMPORTED_MODULE_24__components_blogs_BlogsCharts_vue__["a" /* default */]
    }, {
        path: '/createBlog',
        name: 'CreateBlog',
        component: __WEBPACK_IMPORTED_MODULE_14__components_user_blogs_CreateBlogPage_vue__["a" /* default */]
    }, {
        path: '/editBlog/:blogUrl',
        name: 'EditBlog',
        component: __WEBPACK_IMPORTED_MODULE_18__components_user_blogs_UserBlogEdit_vue__["a" /* default */]
    },

    // Messaging
    {
        path: '/messenger',
        name: 'Messenger',
        component: __WEBPACK_IMPORTED_MODULE_25__components_messenger_MessengerPage__["a" /* default */]
    }, {
        path: '/messenger/blog/:blogUrl',
        name: 'MessageToBlog',
        component: __WEBPACK_IMPORTED_MODULE_26__components_messenger_MessengerDetailPage__["a" /* default */]
    }, {
        path: '/messenger/blog/:blogUrl/user/:userId',
        name: 'MessageToUserFromBlog',
        component: __WEBPACK_IMPORTED_MODULE_26__components_messenger_MessengerDetailPage__["a" /* default */]
    }, {
        path: '/messenger/chat/:conversationId',
        name: 'MessengerDetail',
        component: __WEBPACK_IMPORTED_MODULE_26__components_messenger_MessengerDetailPage__["a" /* default */]
    },

    // Blog Page
    {
        path: '/blog/:blogUrl',
        name: 'BlogPage',
        component: __WEBPACK_IMPORTED_MODULE_16__components_blogs_BlogPage_vue__["a" /* default */]
    }, {
        path: '/blog/:blogUrl/video/:videoId',
        name: 'BlogPageVideo',
        component: __WEBPACK_IMPORTED_MODULE_16__components_blogs_BlogPage_vue__["a" /* default */]
    }, {
        path: '/profile',
        name: 'Profile',
        component: __WEBPACK_IMPORTED_MODULE_19__components_user_ProfilePage_vue__["a" /* default */]
    }, {
        path: '/profile/following',
        name: 'FollowedBlogs',
        component: __WEBPACK_IMPORTED_MODULE_27__components_user_FollowedBlogsPage__["a" /* default */]
    }, {
        path: '/account-deleted',
        name: 'AccountDeleted',
        component: __WEBPACK_IMPORTED_MODULE_23__components_user_AccountDeletedPage_vue__["a" /* default */]
    }, {
        path: '/myblogs/synctumblr',
        name: 'SyncTumblr',
        component: __WEBPACK_IMPORTED_MODULE_17__components_user_tumblr_SyncTublrPage_vue__["a" /* default */]
    }, {
        path: '/myblogs',
        name: 'MyBlogs',
        component: __WEBPACK_IMPORTED_MODULE_13__components_user_blogs_UserBlogsListPage_vue__["a" /* default */]
    }, {
        path: '/search/:query',
        name: 'Search',
        component: __WEBPACK_IMPORTED_MODULE_12__components_blogs_SearchPage_vue__["a" /* default */]
    },

    // SharePage
    {
        path: '/share',
        name: 'Share',
        component: __WEBPACK_IMPORTED_MODULE_15__components_posts_SharePage_vue__["a" /* default */]
    }, {
        path: '/',
        redirect: '/start'
    }]
});

router.beforeEach(function (to, from, next) {

    var bcl = document.body.classList;

    if (to.matched.some(function (record) {
        return record.meta.bgImage;
    })) {
        if (!bcl.contains('bgImage')) bcl.add('bgImage');
    } else {
        if (bcl.contains('bgImage')) bcl.remove('bgImage');
    }

    __WEBPACK_IMPORTED_MODULE_4__services_EventBus__["a" /* default */].$emit('track.click', {
        path: to.path,
        title: to.name
    });

    next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yf7O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ygsw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yj4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Terms',
    data: function data() {
        return {};
    },

    methods: {}
});

/***/ }),

/***/ "Z5Ii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PauseOverlay_vue__ = __webpack_require__("QYSQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bccc79_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PauseOverlay_vue__ = __webpack_require__("+0uh");
function injectStyle (ssrContext) {
  __webpack_require__("oVkp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17bccc79"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PauseOverlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bccc79_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PauseOverlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z7Wr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZWoj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZbUC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardPage_vue__ = __webpack_require__("N1J+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e10804_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardPage_vue__ = __webpack_require__("wgln");
function injectStyle (ssrContext) {
  __webpack_require__("b77r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e10804_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZfRW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a7Cb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mb-3"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-8"},[(_vm.headline)?_c('h1',[_vm._v(_vm._s(_vm.headline))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a9gA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ReblogButton',
    props: {
        post: { default: Object },
        size: { type: String, default: "1x" }
    },
    data: function data() {
        return {
            isLoading: false,
            wasReblogged: false
        };
    },
    created: function created() {},

    computed: {
        blogs: function blogs() {
            return this.$store.state.user.blogs;
        },
        isLoggedIn: function isLoggedIn() {
            return this.$store.getters['user/isLoggedIn'];
        }
    },
    methods: {
        pushBtn: function pushBtn() {
            var _this = this;

            if (!this.isLoggedIn) {
                this.$bus.$emit('error', 'Please login for reblogging!');
                return;
            }
            if (!this.blogs || this.blogs.length < 1) {
                this.$bus.$emit('error', "You don't have any Blogs yet!");
                return;
            }
            if (this.blogs.length > 1) {
                this.$bus.$emit('blogPicker', function (blog) {
                    _this.reblog(blog);
                });
            } else {
                this.reblog(this.blogs[0]);
            }
        },
        reblog: function reblog(blog) {
            var _this2 = this;

            this.isLoading = true;
            this.$api.reblog(blog.url, this.post._id).then(function (res) {
                _this2.isLoading = false;
                _this2.wasReblogged = true;
                _this2.$bus.$emit('success', "Post was reblogged!");
                setTimeout(function () {
                    _this2.wasReblogged = false;
                }, 3000);
            }).catch(function (err) {
                _this2.isLoading = false;
            });
        }
    },
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */]
    }
});

/***/ }),

/***/ "aSi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LikePostButton_vue__ = __webpack_require__("Ew9K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4650383a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LikePostButton_vue__ = __webpack_require__("dZUx");
function injectStyle (ssrContext) {
  __webpack_require__("DBjL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4650383a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LikePostButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4650383a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LikePostButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aSz4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "almG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "at59":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b77r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bBi1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_CenterLogo_vue__ = __webpack_require__("mMEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_Icon__ = __webpack_require__("/G2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blogs_Top20_vue__ = __webpack_require__("EKBn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Startpage',
    data: function data() {
        return {};
    },
    created: function created() {
        if (this.$store.getters['user/isLoggedIn']) this.$router.push({ name: 'Dashboard' });
    },


    methods: {
        showSharing: function showSharing() {
            this.$bus.$emit('ShowHowToPostVideo');
        }
    },
    components: {
        Logo: __WEBPACK_IMPORTED_MODULE_0__layout_CenterLogo_vue__["a" /* default */],
        Icon: __WEBPACK_IMPORTED_MODULE_1__ui_Icon__["a" /* default */],
        Top20: __WEBPACK_IMPORTED_MODULE_2__blogs_Top20_vue__["a" /* default */]
    }

});

/***/ }),

/***/ "bGp4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bKCy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortalLogo_vue__ = __webpack_require__("MMKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e3fe23a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortalLogo_vue__ = __webpack_require__("/FyZ");
function injectStyle (ssrContext) {
  __webpack_require__("jjzj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e3fe23a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortalLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e3fe23a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortalLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bQLH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPostForm_vue__ = __webpack_require__("pVWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d6e5dcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPostForm_vue__ = __webpack_require__("AvC4");
function injectStyle (ssrContext) {
  __webpack_require__("UAAa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d6e5dcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPostForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d6e5dcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPostForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bX0x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bYy7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "bjyy":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "bl7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_PortalLogo__ = __webpack_require__("bKCy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_LoadingIndicator__ = __webpack_require__("HToW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_BlogAvatar__ = __webpack_require__("P0hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PostInspector",
  data: function data() {
    return {
      isOpen: false,
      theme: 'light',
      post: {},
      postData: {},
      commentStr: '',
      isPostingComment: false,
      showTrail: false
    };
  },

  computed: {
    postExists: function postExists() {
      return this.post.post ? true : false;
    },
    postDataExists: function postDataExists() {
      return this.postData.post ? true : false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$bus.$on('postInspector.show', function (data) {
      _this.isOpen = true;
      _this.post = data.post;
      _this.theme = data.theme;
      _this.$api.getExtendedPostInfo(_this.post).then(function (res) {
        return _this.postData = res.data;
      });
    });
    this.$bus.$on('postInspector.hide', function () {
      _this.closeInspector();
    });
    this.$bus.$on('modal.open', function (modal) {
      if (modal === 'player') _this.theme = 'dark';
    });
    this.$bus.$on('modal.close', function (modal) {
      if (modal === 'player') _this.theme = 'light';
    });
  },

  methods: {
    closeInspector: function closeInspector() {
      var _this2 = this;

      this.isOpen = false;
      setTimeout(function () {
        _this2.post = {};
        _this2.postData = {};
      }, 200);
    },
    pushClose: function pushClose() {
      this.$bus.$emit('postInspector.hide');
    },
    postComment: function postComment() {
      var _this3 = this;

      this.isPostingComment = true;
      this.$api.postComment(this.post, this.commentStr).then(function (res) {
        _this3.isPostingComment = false;
        _this3.commentStr = '';
        _this3.postData.comments.push(res.data.comment);
        _this3.$bus.$emit('success', 'Your Comment was added!');
      }).catch(function (err) {
        _this3.$bus.$emit('error', 'Could not Save your Comment');
        _this3.isPostingComment = false;
      });
    },
    isMine: function isMine(comment) {
      return comment.user.name === this.$store.getters['user/name'];
    },
    deleteComment: function deleteComment(comment) {
      var _this4 = this;

      this.$api.deleteComment(this.post, comment).then(function (res) {
        _this4.postData.comments.splice(_this4.postData.comments.indexOf(comment), 1);
        _this4.$bus.$emit('success', 'Your comment was deleted');
      }).catch(function (err) {
        _this4.$bus.$emit('error', 'Sorry, you can not delete this comment.');
      });
    },
    getBlogUrl: function getBlogUrl(blog) {
      return this.$router.resolve({ name: 'BlogPage', params: { blogUrl: blog.url } }).href;
    },
    showBlog: function showBlog(blog) {
      if (this.$route.path != this.getBlogUrl(blog)) {
        this.$bus.$emit('blog-modal.open', { blog: blog });
      }
    }
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3__ui_Icon__["a" /* default */],
    BlogAvatar: __WEBPACK_IMPORTED_MODULE_2__ui_BlogAvatar__["a" /* default */],
    LoadingIndicator: __WEBPACK_IMPORTED_MODULE_1__ui_LoadingIndicator__["a" /* default */],
    PortalLogo: __WEBPACK_IMPORTED_MODULE_0__ui_PortalLogo__["a" /* default */]
  }
});

/***/ }),

/***/ "cEH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard_vue__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProfileForm_vue__ = __webpack_require__("fNA2");
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Profile',
    metaInfo: {
        title: 'Your Pimblr Profile'
    },
    data: function data() {
        return {};
    },


    methods: {},
    components: {
        Navigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__["a" /* default */],
        CenteredCard: __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard_vue__["a" /* default */],
        ProfileForm: __WEBPACK_IMPORTED_MODULE_2__ProfileForm_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "cJLX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBlogListItem_vue__ = __webpack_require__("68jF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acd6391_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBlogListItem_vue__ = __webpack_require__("0Zpd");
function injectStyle (ssrContext) {
  __webpack_require__("at59")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0acd6391"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBlogListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acd6391_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBlogListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cOjI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PimblrIcon",
  props: {
    collection: { type: String, default: 'fal' },
    icon: { type: String, required: true },
    size: { type: String },
    spin: { default: false },
    pulse: { default: false },
    rotation: { default: null }

  }
});

/***/ }),

/***/ "cZDQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Icon__ = __webpack_require__("/G2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_Modal__ = __webpack_require__("KQb1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "share-modal",
    data: function data() {
        return {
            post: null,
            showModal: false,
            hover: 'tumblr'
        };
    },

    computed: {
        imgPreview: function imgPreview() {
            return "url('" + this.post.post.preview + "')";
        },
        imgBlurred: function imgBlurred() {
            return "url('" + this.blurredPreview + "')";
        },
        blurredPreview: function blurredPreview() {
            return document.location.protocol + '//' + document.location.host + '/api/v1/posts/preview/' + this.post.post._id + '/blurred.jpg';
        },
        showPreview: function showPreview() {
            return this.post && this.hover === 'tumblr';
        },
        showBlurred: function showBlurred() {
            return this.post && this.hover !== 'tumblr';
        }
    },
    created: function created() {
        var _this = this;

        this.$bus.$on('openShareModal', function (data) {
            _this.post = data.post;
            _this.showModal = true;
            _this.$bus.$emit('modal.open', 'shareModal');
            _this.$bus.$emit('track.event', { name: 'ShareDialog.open', data: _this.post.post._id });
        });
        this.$bus.$on('closeModal', function (data) {
            _this.closeShareModal();
        });
    },

    methods: {
        closeShareModal: function closeShareModal() {
            this.$bus.$emit('modal.close', 'shareModal');
            this.showModal = false;
        },
        getPostUrl: function getPostUrl() {
            var route = this.$router.resolve({ name: 'BlogPageVideo', params: { blogUrl: this.post.blog.url, videoId: this.post._id } });
            var url = document.location.protocol + '//' + document.location.host + route.location.path;
            return url;
        },
        getTitle: function getTitle() {
            return 'Check out this hot video at: ';
        },
        shareTumblr: function shareTumblr() {
            var title = encodeURIComponent(this.getTitle() + this.getPostUrl());
            var postUrl = encodeURIComponent(this.getPostUrl());
            var imgUrl = encodeURIComponent(this.post.post.preview);
            var shareUrl = "http://www.tumblr.com/share/photo?source=" + imgUrl + "&caption=" + title + "&canonicalUrl=" + postUrl;
            this.$bus.$emit('track.event', { name: 'ShareDialog.exec', data: 'Tumblr: ' + this.post.post._id });
            window.open(shareUrl, 'tumblrShare', 'width=540,height=600');
        },
        shareFacebook: function shareFacebook() {
            var title = encodeURIComponent(this.getTitle());
            var postUrl = encodeURIComponent(this.getPostUrl());
            var imgUrl = encodeURIComponent(this.blurredPreview);
            var shareUrl = "http://www.facebook.com/sharer.php?u=" + postUrl;
            this.$bus.$emit('track.event', { name: 'ShareDialog.exec', data: 'Facebook: ' + this.post.post._id });
            window.open(shareUrl, 'facebookShare', 'width=540,height=600');
        },
        shareTwitter: function shareTwitter() {
            var title = encodeURIComponent(this.getTitle());
            var postUrl = encodeURIComponent(this.getPostUrl());
            var imageUrl = encodeURIComponent(this.blurredPreview);
            var shareUrl = "https://twitter.com/intent/tweet?url=" + postUrl;
            this.$bus.$emit('track.event', { name: 'ShareDialog.exec', data: 'Twitter: ' + this.post.post._id });
            window.open(shareUrl, 'twitterShare', 'width=540,height=600');
        },
        sharePinterest: function sharePinterest() {
            var title = encodeURIComponent(this.getTitle());
            var imageUrl = encodeURIComponent(this.blurredPreview);
            var postUrl = encodeURIComponent(this.getPostUrl());
            var shareUrl = "http://pinterest.com/pin/create/button/?url=" + postUrl + "&media=" + imageUrl + "&description=" + title;
            this.$bus.$emit('track.event', { name: 'ShareDialog.exec', data: 'Pinterest: ' + this.post.post._id });
            window.open(shareUrl, 'pinterestShare', 'width=540,height=600');
        }
        // ToDo: Add Instagram?

    },
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_0__ui_Icon__["a" /* default */],
        Modal: __WEBPACK_IMPORTED_MODULE_1__ui_Modal__["a" /* default */]
    }
});

/***/ }),

/***/ "cmyg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogList_vue__ = __webpack_require__("e0k2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03282246_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogList_vue__ = __webpack_require__("H5Er");
function injectStyle (ssrContext) {
  __webpack_require__("Cszg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03282246"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03282246_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cq31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FollowedBlogsList__ = __webpack_require__("eRWG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_MainNavigation__ = __webpack_require__("HCAz");
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FollowedBlogsPage",
  components: {
    MainNavigation: __WEBPACK_IMPORTED_MODULE_2__layout_MainNavigation__["a" /* default */],
    CenteredCard: __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard__["a" /* default */],
    FollowedBlogs: __WEBPACK_IMPORTED_MODULE_0__FollowedBlogsList__["a" /* default */]
  }
});

/***/ }),

/***/ "csWb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_messenger_CountBadge__ = __webpack_require__("H0JP");


/* harmony default export */ __webpack_exports__["a"] = ({
    main: [{
        label: 'Dashboard',
        icon: ['fal', 'home-alt'],
        name: 'Dashboard'
    }, {
        label: 'Add Post',
        icon: ['fal', 'plus'],
        name: 'Add'
    }, {
        label: 'Explore',
        icon: ['fal', 'compass'],
        name: 'Blogs'
    }, {
        label: 'Top 20',
        icon: ['fal', 'chart-line'],
        name: 'Charts'
    }, {
        label: 'Messenger',
        icon: ['fal', 'comments'],
        name: 'Messenger',
        component: __WEBPACK_IMPORTED_MODULE_0__components_messenger_CountBadge__["a" /* default */]
    }, {
        label: 'Profile',
        icon: ['fal', 'user'],
        name: 'TopProfile', // Need to get uniqe Name fpr DropdownMenu
        subs: [{
            label: 'Profile',
            icon: ['fal', 'user'],
            name: 'Profile'
        }, {
            label: 'My Blogs',
            icon: ['fal', 'atlas'],
            name: 'MyBlogs'
        }, {
            label: 'Followed Blogs',
            icon: ['fal', 'user-friends'],
            name: 'FollowedBlogs'
        }]
    }]
});

/***/ }),

/***/ "cxe5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_CenterLogo_vue__ = __webpack_require__("mMEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_About__ = __webpack_require__("C0Be");
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AboutPage',
    data: function data() {
        return {};
    },


    methods: {},
    components: {
        About: __WEBPACK_IMPORTED_MODULE_2__layout_About__["a" /* default */],
        CenteredCard: __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard__["a" /* default */],
        Logo: __WEBPACK_IMPORTED_MODULE_0__layout_CenterLogo_vue__["a" /* default */]
    }

});

/***/ }),

/***/ "d3Jk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dUH4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar fixed-top navbar-expand-lg navbar-light bg-light-tr"},[_c('div',{staticClass:"container"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goHome()}}},[_c('img',{attrs:{"src":__webpack_require__("AH4R"),"alt":"Pimblr"}})]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav my-2 my-lg-0"},[(!_vm.isLoggedIn)?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/login","tag":"li","activeClass":"active"}},[_c('a',{staticClass:"nav-link"},[_vm._v("Login")])]):_vm._e(),_vm._v(" "),(!_vm.isLoggedIn)?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/register","tag":"li","activeClass":"active"}},[_c('a',{staticClass:"nav-link"},[_vm._v("Register")])]):_vm._e(),_vm._v(" "),(_vm.isLoggedIn)?_c('router-link',{staticClass:"nav-item",attrs:{"to":{name: 'MessageToBlog', params:{blogUrl:_vm.blog.url}},"tag":"li","activeClass":"active"}},[_c('a',{staticClass:"btn btn-outline-primary"},[_vm._v("Send Message")])]):_vm._e(),_vm._v(" "),_c('li',[_vm._v(" ")]),_vm._v(" "),(_vm.isLoggedIn && _vm.canGoBack)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goBack()}}},[_vm._v("go Back")])]):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dZUx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"likeBtn"},[(_vm.isLoading)?_c('a',{attrs:{"href":"#"}},[_c('icon',{attrs:{"icon":"sync","spin":"","size":_vm.size}})],1):(_vm.wasLiked)?_c('a',{staticClass:"active",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.like($event)}}},[_c('icon',{attrs:{"icon":"heart","size":_vm.size}})],1):_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.like($event)}}},[_c('icon',{attrs:{"icon":"heart","size":_vm.size}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dtaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['notification'],
    data: function data() {
        return {};
    },

    computed: {
        classes: function classes() {
            var css = [];
            switch (this.notification.type) {
                case 'error':
                    css.push('alert-danger');break;
                case 'success':
                    css.push('alert-success');break;
                case 'warning':
                    css.push('alert-warning');break;
            }
            return css.join(' ');
        },
        icon: function icon() {
            var iconName = '';
            switch (this.notification.type) {
                case 'error':
                    iconName = 'times';break;
                case 'success':
                    iconName = 'check';break;
                case 'warning':
                    iconName = 'exclamation-triangle';break;
            }
            return iconName;
        }
    },
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_0__ui_Icon__["a" /* default */]
    }
});

/***/ }),

/***/ "duCX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hypnotube.aba1640.png";

/***/ }),

/***/ "e0k2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BlogListItem_vue__ = __webpack_require__("GB2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_LoadingIndicator_vue__ = __webpack_require__("HToW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_DropDownHeader__ = __webpack_require__("M+Kk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    props: {
        headline: { type: String, default: 'Latest Blogs' },
        searchQuery: { type: String, default: '' }
    },
    data: function data() {
        return {
            isActive: false,
            search: null,
            wasLastBlog: false,
            itemsPerPage: 24,
            isLoading: false,
            categories: [
            //{key: 'best', label: 'Best Blogs'},
            { key: 'popular', label: 'Popular Blogs' }, { key: 'latest', label: 'Latest Blogs' }, { key: 'latestupdate', label: 'Latest Updates' }],
            currentCategory: null,
            showCats: false,
            blogs: [],
            nothingFound: false
        };
    },

    computed: {
        isSearching: function isSearching() {
            return this.searchQuery.length > 2;
        }
    },
    watch: {
        searchQuery: function searchQuery(newVal, oldVal) {
            this.blogs = [];
            this.loadBlogs(0);
        }
    },
    created: function created() {
        this.currentCategory = this.categories[0];
        document.addEventListener("scroll", this.scrollListener);
    },
    mounted: function mounted() {
        var _this = this;

        this.isActive = true;
        this.$nextTick(function () {
            if (!_this.isSearching) _this.loadBlogs(0);
        });
        this.$bus.$on('bloglist.exists', function (data) {
            if (_this.isActive) _this.$bus.$emit('blog-modal.listExists', _this.getNextPrevBlogs(data.currentBlog));
        });
    },
    beforeDestroy: function beforeDestroy() {
        this.isActive = false;
        document.removeEventListener('scroll', this.scrollListener);
    },

    methods: {
        scrollListener: function scrollListener() {
            var scrollPos = window.pageYOffset + window.innerHeight;
            if (!this.wasLastBlog && !this.isLoading && Math.abs(scrollPos - document.body.scrollHeight) < 50) {
                this.loadMore();
            }
        },
        loadBlogs: function loadBlogs(offset) {
            var _this2 = this;

            this.nothingFound = false;
            if (this.isSearching) {
                this.$api.searchBlogs(this.searchQuery, offset).then(function (res) {
                    if (res.data.blogs.length < _this2.itemsPerPage) _this2.wasLastBlog = true;
                    res.data.blogs.forEach(function (blog) {
                        _this2.blogs.push(blog);
                    });
                    _this2.isLoading = false;
                    if (offset === 0 && res.data.blogs.length === 0) {
                        _this2.nothingFound = true;
                    }
                });
            } else {
                this.$api.getBlogListByType(this.currentCategory.key, offset).then(function (res) {
                    if (res.data.blogs.length < _this2.itemsPerPage) _this2.wasLastBlog = true;
                    res.data.blogs.forEach(function (blog) {
                        _this2.blogs.push(blog);
                    });
                    _this2.isLoading = false;
                });
            }
        },
        loadMore: function loadMore() {
            this.isLoading = true;
            this.loadBlogs(this.blogs.length);
        },
        chooseCategory: function chooseCategory(cat) {
            this.showCats = false;
            if (cat != this.currentCategory) {
                this.currentCategory = cat;
                this.blogs = [];
                this.loadBlogs(0);
            }
        },
        getNextPrevBlogs: function getNextPrevBlogs(current) {
            var last = null;
            var next = null;
            for (var i in this.blogs) {
                if (i > this.blogs.length - 3 && !this.wasLastBlog) this.loadMore();
                var b = this.blogs[i];
                if (b === current) {
                    next = 1;
                    continue;
                }
                if (next === 1) {
                    next = b;
                    break;
                }
                last = b;
            }
            if (next === 1) next = null;
            return {
                nextBlog: next,
                prevBlog: last
            };
        }
    },
    components: {
        BlogListItem: __WEBPACK_IMPORTED_MODULE_0__BlogListItem_vue__["a" /* default */],
        LoadingIndicator: __WEBPACK_IMPORTED_MODULE_1__ui_LoadingIndicator_vue__["a" /* default */],
        DropDownHeader: __WEBPACK_IMPORTED_MODULE_2__ui_DropDownHeader__["a" /* default */]
    }
});

/***/ }),

/***/ "e8va":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "eRWG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FollowedBlogsList_vue__ = __webpack_require__("9MX5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f154f4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FollowedBlogsList_vue__ = __webpack_require__("MoqY");
function injectStyle (ssrContext) {
  __webpack_require__("ZfRW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FollowedBlogsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f154f4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FollowedBlogsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eRwP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('modal',[_c('h2',{attrs:{"slot":"header"},slot:"header"},[_vm._v("How to post a video on Pimblr")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('video',{attrs:{"src":"https://vt.media.tumblr.com/tumblr_p6vjjx16b51x770v3.mp4","controls":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-xs btn-primary",on:{"click":function($event){_vm.show=false}}},[_vm._v("Got it!")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eUY4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['blog'],
    computed: {
        isFollowing: function isFollowing() {
            return this.$store.getters['user/follows'].includes(this.blog._id);
        },
        followWord: function followWord() {
            return this.isFollowing ? 'unfollow' : 'follow';
        },
        btnClass: function btnClass() {
            return this.isFollowing ? 'btn-primary' : 'btn-outline-primary';
        },
        icon: function icon() {
            return this.isFollowing ? 'user-minus' : 'user-plus';
        }
    },
    created: function created() {},

    methods: {
        follow: function follow() {
            if (this.$store.getters['user/isLoggedIn']) {
                this.$store.dispatch('user/followBlog', this.blog.url);
            } else {
                this.$router.push({ name: 'Registration' });
            }
        }
    }
});

/***/ }),

/***/ "eWqp":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ecnS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showShareMenue($event)}}},[_c('icon',{attrs:{"icon":"share-alt","size":_vm.size}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f87d":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "fAmf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification alert",class:_vm.classes},[_c('div',{staticClass:"media"},[_c('icon',{attrs:{"icon":_vm.icon}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_vm._v("\n            "+_vm._s(_vm.notification.message)+"\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fNA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileForm_vue__ = __webpack_require__("UNM3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd16af0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileForm_vue__ = __webpack_require__("Ins1");
function injectStyle (ssrContext) {
  __webpack_require__("3t5A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd16af0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fn/m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var AvatarCreator = function () {
    function AvatarCreator(canvas) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AvatarCreator);

        this.canvas = canvas;
        this.ctx = this.canvas.getContext('2d');
        this.width = this.canvas.width;
        this.height = this.canvas.height;
        this.paddingX = 5;
        this.paddingY = 20;

        this.string = '';

        this.bgColors = ['#000000', '#FFFFFF'];
        this.bgImages = [];
        this.fgColors = [];
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AvatarCreator, [{
        key: 'render',
        value: function render(string) {

            this.ctx.clearRect(0, 0, this.width, this.height);

            if (string.length < 3) return;

            this.string = string.split('').reverse().join('');
            var bg = this.string[0];
            var fg = this.string[1];

            this.renderBg();

            var i = 0;
            var params = 4;

            //console.log(this.string, this.string.length)

            while (i < this.string.length - params) {
                //console.log(i);
                var pt = this.string.substr(i, params);
                if (pt.length < params) pt += this.string.substr(0, params - pt.length);
                this.renderPoint(pt);
                i += 1;
            }
        }
    }, {
        key: 'renderBg',
        value: function renderBg() {
            var c = this.bgColors[this.string.length % this.bgColors.length];
            this.ctx.fillStyle = c;
            this.ctx.fillRect(0, 0, this.width, this.height);
        }
    }, {
        key: 'renderFg',
        value: function renderFg(str) {}
    }, {
        key: 'renderPoint',
        value: function renderPoint(str) {
            var x = this.posFromChar(str[0], this.width, this.paddingX);
            var y = this.posFromChar(str[1], this.height, this.paddingY);
            var s = this.pointSizeFromChar(str[3]);

            this.ctx.shadowColor = this.colorFromChar(str[2], 100);
            this.ctx.fillStyle = this.colorFromChar(str[2], this.charToPer(str[3]));
            this.ctx.shadowBlur = 30;
            this.ctx.beginPath();
            this.ctx.arc(x, y, s, 0, Math.PI * 2);
            this.ctx.closePath();
            this.ctx.fill();
        }
    }, {
        key: 'charToPer',
        value: function charToPer(char) {
            var ccn = parseInt(char, 16);
            return parseInt(100 / 15 * ccn);
        }
    }, {
        key: 'posFromChar',
        value: function posFromChar(char, max, padding) {
            var pad = max / 100 * padding;
            var pos = pad + this.charToPer(char) / 100 * (max - 2 * pad);
            return pos;
        }
    }, {
        key: 'colorFromChar',
        value: function colorFromChar(char, alpha) {
            var n = this.charToPer(char) % 100;
            var h = n * 3.6 + 220;
            var s = 50 + n * 0.5;
            var l = 20 + n * 0.3;
            var a = parseFloat(alpha / 160); //(10 + (n*0.4)) / 100;
            //if(!alpha)console.log('Alpha: '+a);
            return 'hsla(' + h + ',' + s + '%,' + l + '%,' + a + ')';
        }
    }, {
        key: 'pointSizeFromChar',
        value: function pointSizeFromChar(char) {
            var max = Math.min(this.width, this.height) / 2;
            return parseInt(this.charToPer(char) / 100 * max);
        }
    }]);

    return AvatarCreator;
}();

/* harmony default export */ __webpack_exports__["a"] = (AvatarCreator);

/***/ }),

/***/ "fxk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'MessengerNavigation',
    props: ['title'],
    data: function data() {
        return {};
    },

    computed: {
        isLoggedIn: function isLoggedIn() {
            return this.$store.state.user.isLoggedIn;
        }
    },
    created: function created() {},

    methods: {
        toggleNav: function toggleNav() {
            this.$bus.$emit('sidebar.toggle');
        },
        goBack: function goBack() {
            this.$router.go(-1);
        }
    },
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_0__ui_Icon__["a" /* default */]
    }
});

/***/ }),

/***/ "gDpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce__ = __webpack_require__("HhAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "autocomplete-input",
    props: {
        placeholder: { type: String, default: '' },
        suggestMethod: { type: String }
    },
    data: function data() {
        return {
            current: -1,
            list: [],
            fieldVal: ''
        };
    },

    computed: {
        showList: function showList() {
            return this.list.length > 0;
        }
    },
    mounted: function mounted() {
        this.fieldVal = this.value;
        if (this.$route.params.query) this.fieldVal = this.$route.params.query;
    },

    methods: {
        updateValue: __WEBPACK_IMPORTED_MODULE_0_debounce___default()(function (input) {
            var _this = this;

            var fullQ = input.target.value.toString();
            var words = fullQ.split(' ');
            var q = words.pop();
            var pref = words.join(' ');

            if (q.length < 2) {
                this.current = -1;
                this.list = [];
                return;
            }
            this.$api[this.suggestMethod](q).then(function (res) {
                var listArr = [];
                _this.current = -1;
                if (res) {
                    listArr = res.data.tags.map(function (tag) {
                        var label = '';
                        if (pref.length > 0) label = pref + " ";
                        label += tag;
                        return new Object({ label: label });
                    });
                }
                _this.list = listArr;
            });
        }, 600),
        hitEnter: function hitEnter(inputField) {
            this.startSearch();
        },
        clickItem: function clickItem(item) {
            this.current = this.list.indexOf(item);
            this.fieldVal = item.label;
            this.startSearch();
        },
        startSearch: function startSearch() {
            if (this.fieldVal.length < 3) {
                this.$bus.$emit('error', 'Please enter at least 3 chars.');
                return false;
            }
            this.$emit('input', this.fieldVal);
            this.list = [];
        },
        hitDown: function hitDown() {
            if (this.current < this.list.length - 1) this.current++;
            this.fieldVal = this.list[this.current].label;
        },
        hitUp: function hitUp() {
            if (this.current > 0) this.current--;
            this.fieldVal = this.list[this.current].label;
        },
        subIsActive: function subIsActive(idx) {
            return idx === this.current;
        }
    }
});

/***/ }),

/***/ "gVSD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gd8T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gfnv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"postListItem"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9 longpoint",attrs:{"title":_vm.post.post.title}},[_c('portal-logo',{attrs:{"post":_vm.post,"mh":"20px"}}),_vm._v(" "+_vm._s(_vm.post.post.title)+"\n                    ")],1),_vm._v(" "),_c('div',{staticClass:"col-3 text-right"},[_vm._v("\n                        "+_vm._s(_vm._f("time")(_vm.post.post.duration))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"holder",style:({'background-image': _vm.bgImage }),on:{"click":_vm.playVideo}}),_vm._v(" "),_c('div',{staticClass:"options"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 longpoint"},[_c('a',{attrs:{"href":_vm.getBlogUrl(_vm.post.blog)},on:{"click":function($event){$event.preventDefault();_vm.showBlog(_vm.post.blog)}}},[_c('blog-avatar',{attrs:{"blog":_vm.post.blog,"w":20,"h":20}}),_vm._v(" "+_vm._s(_vm.post.blog.title))],1)]),_vm._v(" "),_c('div',{staticClass:"col-4 text-right btns-right"},[(_vm.isAdmin)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deletePost()}}},[_c('icon',{attrs:{"icon":"trash-alt"}})],1):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showPostInfo($event)}}},[_c('icon',{attrs:{"icon":"comment"}})],1),_vm._v(" "),_c('share-btn',{attrs:{"post":_vm.post}}),_vm._v(" "),_c('like-post-button',{attrs:{"post":_vm.post}}),_vm._v(" "),_c('reblog-btn',{attrs:{"post":_vm.post}})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gjxy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TinyProgressBar',
    props: ['me', 'post'],
    data: function data() {
        return {
            progress: 0
        };
    },

    computed: {
        progressStr: function progressStr() {
            return this.progress + "%";
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$bus.$on('player.progress', function (data) {
            _this.progress = data.progress;
        });
    }
});

/***/ }),

/***/ "gr0q":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "h5BD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BlogListItem"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-img-top"},[_c('blog-avatar',{attrs:{"blog":_vm.blog,"w":600,"h":150}})],1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title",attrs:{"title":_vm.blog.title},on:{"click":function($event){$event.preventDefault();_vm.openBlog(_vm.blog, $event)}}},[_vm._v(_vm._s(_vm.blog.title))]),_vm._v(" "),_c('div',{staticClass:"preview-cont"},[_c('div',{staticClass:"inner"},_vm._l((_vm.posts),function(p){return _c('div',{staticClass:"blogpost-img-preview",style:({'background-image': _vm.bgImage(p.post.preview) }),on:{"click":function($event){$event.preventDefault();_vm.playPost(p)}}})}))])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":_vm.getBlogUrl(_vm.blog)},on:{"click":function($event){$event.preventDefault();_vm.openBlog(_vm.blog, $event)}}},[_vm._v("show blog")]),_vm._v(" "),_c('follow-button',{attrs:{"blog":_vm.blog}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hLeH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center logo-outer"},[_c('img',{staticClass:"logo",attrs:{"title":"Pimblr","src":__webpack_require__("5l9X")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hNKH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_SearchField_vue__ = __webpack_require__("9NlZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_buttons_FollowButton_vue__ = __webpack_require__("/caE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'BlogNavigation',
    props: ['blog'],
    data: function data() {
        return {
            navOpen: false
        };
    },

    computed: {
        isLoggedIn: function isLoggedIn() {
            return this.$store.state.user.isLoggedIn;
        },
        canGoBack: function canGoBack() {
            return history.length > 1;
        }
    },
    created: function created() {},

    methods: {
        toggleNav: function toggleNav() {
            this.navOpen = !this.navOpen;
        },
        logout: function logout() {
            this.$store.commit('user/unsetToken');
            this.$router.push({ name: 'Login' });
        },
        goHome: function goHome() {
            if (this.isLoggedIn) {
                this.$router.push({ name: 'Dashboard' });
            } else {
                this.$router.push({ name: 'Startpage' });
            }
        },
        goBack: function goBack() {
            this.$router.go(-1);
        }
    },
    components: {
        SearchField: __WEBPACK_IMPORTED_MODULE_0__ui_SearchField_vue__["a" /* default */],
        FollowButton: __WEBPACK_IMPORTED_MODULE_1__ui_buttons_FollowButton_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "hSle":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation'),_vm._v(" "),_c('centered-card',{attrs:{"headline":"My Profile"}},[_c('profile-form')],1),_vm._v(" "),_c('div',{staticClass:"card-spacer"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hc2r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FollowedBlogsPage_vue__ = __webpack_require__("cq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490aac6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FollowedBlogsPage_vue__ = __webpack_require__("7BDS");
function injectStyle (ssrContext) {
  __webpack_require__("ta6d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-490aac6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FollowedBlogsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490aac6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FollowedBlogsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hjLe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i+8x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutocompleteInput__ = __webpack_require__("iA6h");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { AutocompleteInput: __WEBPACK_IMPORTED_MODULE_0__AutocompleteInput__["a" /* default */] },
    name: '',
    data: function data() {
        return {
            searchQuery: ''
        };
    },


    methods: {
        search: function search(input) {
            this.$router.push({ name: 'Search', params: { query: this.searchQuery } });
        }
    }
});

/***/ }),

/***/ "iA6h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutocompleteInput_vue__ = __webpack_require__("gDpt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a079846_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutocompleteInput_vue__ = __webpack_require__("UN5Y");
function injectStyle (ssrContext) {
  __webpack_require__("YG6y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a079846"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutocompleteInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a079846_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutocompleteInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iFST":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard_vue__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogForm_vue__ = __webpack_require__("PwP5");
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'UserBlogEditPage',
    metaInfo: {
        title: 'Edit your Blog'
    },
    data: function data() {
        return {
            blog: {}
        };
    },
    created: function created() {
        var _this = this;

        this.$api.getBlog(this.$route.params.blogUrl).then(function (res) {
            _this.blog = res.data.blog;
        });
    },

    methods: {},
    components: {
        MainNavigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__["a" /* default */],
        CenteredCard: __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard_vue__["a" /* default */],
        BlogForm: __WEBPACK_IMPORTED_MODULE_2__BlogForm_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "iXms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.btnClass,on:{"click":function($event){$event.preventDefault();_vm.follow($event)}}},[_c('span',{staticClass:"hidden-xs"},[_vm._v(_vm._s(_vm.followWord))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iZtR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserBlogListItem_vue__ = __webpack_require__("cJLX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard_vue__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_LoadingIndicator__ = __webpack_require__("HToW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    data: function data() {
        return {
            blogs: [],
            search: '',
            isActive: false
        };
    },

    computed: {
        selected: function selected() {
            var _this = this;

            return this.blogs.filter(function (blog) {
                return blog.title.toLowerCase().indexOf(_this.search) >= 0;
            });
        },
        headline: function headline() {
            var str = 'My Blogs';
            var len = this.selected.length;
            if (len > 0) str += ' (' + len + ')';
            return str;
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.isActive = true;
        this.$bus.$on('blog-deleted', this.loadBlogs);
        this.$bus.$on('bloglist.exists', function (data) {
            if (_this2.isActive) _this2.$bus.$emit('blog-modal.listExists', _this2.getNextPrevBlogs(data.currentBlog));
        });
        this.loadBlogs();
    },
    beforeDestroy: function beforeDestroy() {
        this.isActive = false;
    },

    methods: {
        loadBlogs: function loadBlogs() {
            var _this3 = this;

            this.$api.getUserBlogs().then(function (res) {
                _this3.blogs = res.data.blogs;
            });
        },
        getNextPrevBlogs: function getNextPrevBlogs(current) {
            var last = null;
            var next = null;
            for (var i in this.selected) {
                var b = this.selected[i];
                if (b === current) {
                    next = 1;
                    continue;
                }
                if (next === 1) {
                    next = b;
                    break;
                }
                last = b;
            }
            if (next === 1) next = null;
            return {
                nextBlog: next,
                prevBlog: last
            };
        },
        createBlog: function createBlog() {
            this.$router.push({ name: 'CreateBlog' });
        },
        syncTumblr: function syncTumblr() {
            this.$router.push({ name: 'SyncTumblr' });
        }
    },
    components: {
        LoadingIndicator: __WEBPACK_IMPORTED_MODULE_2__ui_LoadingIndicator__["a" /* default */],
        BlogItem: __WEBPACK_IMPORTED_MODULE_0__UserBlogListItem_vue__["a" /* default */],
        CenteredCard: __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "jYnn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jZ0l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventBus__ = __webpack_require__("n2zA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");







var Api = function () {
    function Api() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

        this.api = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
            baseURL: '/api/v1'
        });
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
        key: 'request',
        value: function request(type, url, data) {
            var requestName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ApiService";
            var customToken = arguments[4];

            var token = customToken ? customToken : __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].getters['user/token'];
            var headers = token ? { 'Authorization': 'JWT ' + token } : {};

            __WEBPACK_IMPORTED_MODULE_3__EventBus__["a" /* default */].$emit('loading', requestName);

            var promise = this.api({
                method: type,
                url: url,
                data: data ? data : null,
                headers: headers
            });

            promise.then(function (res) {
                __WEBPACK_IMPORTED_MODULE_3__EventBus__["a" /* default */].$emit('loaded', requestName);
            });
            promise.catch(function (err) {
                __WEBPACK_IMPORTED_MODULE_3__EventBus__["a" /* default */].$emit('loaded', requestName);
                if (err.response && err.response.data && err.response.data.message) __WEBPACK_IMPORTED_MODULE_3__EventBus__["a" /* default */].$emit('error', err.response.data.message);
                if (err.response.status == 401) {
                    __WEBPACK_IMPORTED_MODULE_3__EventBus__["a" /* default */].$emit('error', "Sorry, you're not autorized for that...");
                    __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].commit('user/unsetToken');
                    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push('/login');
                }
            });
            return promise;
        }

        // User

    }, {
        key: 'login',
        value: function login(username, password) {
            return this.request('post', '/users/login', {
                name: username,
                password: password
            }, 'user.login');
        }
    }, {
        key: 'deleteUserAccount',
        value: function deleteUserAccount(userId, password) {
            return this.request('delete', '/users', {
                id: userId,
                password: password
            }, 'user.delete');
        }
    }, {
        key: 'mailExists',
        value: function mailExists(mail) {
            return this.request('get', '/users/mailexists/' + mail);
        }
    }, {
        key: 'userExists',
        value: function userExists(username) {
            return this.request('get', '/users/usernameexists/' + username);
        }
    }, {
        key: 'register',
        value: function register(email, username, password) {
            return this.request('post', '/users', {
                name: username,
                password: password,
                email: email
            }, 'user.register');
        }
    }, {
        key: 'forgotPw',
        value: function forgotPw(email) {
            return this.request('post', '/users/lostpassword', { email: email }, 'user.forgotpw');
        }
    }, {
        key: 'retrievePw',
        value: function retrievePw(pwKey) {
            return this.request('post', '/users/resetpassword', { pwKey: pwKey }, 'user.retrievepw');
        }
    }, {
        key: 'getUserInfo',
        value: function getUserInfo(token) {
            return this.request('get', '/users/info', null, 'user.info', token);
        }
    }, {
        key: 'changeUserEmail',
        value: function changeUserEmail(email) {
            return this.request('put', '/users/email', { email: email }, 'user.changemail');
        }
    }, {
        key: 'changeUserPassowrd',
        value: function changeUserPassowrd(password) {
            return this.request('put', '/users/password', { password: password }, 'user.changepassword');
        }
    }, {
        key: 'changeUserContentTypes',
        value: function changeUserContentTypes(contentTypes) {
            return this.request('put', '/users/contentTypes', { contentTypes: contentTypes }, 'user.changecontentTypes');
        }
    }, {
        key: 'getUserFollowdBlogs',
        value: function getUserFollowdBlogs() {
            return this.request('get', '/users/follows', null, 'user.follows');
        }
    }, {
        key: 'sendFeedback',
        value: function sendFeedback(formData) {
            return this.request('post', '/users/feedback', formData, 'user.sendFeedback');
        }
    }, {
        key: 'reblog',
        value: function reblog(blogUrl, postId) {
            return this.request('post', '/blogs/' + blogUrl + '/reblog/' + postId, null, 'post.reblog');
        }
    }, {
        key: 'toggleFollowBlog',
        value: function toggleFollowBlog(blogUrl) {
            return this.request('post', '/users/follow/' + blogUrl, null, 'blog.follow');
        }

        // Likes

    }, {
        key: 'likePost',
        value: function likePost(post) {
            return this.request('post', '/users/like/' + post._id, null, 'post.like');
        }
    }, {
        key: 'unLikePost',
        value: function unLikePost(post) {
            return this.request('post', '/users/unlike/' + post._id, null, 'post.unlike');
        }
    }, {
        key: 'getLikedPosts',
        value: function getLikedPosts(lastPost) {
            var q = lastPost ? '?last=' + lastPost : '';
            return this.request('get', '/posts/liked' + q, {}, 'likedposts.get');
        }

        // Comments

    }, {
        key: 'postComment',
        value: function postComment(post, text) {
            return this.request('post', '/posts/' + post._id + '/comment', { text: text }, 'post.addComment');
        }
    }, {
        key: 'deleteComment',
        value: function deleteComment(post, comment) {
            return this.request('delete', '/posts/' + post.post._id + '/comment/' + comment._id, null, 'post.deleteComment');
        }
    }, {
        key: 'getExtendedPostInfo',
        value: function getExtendedPostInfo(post) {
            return this.request('get', '/posts/' + post._id + '/extended', null, 'post.extendedInfo');
        }

        // Public Blogs

    }, {
        key: 'getBlogs',
        value: function getBlogs(offset) {
            var q = offset ? '?offset=' + offset : '';
            return this.request('get', '/blogs' + q, null, 'blogs');
        }
    }, {
        key: 'getBlogListByType',
        value: function getBlogListByType(type, offset) {
            var t = type ? type : 'best';
            var q = offset ? '?offset=' + offset : '';
            return this.request('get', '/blogs/list/' + t + q, null, 'blogs');
        }
    }, {
        key: 'getBlogTop20',
        value: function getBlogTop20() {
            return this.request('get', '/blogs/top20', null, 'blog.top20');
        }
    }, {
        key: 'searchBlogs',
        value: function searchBlogs(query, offset) {
            var q = offset ? '?offset=' + offset : '';
            return this.request('get', '/blogs/search/' + encodeURIComponent(query) + q, null, 'blogs');
        }
    }, {
        key: 'getBlog',
        value: function getBlog(blogUrl) {
            return this.request('get', '/blogs/' + blogUrl, null, 'blog.get');
        }
    }, {
        key: 'getBlogPosts',
        value: function getBlogPosts(blogUrl, lastPost) {
            var q = lastPost ? '?last=' + lastPost : '';
            return this.request('get', '/blogs/' + blogUrl + "/posts" + q, null, 'blog.getPosts');
        }
    }, {
        key: 'searchSuggest',
        value: function searchSuggest(query) {
            return this.request('get', '/blogs/tags/' + query, null, 'search.suggest');
        }

        // User Blogs

    }, {
        key: 'getUserBlogs',
        value: function getUserBlogs() {
            return this.request('get', '/users/blogs', null, 'user.getBlogs');
        }
    }, {
        key: 'getUserBlogFollower',
        value: function getUserBlogFollower(blogObj, page) {
            return this.request('get', '/users/blog/' + blogObj.url + '/follower/' + page, null, 'user.getBlogFollower');
        }
    }, {
        key: 'createBlog',
        value: function createBlog(blogObj) {
            return this.request('post', '/blogs', blogObj, 'blog.create');
        }
    }, {
        key: 'updateBlog',
        value: function updateBlog(blogObj) {
            return this.request('put', '/blogs/' + blogObj._id, blogObj, 'blog.update');
        }
    }, {
        key: 'deleteBlog',
        value: function deleteBlog(blogObj) {
            return this.request('delete', '/blogs/' + blogObj._id, null, 'blog.delete');
        }

        // Tumblr Auth

    }, {
        key: 'tumblrGetAuth',
        value: function tumblrGetAuth() {
            return this.request('get', '/users/synctumblr/getauth', null, 'user.tumblr.getAuth');
        }
    }, {
        key: 'tumblrVerifyAuth',
        value: function tumblrVerifyAuth(token, secret, verifier) {
            return this.request('post', '/users/synctumblr/verify', {
                token: token,
                secret: secret,
                verifier: verifier
            }, 'user.tumblr.verifyAuth');
        }
    }, {
        key: 'tumblrUserInfo',
        value: function tumblrUserInfo(token, secret) {
            return this.request('post', '/users/synctumblr/userinfo', {
                token: token, secret: secret
            }, 'user.tumblr.getUserInfo');
        }
    }, {
        key: 'tumblrSyncBlog',
        value: function tumblrSyncBlog(token, secret, blogName) {
            return this.request('post', '/users/synctumblr/sync/' + blogName, {
                token: token, secret: secret
            }, 'user.tumblr.import');
        }

        // Video Info

    }, {
        key: 'getVideoInfo',
        value: function getVideoInfo(videoUrl) {
            return this.request('get', '/posts/videoinfo?url=' + encodeURI(videoUrl), null, 'post.getVideoInfo');
        }

        // Posts

    }, {
        key: 'getPosts',
        value: function getPosts(lastPost) {
            var q = lastPost ? '?last=' + lastPost : '';
            return this.request('get', '/posts' + q, {}, 'posts.get');
        }
    }, {
        key: 'getPost',
        value: function getPost(postId) {
            return this.request('get', '/posts/post/' + postId, 'post.get');
        }
    }, {
        key: 'getVideoUrl',
        value: function getVideoUrl(postId) {
            return this.request('get', '/posts/videourl/' + postId, null, 'posts.getVideoUrl');
        }
    }, {
        key: 'addPost',
        value: function addPost(blogUrl, postUrl) {
            return this.request('post', '/posts/', { blogUrl: blogUrl, url: postUrl }, 'post.add');
        }
    }, {
        key: 'deletePost',
        value: function deletePost(postId) {
            return this.request('delete', '/posts/' + postId, {}, 'post.delete');
        }
    }, {
        key: 'updatePostDuration',
        value: function updatePostDuration(postId, duration) {
            return this.request('put', '/posts/' + postId + '/updateDuration', { duration: duration }, 'post.updateDuration');
        }
    }, {
        key: 'getConversations',
        value: function getConversations() {
            return this.request('get', '/messenger', {}, 'messenger.getConversations');
        }
    }, {
        key: 'getUnreadMessages',
        value: function getUnreadMessages() {
            return this.request('get', '/messenger/unreadMessages');
        }
    }, {
        key: 'getConversationByBlogUrl',
        value: function getConversationByBlogUrl(blogUrl) {
            return this.request('get', '/messenger/blog/' + blogUrl);
        }
    }, {
        key: 'getConversationByUserIdAndBlogUrl',
        value: function getConversationByUserIdAndBlogUrl(userId, blogUrl) {
            return this.request('get', '/messenger/blog/' + blogUrl + '/user/' + userId);
        }
    }, {
        key: 'getConversationById',
        value: function getConversationById(conversationId) {
            return this.request('get', '/messenger/conversation/' + conversationId);
        }
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Api());

/***/ }),

/***/ "jgr8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TinyProgressBar_vue__ = __webpack_require__("gjxy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25426c57_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TinyProgressBar_vue__ = __webpack_require__("T2FU");
function injectStyle (ssrContext) {
  __webpack_require__("H2CP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25426c57"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TinyProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25426c57_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TinyProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jjzj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k79l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notificationCenter"}},[_c('transition-group',{attrs:{"name":"notification-list"}},_vm._l((_vm.notifications),function(n,k){return _c('notification',{key:k,attrs:{"notification":n}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kf+a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kgtc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("/G2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogAvatar__ = __webpack_require__("P0hn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'postToBlogDialog',
    data: function data() {
        return {
            show: false,
            callback: null,
            search: ''
        };
    },

    computed: {
        blogs: function blogs() {
            return this.$store.getters['user/blogs'];
        },
        selected: function selected() {
            var _this = this;

            return this.blogs.filter(function (blog) {
                return blog.title.toLowerCase().indexOf(_this.search) >= 0;
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$bus.$on('blogPicker', function (cb) {
            _this2.show = true;
            _this2.callback = cb;
            _this2.$bus.$emit('modal.open', 'blogPicker');
        });
    },

    methods: {
        hide: function hide() {
            this.show = false;
            this.callback = null;
            this.$bus.$emit('modal.close', 'blogPicker');
        },
        doPost: function doPost(blog) {
            this.callback(blog);
            this.hide();
        }
    },
    components: {
        BlogAvatar: __WEBPACK_IMPORTED_MODULE_1__BlogAvatar__["a" /* default */],
        Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */]
    }
});

/***/ }),

/***/ "kihP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_CenterLogo__ = __webpack_require__("mMEQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "ageBlock",
    props: ['acceptAction'],
    data: function data() {
        return {
            accepted: false
        };
    },
    created: function created() {
        var _this = this;

        if (this.$store.state.user.isLoggedIn) {
            this.accepted = true;
        }
        this.$nextTick(function () {
            if (_this.$store.state.user.isLoggedIn) {
                _this.accept();
            }
        });
    },

    methods: {
        accept: function accept() {
            this.accepted = true;
            if (this.acceptAction) this.acceptAction();
        }
    },
    components: {
        logo: __WEBPACK_IMPORTED_MODULE_0__layout_CenterLogo__["a" /* default */]
    }
});

/***/ }),

/***/ "lQ4r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lfiD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__ = __webpack_require__("3nTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_pro_solid_svg_icons__ = __webpack_require__("OORV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_brands_svg_icons__ = __webpack_require__("DfMW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");





__WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["s" /* faHomeAlt */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["A" /* faPlus */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["d" /* faChartLine */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["n" /* faCompass */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["K" /* faUser */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["y" /* faPlay */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["w" /* faPause */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["Q" /* faVolumeOff */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["R" /* faVolumeUp */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["P" /* faVolumeMute */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["G" /* faSync */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["m" /* faComments */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["l" /* faComment */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["F" /* faStar */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["I" /* faTrashAlt */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["D" /* faRetweet */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["r" /* faHeart */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["r" /* faHeart */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["E" /* faShareAlt */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["H" /* faTimes */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["e" /* faCheck */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["o" /* faExclamationTriangle */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["k" /* faCircleNotch */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["a" /* faArrowsAlt */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["J" /* faTv */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["h" /* faChevronLeft */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["i" /* faChevronRight */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["g" /* faChevronDown */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["j" /* faChevronUp */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["x" /* faPencil */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["t" /* faLightbulb */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["C" /* faQuestion */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["u" /* faList */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["O" /* faUsers */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["z" /* faPlayCircle */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["v" /* faMobile */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["p" /* faExternalLink */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["b" /* faAtlas */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["L" /* faUserFriends */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["B" /* faPowerOff */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["q" /* faForward */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["c" /* faBackward */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["f" /* faCheckCircle */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["N" /* faUserPlus */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_pro_light_svg_icons__["M" /* faUserMinus */]);



__WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_3__fortawesome_pro_solid_svg_icons__["a" /* faStar */]);



__WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_brands_svg_icons__["e" /* faTumblrSquare */], __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_brands_svg_icons__["a" /* faFacebookSquare */], __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_brands_svg_icons__["g" /* faTwitterSquare */], __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_brands_svg_icons__["b" /* faPinterestSquare */], __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_brands_svg_icons__["d" /* faTumblr */], __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_brands_svg_icons__["f" /* faTwitter */], __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_brands_svg_icons__["c" /* faReddit */]);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);

/***/ }),

/***/ "lz/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideNav_vue__ = __webpack_require__("T98I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81081c34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideNav_vue__ = __webpack_require__("siMR");
function injectStyle (ssrContext) {
  __webpack_require__("v81+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81081c34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m84K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserBlogList_vue__ = __webpack_require__("0fKa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'UserBlogsPage',
    metaInfo: {
        title: 'Your Blogs'
    },
    data: function data() {
        return {};
    },
    created: function created() {},

    methods: {},
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_2__ui_Icon__["a" /* default */],
        MainNavigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__["a" /* default */],
        BlogList: __WEBPACK_IMPORTED_MODULE_1__UserBlogList_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "mATz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndicatorButton_vue__ = __webpack_require__("S3uB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78f18197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndicatorButton_vue__ = __webpack_require__("IPwU");
function injectStyle (ssrContext) {
  __webpack_require__("d3Jk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndicatorButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78f18197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndicatorButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mMEQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CenterLogo_vue__ = __webpack_require__("9Q6Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bacf9f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CenterLogo_vue__ = __webpack_require__("hLeH");
function injectStyle (ssrContext) {
  __webpack_require__("bGp4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bacf9f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CenterLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bacf9f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CenterLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mbE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['headline'],
    data: function data() {
        return {};
    },
    created: function created() {},

    methods: {}
});

/***/ }),

/***/ "miCQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n+nU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n2zA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    data: function data() {
        return {
            modals: []
        };
    },
    created: function created() {
        var _this = this;

        this.$on('modal.open', function (str) {
            if (!_this.modals.includes(str)) {
                if (_this.modals.length == 0) document.body.classList.add('modal-open');
                _this.modals.push(str);
            }
        });
        this.$on('modal.close', function (str) {
            _this.modals.splice(_this.modals.indexOf(str), 1);
            if (_this.modals.length == 0) document.body.classList.remove('modal-open');
        });
        this.$on('track.click', function (trackObj) {
            if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.user.data.id) _paq.push(['setUserId', __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.user.data.name]); //store.state.user.data.id]);
            _paq.push(['setCustomUrl', trackObj.path]);
            _paq.push(['setDocumentTitle', trackObj.title]);
            _paq.push(['trackPageView']);
        });

        this.$on('track.event', function (trackObj) {
            _paq.push(['trackEvent', trackObj.name, trackObj.data]);
        });

        this.$on('user.login', function () {
            _this.$socket.emit('isOnline', {
                token: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.user.token
            });
        });

        this.$on('user.logout', function () {
            _this.$socket.emit('isOffline', {
                token: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.user.token
            });
        });
    }
});

/* harmony default export */ __webpack_exports__["a"] = (bus);

/***/ }),

/***/ "n51x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import debounce from 'debounce';
var debounce = __webpack_require__("HhAh");

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RegistrationForm',
    data: function data() {
        return {
            email: '',
            username: '',
            password: '',
            ageverification: false,
            termsaccepted: false,
            mailCls: '',
            userCls: '',
            pwCls: ''
        };
    },

    methods: {
        register: function register() {
            var _this = this;

            if (!this.ageverification) {
                return this.$bus.$emit('error', 'You need to be at leat 18!');
            }
            if (!this.termsaccepted) {
                return this.$bus.$emit('error', 'Your ahve to Accept our Terms and Conditions');
            }
            if (this.username.length < 3 || this.password.length < 6 || this.email.indexOf('@') < 2) {
                return this.$bus.$emit('error', 'Please provide valid User Data');
            }
            this.$api.register(this.email, this.username, this.password).then(function (res) {
                return _this.$store.dispatch('user/init', res.data.token);
            }).then(function (res) {
                _this.$bus.$emit('success', 'Your Account was Created! Have Fun!');
                _this.$router.push({ name: 'Intro' });
            });
        },

        checkUsername: debounce(function (e) {
            var _this2 = this;

            var val = e.target.value;
            this.$api.userExists(val).then(function (res) {
                _this2.userCls = res.data.exists;
            });
        }, 600),
        checkEmail: debounce(function (e) {
            var _this3 = this;

            var val = e.target.value;
            this.$api.mailExists(val).then(function (res) {
                _this3.mailCls = res.data.exists;
            });
        }, 600),
        checkPassword: debounce(function (e) {
            var val = e.target.value;
            this.pwCls = val.length > 0 && val.length < 6;
        })
    },
    components: {}

});

/***/ }),

/***/ "n6ub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateBlogPage_vue__ = __webpack_require__("VsM4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8258a980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateBlogPage_vue__ = __webpack_require__("I9D2");
function injectStyle (ssrContext) {
  __webpack_require__("sqFX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateBlogPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8258a980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateBlogPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n7mN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'About',
    data: function data() {
        return {};
    },

    methods: {},
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_0__ui_Icon__["a" /* default */]
    }
});

/***/ }),

/***/ "n8L9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nDTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_CenterLogo_vue__ = __webpack_require__("mMEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard__ = __webpack_require__("PP3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_buttons_IndicatorButton__ = __webpack_require__("mATz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ForgotPwPage',
    metaInfo: {
        title: 'Forgot your Password?',
        meta: [{ vmid: 'description', name: 'description', content: 'Retrieve a new Pimblr Password' }, { vmid: 'title', name: 'title', content: 'Forgot your Password?' }]
    },
    data: function data() {
        return {
            view: 'form',
            email: '',
            error: '',
            isLoading: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (this.$route.params.key) {
            this.view = 'key';
            this.isLoading = true;
            this.$api.retrievePw(this.$route.params.key).then(function () {
                _this.view = 'keysent';
                _this.isLoading = false;
            }).catch(function () {
                _this.view = 'error';
                _this.isLoading = false;
                _this.error = 'We could not reset your password.';
            });
        }
    },

    methods: {
        resetPassword: function resetPassword() {
            var _this2 = this;

            this.isLoading = true;
            this.$api.forgotPw(this.email).then(function () {
                _this2.view = 'requested';
                _this2.isLoading = false;
            }).catch(function () {
                _this2.isLoading = false;
            });
        }
    },
    components: {
        CenteredCard: __WEBPACK_IMPORTED_MODULE_1__layout_CenteredCard__["a" /* default */],
        Logo: __WEBPACK_IMPORTED_MODULE_0__layout_CenterLogo_vue__["a" /* default */],
        IndicatorButton: __WEBPACK_IMPORTED_MODULE_2__ui_buttons_IndicatorButton__["a" /* default */]
    }

});

/***/ }),

/***/ "nDX3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nRmG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepIndicator_vue__ = __webpack_require__("Vylj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735dacb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepIndicator_vue__ = __webpack_require__("GJXK");
function injectStyle (ssrContext) {
  __webpack_require__("v7gI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735dacb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nglB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "content-type-selector",
    props: ['types', 'navClass'],
    data: function data() {
        return {
            cats: ['Straight', 'Shemale', 'Gay'],
            selectedCats: [0]
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$api.getUserInfo().then(function (info) {
            _this.selectedCats = info.data.user.contentTypes;
        });
    },

    methods: {
        toggleCat: function toggleCat(catIdx) {
            var _this2 = this;

            if (this.selectedCats.includes(catIdx)) {
                var idx = this.selectedCats.indexOf(catIdx);
                this.selectedCats.splice(idx, 1);
            } else {
                this.selectedCats.push(catIdx);
            }

            this.$api.changeUserContentTypes(this.selectedCats).then(function (res) {
                _this2.$store.dispatch('user/init', res.data.token);
            });
        }
    }

});

/***/ }),

/***/ "o/i9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oGeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation'),_vm._v(" "),_c('blog-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oICN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountDeletedPage_vue__ = __webpack_require__("5s5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb86dda0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountDeletedPage_vue__ = __webpack_require__("Irel");
function injectStyle (ssrContext) {
  __webpack_require__("miCQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bb86dda0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountDeletedPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb86dda0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountDeletedPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oVkp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ojbn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"nav nav-pills bordered",class:_vm.navClass},_vm._l((_vm.cats),function(cat,i){return _c('a',{staticClass:"nav-link",class:{active: _vm.selectedCats.includes(i)},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleCat(i)}}},[_vm._v(_vm._s(cat))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "owhB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"reblogBtn"},[(_vm.isLoading)?_c('a',{attrs:{"href":"#"}},[_c('icon',{attrs:{"icon":"sync","spin":"","size":_vm.size}})],1):(_vm.wasReblogged)?_c('a',{staticClass:"text-success",attrs:{"href":"#"}},[_c('icon',{attrs:{"icon":"check-circle","size":_vm.size}})],1):_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.pushBtn()}}},[_c('icon',{attrs:{"icon":"retweet","size":_vm.size}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pDV8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "pH1w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pVWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_buttons_PostToBlogButton_vue__ = __webpack_require__("wPy7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_SuccessIcon_vue__ = __webpack_require__("UAOq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_LoadingIndicator_vue__ = __webpack_require__("HToW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Icon__ = __webpack_require__("/G2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_buttons_IndicatorButton__ = __webpack_require__("mATz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AddPost',
    props: ['savedMethod'],
    data: function data() {
        return {
            url: '',
            preview: false,
            submitted: false,
            isLoading: false,
            errorMsg: ''
        };
    },
    created: function created() {
        if (this.$route.query.url) {
            this.url = this.$route.query.url;
        }
        if (this.$route.query.b) {
            this.url = atob(this.$route.query.b);
        }
    },

    watch: {
        url: function url(_url) {
            var _this = this;

            this.preview = false;
            this.errorMsg = '';

            var previews = [
            // {name:"pornhub",  logo:require('../../assets/img/logos/pornhub.png'),  reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?pornhub\.com\/view_video.php\?viewkey=(ph[a-f0-9]{13})|([\d]{5,})$/)},
            // {name:"xhamster", logo:require('../../assets/img/logos/xhamster.svg'),  reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?xhamster\.com\/videos\/([a-z0-9-])+-([0-9]{3,})/)},
            // {name:"tumblr",   logo:require('../../assets/img/logos/tumblr.png'), reg: new RegExp(/^http[s]?:\/\/([^\.]+)\.tumblr\.com\/post\/([^\/]+)*/)},
            // {name:"xnxx",     logo:require('../../assets/img/logos/xnxx.png'), reg: new RegExp(/^http[s]?:\/\/([^\.]+)\.xnxx\.com\/video-([0-9a-z]{6,8})\/.*/)},
            // {name:"xvideos",  logo:require('../../assets/img/logos/xvideos.svg'), reg: new RegExp(/^http[s]?:\/\/([^\.]+)\.xvideos\.com\/video([0-9a-z]{6,8})\/.*/)},
            { name: "dirtyship", logo: __webpack_require__("eWqp"), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?dirtyship\.com\/([0-9a-z-]{5,})\//) }, { name: "tiktits", logo: __webpack_require__("+UQR"), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?tiktits\.com\/video\/([0-9a-z-]{3,})/) }, { name: "motherless", logo: __webpack_require__("TD3i"), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?motherless\.com\/([0-9A-Z]{6,8})/) }, { name: "hypnotube", logo: __webpack_require__("duCX"), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?hypnotube\.com\/video\/.*-(\d{1,})\.html/) }, { name: "ashemaletube", logo: __webpack_require__("4FT9"), reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?ashemaletube\.com\/videos\/.*[\d]{4,}\/.*/) }, { name: "porndig", logo: __webpack_require__("e8va"), reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?porndig\.com\/videos\/[\d]{2,}\/.+\.html/) }, { name: "sexdotcom", logo: __webpack_require__("+ZGw"), reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?sex\.com\/pin\/([0-9]{4,}).+/) }, { name: "sheshaft", logo: __webpack_require__("f87d"), reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?sheshaft\.com\/videos\/([0-9]{4,})\/.+/) }, { name: "eroprofile", logo: __webpack_require__("f87d"), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?eroprofile\.com\/m\/videos\/view\/.+/) }, { name: "youjizz", logo: __webpack_require__("9EQo"), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?youjizz\.com\/videos\/([a-z0-9-])+-([0-9]{3,})\.html/) }, { name: "nsfwonsnap", logo: __webpack_require__("UM4+"), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?nsfw247\.to\/([a-z0-9-])/) }, { name: "hotscope", logo: __webpack_require__("06U2"), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?hotscope\.tv\/(porn|periscope|snapchat)\/([0-9])/) }, { name: "youtrannytube", logo: __webpack_require__("Ty5W"), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?youtrannytube\.com\/(gallery\/)?([a-z0-9-])+-([0-9]{3,})\.html/) }, { name: "fulltrannytube", logo: __webpack_require__("bYy7"), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?fulltrannytube\.com\/(view|gallery)\/([0-9]{3,})+-([a-z0-9-])/) }, { name: "trannytubetv", logo: __webpack_require__("wSez"), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?trannytube\.tv\/movies\/([0-9]{3,})\/([a-z0-9-])/) }];
            var portal = previews.find(function (port) {
                if (port.reg.test(_url)) return port;
            });
            if (portal) {
                this.$api.getVideoInfo(_url).then(function (res) {
                    if (res.status == 404) {
                        _this.errorMsg = res.data.message;
                        return false;
                    }
                    _this.preview = res.data.data;
                    _this.preview.portal = portal;
                }).catch(function (res) {
                    _this.errorMsg = res.response.data.message;
                });
            } else {
                if (_url.length > 1) {
                    this.errorMsg = 'Please provide a valid Video URL';
                }
            }
        }
    },
    methods: {
        doPost: function doPost(blog, callback) {
            var _this2 = this;

            this.isLoading = true;
            this.$api.addPost(blog.url, this.url).then(function (res) {
                _this2.isLoading = false;
                _this2.url = '';
                _this2.submitted = true;
                callback(false);
                setTimeout(function () {
                    if (_this2.savedMethod) {
                        _this2.savedMethod();
                    }
                    _this2.submitted = false;
                }, 2000);
            }).catch(function () {
                _this2.isLoading = false;
            });
        },
        missingPortal: function missingPortal() {
            this.$bus.$emit('feedback.open', 'I am missing the portal: ');
        },
        showHowTo: function showHowTo() {
            this.$bus.$emit('ShowHowToPostVideo');
        }
    },
    components: {
        IndicatorButton: __WEBPACK_IMPORTED_MODULE_4__ui_buttons_IndicatorButton__["a" /* default */],
        Icon: __WEBPACK_IMPORTED_MODULE_3__ui_Icon__["a" /* default */],
        PostButton: __WEBPACK_IMPORTED_MODULE_0__ui_buttons_PostToBlogButton_vue__["a" /* default */],
        SuccessIcon: __WEBPACK_IMPORTED_MODULE_1__ui_SuccessIcon_vue__["a" /* default */],
        LoadingIndicator: __WEBPACK_IMPORTED_MODULE_2__ui_LoadingIndicator_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "plbk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qDxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__posts_PostList_vue__ = __webpack_require__("P8V4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__posts_PostListItem_vue__ = __webpack_require__("xtMH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_BlogNavigation_vue__ = __webpack_require__("0Add");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blogs_BlogHeader_vue__ = __webpack_require__("DWZf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_AgeBlock_vue__ = __webpack_require__("66ng");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_LoadingIndicator__ = __webpack_require__("HToW");
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BlogPage',
  data: function data() {
    return {
      init: false,
      blogUrl: '',
      blog: {},
      posts: [],
      displayVideoId: null,
      meta: {},
      noResults: null
    };
  },
  metaInfo: function metaInfo() {
    return this.meta;
  },
  mounted: function mounted() {
    var _this = this;

    this.blogUrl = this.$route.params.blogUrl;
    if (this.$route.params.videoId) {
      this.displayVideoId = this.$route.params.videoId;
    }
    this.$api.getBlog(this.blogUrl).then(function (res) {
      _this.blog = res.data.blog;
      _this.init = true;

      var absBlogUrl = 'https://pimblr.com/blog/' + _this.blog.url;
      var blogTitle = _this.blog.title + ' on Pimblr';
      _this.meta = {
        title: _this.blog.title,
        meta: [{ vmid: 'description', name: 'description', content: _this.blog.description }, { vmid: 'title', name: 'title', content: _this.blog.title }, { property: 'og:title', content: blogTitle }, { property: 'og:site_name', content: 'Pimblr' }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: absBlogUrl },
        //{property: 'og:image', content: 'https://www.my-site.com/my-special-image.jpg'},

        { name: 'twitter:card', content: 'summary' }, { name: 'twitter:site', content: absBlogUrl }, { name: 'twitter:title', content: blogTitle }, { name: 'twitter:description', content: _this.blog.description }, { itemprop: 'name', content: blogTitle }, { itemprop: 'description', content: _this.blog.description }]
      };
    });

    this.$bus.$on('postlist.noresults', function (data) {
      _this.noResults = data.type;
    });
  },

  methods: {
    displayVideo: function displayVideo() {
      var _this2 = this;

      if (this.displayVideoId) {
        this.$api.getPost(this.displayVideoId).then(function (res) {
          var post = res.data.post;
          _this2.$bus.$emit('playVideo', post);

          var title = post.post.title + " on " + _this2.blog.title;
          var desc = title + " on " + _this2.blog.title + " - " + _this2.blog.description;
          var absBlogUrl = 'https://pimblr.com/blog/' + _this2.blog.url;

          _this2.meta = {
            title: post.post.title,
            meta: [{ vmid: 'description', name: 'description', content: desc }, { vmid: 'title', name: 'title', content: title }, { property: 'og:title', content: title }, { property: 'og:site_name', content: 'Pimblr' }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: absBlogUrl }, { property: 'og:image', content: post.post.preview }, { name: 'twitter:card', content: 'summary' }, { name: 'twitter:site', content: absBlogUrl }, { name: 'twitter:title', content: title }, { name: 'twitter:description', content: desc }, { itemprop: 'name', content: title }, { itemprop: 'description', content: desc }]
          };
        });
      }
    }
  },
  components: {
    LoadingIndicator: __WEBPACK_IMPORTED_MODULE_5__ui_LoadingIndicator__["a" /* default */],
    Posts: __WEBPACK_IMPORTED_MODULE_0__posts_PostList_vue__["a" /* default */],
    PostItem: __WEBPACK_IMPORTED_MODULE_1__posts_PostListItem_vue__["a" /* default */],
    BlogHeader: __WEBPACK_IMPORTED_MODULE_3__blogs_BlogHeader_vue__["a" /* default */],
    BlogNavigation: __WEBPACK_IMPORTED_MODULE_2__layout_BlogNavigation_vue__["a" /* default */],
    AgeBlock: __WEBPACK_IMPORTED_MODULE_4__layout_AgeBlock_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "qsa0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r2zH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r3e9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blogs_BlogList_vue__ = __webpack_require__("cmyg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Icon__ = __webpack_require__("/G2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_buttons_ContentTypeSelector__ = __webpack_require__("2MWY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ContentTypeSelector: __WEBPACK_IMPORTED_MODULE_3__ui_buttons_ContentTypeSelector__["a" /* default */],
        Icon: __WEBPACK_IMPORTED_MODULE_2__ui_Icon__["a" /* default */],
        MainNavigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__["a" /* default */],
        BlogList: __WEBPACK_IMPORTED_MODULE_1__blogs_BlogList_vue__["a" /* default */]
    },
    name: "intro-page",
    data: function data() {
        return {
            selected: false,
            tags: ['Teen', 'Milf', 'Lesbian', 'Anal', 'Squirting', 'Cumshots', 'Deepthroat', 'Blowjobs', 'Hentai', 'Black', 'Asian', 'Shemale', 'Gay'],
            selectedTags: []
        };
    },

    computed: {
        searchTags: function searchTags() {
            return this.selectedTags.join(' ');
        }
    },
    methods: {
        toggleTag: function toggleTag(tag) {
            if (this.selectedTags.includes(tag)) {
                var idx = this.selectedTags.indexOf(tag);
                this.selectedTags.splice(idx, 1);
            } else {
                this.selectedTags.push(tag);
            }
        },
        backToTags: function backToTags() {
            this.selected = false;
        },
        start: function start() {
            this.selected = true;
        }
    }
});

/***/ }),

/***/ "r5J+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'VolumeControl',
    props: ['me', 'isMobile'],
    data: function data() {
        return {
            muted: true,
            position: 0,
            mpos: 50
        };
    },

    computed: {
        progress: function progress() {
            return this.position + "%";
        },
        isMuted: function isMuted() {
            return this.muted || this.position == 0;
        },
        mousePos: function mousePos() {
            return this.mpos + "px";
        }
    },
    watch: {
        me: function me(newVal, oldVal) {
            if (oldVal === false && newVal) this.init();
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            if (_this.me) _this.init();
        }, 5);
    },

    methods: {
        init: function init() {
            var _this2 = this;

            this.muted = localStorage.getItem('player.muted') == "false" ? false : true;
            var volume = parseFloat(localStorage.getItem('player.volume'));
            if (!volume) volume = .75;

            this.me.muted = this.muted;
            if (!this.isMobile) this.me.volume = volume;
            this.position = this.me.volume * 100;
            this.me.onvolumechange = function (e) {
                _this2.calcProg();
            };
            this.$refs['outer'].onmousemove = function (e) {
                _this2.mpos = _this2.getXpos(e);
            };
        },
        calcProg: function calcProg() {
            this.position = this.me.volume * 100;
            this.muted = this.me.muted;
        },
        setPosition: function setPosition(event) {
            var pos = this.getXpos(event);
            var perc = pos / this.$refs['outer'].offsetWidth;
            this.me.volume = perc;
            localStorage.setItem('player.volume', this.me.volume);
            if (this.me.muted) {
                this.toggleMute();
            }
        },
        toggleMute: function toggleMute() {
            this.me.muted = !this.me.muted;
            localStorage.setItem('player.muted', this.me.muted);
        },
        getXpos: function getXpos(event) {
            return event.clientX - this.$refs['outer'].offsetLeft;
        }
    },
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_0__ui_Icon__["a" /* default */]
    }
});

/***/ }),

/***/ "r9f/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('logo'),_vm._v(" "),_c('login-form',{attrs:{"redirect":"Dashboard"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rAgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__posts_PostListItem_vue__ = __webpack_require__("xtMH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PostListItem_vue__ = __webpack_require__("xtMH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_LoadingIndicator_vue__ = __webpack_require__("HToW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PostList',
    props: ['blog', 'attachScrollListener', 'type'],
    data: function data() {
        return {
            wasLastPost: false,
            itemsPerPage: 0,
            isLoading: false,
            posts: [],
            isRefreshing: false,
            refreshAlpha: 0,
            scrollContainer: document,
            instanceCount: 0,
            lastLikeId: 0
        };
    },

    computed: {
        isActivePlaylist: function isActivePlaylist() {
            return this.instanceCount < 2;
        }
    },
    watch: {
        type: function type(newVal, oldVal) {
            this.wasLastPost = false;
            this.posts = [];
            this.lastLikeId = 0;
            this.loadPosts();
        },
        blog: function blog(newVal, oldVal) {
            this.wasLastPost = false;
            this.posts = [];
            this.lastLikeId = 0;
            this.loadPosts();
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (this.attachScrollListener && this.attachScrollListener.scrollContainer) {
            this.scrollContainer = this.attachScrollListener.scrollContainer;
        }
        this.loadPosts();
        this.scrollContainer.addEventListener("scroll", this.scrollListener);

        // Needed to determine, which 'playlist' should respost to player events
        this.$bus.$on('postlist.add', function (data) {
            return _this.instanceCount++;
        });
        this.$bus.$on('postlist.remove', function (data) {
            return _this.instanceCount--;
        });
        this.$bus.$emit('postlist.add', { parent: this.$parent.$options.name });

        this.$bus.$on('hasPlaylist', function (cb) {
            if (_this.isActivePlaylist) cb(true);
        });
        this.$bus.$on('playNextVideo', function (post) {
            if (_this.isActivePlaylist) _this.playNextVideo(post);
        });
        this.$bus.$on('playPrevVideo', function (post) {
            if (_this.isActivePlaylist) _this.playPrevVideo(post);
        });
        this.$bus.$on('post.deleted', function (post) {
            _this.posts.splice(_this.posts.findIndex(function (item) {
                return item === post;
            }), 1);
        });
        this.$bus.$on('post.unliked', function (post) {
            if (_this.type === 'likes') _this.posts.splice(_this.posts.findIndex(function (item) {
                return item === post;
            }), 1);
        });
    },
    beforeDestroy: function beforeDestroy() {
        this.scrollContainer.removeEventListener('scroll', this.scrollListener);
        this.$bus.$emit('postlist.remove', { parent: this.$parent.$options.name });
    },

    methods: {
        scrollListener: function scrollListener() {

            var reloadOffset = 450;
            var offset = this.scrollContainer.scrollTop ? this.scrollContainer.scrollTop : window.pageYOffset;
            var scrollPos = offset + window.innerHeight;
            var docHeight = this.scrollContainer.scrollHeight ? this.scrollContainer.scrollHeight : document.body.scrollHeight;

            if (!this.wasLastPost && !this.isLoading && Math.abs(scrollPos - docHeight) < reloadOffset) {
                this.isLoading = true;
                this.loadPosts();
            }

            if (offset < 0) {
                var a = Math.abs(offset) / 100;
                if (a > 1) {
                    a = 1;
                    if (!this.isRefreshing) {
                        this.posts = [];
                        this.loadPosts();
                        this.isRefreshing = true;
                    }
                }
                this.refreshAlpha = a;
            } else {
                if (this.isRefreshing) this.isRefreshing = false;
            }
        },
        loadPosts: function loadPosts() {
            var _this2 = this;

            var lastId = 0;
            if (this.posts.length > 0) {
                var lastPost = this.posts[this.posts.length - 1];
                lastId = lastPost._id;
            }
            if (this.blog) {
                if (this.posts.length > 0 && !this.$store.state.user.isLoggedIn) {
                    this.$swal({
                        title: "Like this Blog?",
                        text: "Please Login/Register to see more!",
                        showCancelButton: true,
                        confirmButtonText: 'Login',
                        confirmButtonColor: '#d618e7'
                    }).then(function (val) {
                        _this2.$router.push({ name: 'Login' });
                    });
                    return;
                }
                this.$api.getBlogPosts(this.blog.url, lastId).then(this.processPosts);
                return;
            }

            if (this.type === 'likes') {
                this.$api.getLikedPosts(this.lastLikeId).then(this.processPosts);
                return;
            }

            this.$api.getPosts(lastId).then(this.processPosts);
        },
        processPosts: function processPosts(res) {
            var _this3 = this;

            var posts = res.data.posts;
            if (posts.length === 0 && this.posts.length === 0) this.$bus.$emit('postlist.noresults', { type: this.type });
            if (res.data.lastLikeId) this.lastLikeId = res.data.lastLikeId;
            if (this.itemsPerPage < posts.length) this.itemsPerPage = posts.length;
            if (posts.length < this.itemsPerPage) this.wasLastPost = true;
            posts.forEach(function (post) {
                return _this3.posts.push(post);
            });
            this.isLoading = false;
        },
        playNextVideo: function playNextVideo(lastPost) {
            var nextPost = null;
            var isNext = false;
            var plPos = 0;
            for (var i in this.posts) {
                plPos = i;
                var post = this.posts[i];
                if (isNext) {
                    nextPost = post;
                    break;
                }
                if (lastPost._id === post._id) isNext = true;
            }
            // Play Next
            if (nextPost) this.$bus.$emit('playVideo', nextPost);

            // Load More?
            if (plPos < this.posts.length - 3) {
                if (!this.wasLastPost && !this.isLoading) {
                    this.isLoading = true;
                    this.loadPosts();
                }
            }
        },
        playPrevVideo: function playPrevVideo(lastPost) {
            var prevPost = null;
            for (var i in this.posts) {
                var post = this.posts[i];
                if (lastPost._id === post._id) break;
                prevPost = post;
            }
            if (prevPost) this.$bus.$emit('playVideo', prevPost);
        }
    },
    components: {
        LoadingIndicator: __WEBPACK_IMPORTED_MODULE_2__ui_LoadingIndicator_vue__["a" /* default */],
        PostItem: __WEBPACK_IMPORTED_MODULE_1__PostListItem_vue__["a" /* default */],
        'post-item': __WEBPACK_IMPORTED_MODULE_0__posts_PostListItem_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "rR5P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-navigation'),_vm._v(" "),_c('centered-card',{attrs:{"headline":"Edit your Blog"}},[_c('blog-form',{attrs:{"edit":"true","blog":_vm.blog}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rYUc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogList_vue__ = __webpack_require__("cmyg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SearchPage',
    data: function data() {
        return {
            searchQuery: ''
        };
    },
    mounted: function mounted() {
        if (this.$route.params.query) {
            this.searchQuery = this.$route.params.query;
        }
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        this.searchQuery = to.params.query;
        next();
    },

    methods: {},
    components: {
        Navigation: __WEBPACK_IMPORTED_MODULE_0__layout_MainNavigation_vue__["a" /* default */],
        BlogList: __WEBPACK_IMPORTED_MODULE_1__BlogList_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "rkMl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareBookmarklet_vue__ = __webpack_require__("4jD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef773f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareBookmarklet_vue__ = __webpack_require__("R0wX");
function injectStyle (ssrContext) {
  __webpack_require__("Yf7O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ef773f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareBookmarklet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef773f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareBookmarklet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rl1C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Modal__ = __webpack_require__("KQb1");
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "HowToPostVideo",
    components: { Modal: __WEBPACK_IMPORTED_MODULE_0__ui_Modal__["a" /* default */] },
    data: function data() {
        return {
            show: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$bus.$on('ShowHowToPostVideo', function () {
            _this.show = true;
        });
        this.$bus.$on('closeModal', function () {
            _this.show = false;
        });
    }
});

/***/ }),

/***/ "rq0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('centered-card',{attrs:{"headline":_vm.headline}},[_c('div',{staticClass:"mb-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"filter blogs"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"user.getBlogs"}}),_vm._v(" "),_vm._l((_vm.selected),function(blog, k){return _c('blog-item',{key:k,attrs:{"blog":blog}})}),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){$event.preventDefault();_vm.createBlog()}}},[_vm._v("Create a new Blog")]),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-tumblr",on:{"click":function($event){$event.preventDefault();_vm.syncTumblr()}}},[_vm._v("Sync Tumblr Blogs")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s064":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s6xY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroPage_vue__ = __webpack_require__("r3e9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11592e9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroPage_vue__ = __webpack_require__("uxmV");
function injectStyle (ssrContext) {
  __webpack_require__("/hU/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11592e9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11592e9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sP8o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sW+W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "siMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.isOpen)?_c('div',{staticClass:"sidenav-overlay",on:{"click":function($event){$event.preventDefault();_vm.close()}}}):_vm._e()]),_vm._v(" "),_c('nav',{staticClass:"sidenav",class:{'open':_vm.isOpen}},[_c('ul',[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link close-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.close()}}},[_vm._v("x close")])]),_vm._v(" "),_c('li',[_c('form',{staticClass:"form-inline mr-auto mt-2 mt-lg-0"},[_c('search-field')],1)]),_vm._v(" "),_vm._l((_vm.navigation),function(a){return _c(a.subs?'li':'router-link',{key:a.name,tag:"component",staticClass:"nav-item",attrs:{"to":{name:a.name},"tag":"li","activeClass":"active"},nativeOn:{"click":function($event){_vm.closeByLink()}}},[(!a.component && !a.subs)?_c('a',{staticClass:"nav-link"},[_c('span',{staticClass:"icn"},[_c('fa-icon',{attrs:{"icon":a.icon}})],1),_vm._v("\n                  "+_vm._s(a.label)+"\n                ")]):_vm._e(),_vm._v(" "),(!a.component && a.subs)?_c('div',_vm._l((a.subs),function(sub){return _c('router-link',{key:sub.name,staticClass:"nav-link",attrs:{"to":{name: sub.name},"activeClass":"active"},nativeOn:{"click":function($event){_vm.closeByLink()}}},[_c('span',{staticClass:"icn"},[_c('fa-icon',{attrs:{"icon":sub.icon}})],1),_vm._v(" "+_vm._s(sub.label))])})):_vm._e(),_vm._v(" "),(a.component)?_c(a.component,{tag:"component"},[_c('span',{staticClass:"icn"},[_c('fa-icon',{attrs:{"icon":a.icon}})],1),_vm._v(" "+_vm._s(a.label))]):_vm._e()],1)}),_vm._v(" "),(!_vm.isLoggedIn)?_c('router-link',{staticClass:"mav-item",attrs:{"to":"/login","tag":"li","activeClass":"active"}},[_c('a',{staticClass:"nav-link"},[_vm._v("Login")])]):_vm._e(),_vm._v(" "),(_vm.isLoggedIn)?_c('li',{staticClass:"mav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.logout($event)}}},[_c('span',{staticClass:"icn"},[_c('fa-icon',{attrs:{"icon":['fal', 'power-off']}})],1),_vm._v("\n                Logout")])]):_vm._e()],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sjPv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"terms-container"}},[_c('h1',[_vm._v("Terms and Conditions")]),_vm._v(" "),_c('p',[_vm._v("Welcome to Pimblr! Your use and access to Pimblr referred to as service, site, or website are included below. You are accepting these terms when using this service. If needed, these terms might be changed.")]),_vm._v(" "),_c('h2',{attrs:{"id":"yourcontent"}},[_vm._v("Your Content")]),_vm._v(" "),_c('p',[_vm._v("In these terms, \"your content\" means links to videos on othe websites that you submit to this website. Your content is yours.")]),_vm._v(" "),_c('p',[_vm._v("No files, no videos and no images were stored on our servers. All file content is uploaded and stored on the servers of our partners. On Pimblr only the reference to this content ist stored.")]),_vm._v(" "),_c('p',[_vm._v("We need your permission to do things like hosting and displaying your content in connection with the site. You give us permission to do those things.")]),_vm._v(" "),_c('p',[_vm._v("These terms don't give us any rights to your user content except for the limited rights that enable us to offer the service.")]),_vm._v(" "),_c('p',[_vm._v("Upon deletion, your content is completely removed from the site.")]),_vm._v(" "),_c('p',[_vm._v("We reserve the right to screen submitted material and remove any content that doesn’t comply with the service. Your content must adhere to applicable laws and regulations. Content depicting minors is strictly prohibited.")]),_vm._v(" "),_c('h2',{attrs:{"id":"nowarrantiesandliabilities"}},[_vm._v("No Warranties and Liabilities")]),_vm._v(" "),_c('p',[_vm._v("This website is offered in its current form without warranty.")]),_vm._v(" "),_c('p',[_vm._v("Nothing on this website signifies, or is intended to signify, any type of advice.")]),_vm._v(" "),_c('p',[_vm._v("We will not be liable to you concerning the contents, use, or losses in any form in connection with the service. You accept indemnifying, defending, and holding harmless the service for any losses, responsibilities and expenses regarding or occurring out of your use of or incapacity to use the service.")]),_vm._v(" "),_c('h2',{attrs:{"id":"access"}},[_vm._v("Access")]),_vm._v(" "),_c('p',[_vm._v("You must hereby strictly obey every law governed during use. If you are likely to access any content or services from outside of the service’s establishment, you are accountable for following applicable international and jurisdictional laws.")]),_vm._v(" "),_c('p',[_vm._v("We respect your privacy. This privacy statement offers information about our practices with respect to individual and public information that we might gather, utilize, and reveal utilizing the service. In addition, we have established to adhere to every international regulation that handles privacy and data protection. It is thereby your legal duty to review and accept this policy.")]),_vm._v(" "),_c('h2',{attrs:{"id":"gatheredinformation"}},[_vm._v("Gathered Information")]),_vm._v(" "),_c('p',[_vm._v("We collect on standard accounts your email (optional) and IP-addresses for identification while visiting and utilizing the service. If you use tumblr to connect your account we save an encrypted version of the unique identifier given to us. ")]),_vm._v(" "),_c('p',[_vm._v("We might also automatically gather information which relates to your computer hardware and software. This information can and might consist of: IP addresses, browser type, domain names, access times and submitting website addresses. This information is utilized for the operation to maintain service quality and make general statistics available concerning the Site’s use. We do not sell, lease or share customer list and information to third parties.")]),_vm._v(" "),_c('h2',{attrs:{"id":"cookies"}},[_vm._v("Cookies")]),_vm._v(" "),_c('p',[_vm._v("We ask you for the collection, usage and storage of “Cookies” through our web servers. We might send at least one cookie to your computer that exclusively recognizes your browser session. However, the site’s features may be unavailable if you consider refusing cookies.")]),_vm._v(" "),_c('p',[_vm._v("Although our servers currently don't respond to \"do-not-track\" requests, you can block these cookies in other ways, for example by turning off your browser’s cookie functionality.")]),_vm._v(" "),_c('h2',{attrs:{"id":"disclosinginformation"}},[_vm._v("Disclosing Information")]),_vm._v(" "),_c('p',[_vm._v("We will undoubtedly disclose all private information if you intentionally upload any unlawful material to the service without notice and any other relevant information given that it is requested to legally do so or in such belief required through good faith. We will disclose all private information if requested by law enforcement in any of the operating countries.")]),_vm._v(" "),_c('h2',{attrs:{"id":"security"}},[_vm._v("Security")]),_vm._v(" "),_c('p',[_vm._v("We will assume every reasonable and technical precaution to stop the loss, misuse or modification of your private and public information. All information is stored on our protected servers and could be saved, processed in, and transferred between any of the operating countries to allow information use according to this privacy policy. You consent to such cross-border transfers of private information.")]),_vm._v(" "),_c('h2',{attrs:{"id":"jurisdiction"}},[_vm._v("Jurisdiction")]),_vm._v(" "),_c('p',[_vm._v("These terms and conditions will be governed in accordance with the laws of France, and any disputes relating to these terms and conditions will be subject to the nonexclusive jurisdiction of the courts.")]),_vm._v(" "),_c('p',[_vm._v("You may email us at "),_c('a',{attrs:{"href":"mailto:feedback@pimblr.com"}},[_vm._v("feedback@pimblr.com")]),_vm._v(" if you have any questions or believe that somebody has misused any of these terms.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sqFX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sxgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    data: function data() {
        return {};
    },
    created: function created() {},

    methods: {}
});

/***/ }),

/***/ "t4mB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPickerDialog_vue__ = __webpack_require__("kgtc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54b56b64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPickerDialog_vue__ = __webpack_require__("QjH2");
function injectStyle (ssrContext) {
  __webpack_require__("w1W4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54b56b64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPickerDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54b56b64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPickerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tAYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('button',{staticClass:"close closer",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){$event.preventDefault();_vm.closeModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"modal-header"},[_vm._t("header",[_vm._v("\n                        default header\n                    ")])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",[_vm._v("\n                        default body\n                    ")])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_vm._v("\n                        default footer\n                        "),_c('button',{staticClass:"modal-default-button btn btn-xs btn-primary",on:{"click":function($event){_vm.$emit('close-modal')}}},[_vm._v("\n                            OK\n                        ")])])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tVTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__posts_PostList_vue__ = __webpack_require__("P8V4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__posts_PostListItem_vue__ = __webpack_require__("xtMH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Icon__ = __webpack_require__("/G2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_BlogAvatar__ = __webpack_require__("P0hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_buttons_FollowButton__ = __webpack_require__("/caE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_LoadingIndicator__ = __webpack_require__("HToW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'BlogModal',
    data: function data() {
        return {
            init: false,
            showModal: false,
            blogUrl: '',
            blog: {},
            posts: [],
            displayVideoId: null,
            scrollContainer: null,
            noResults: null,
            hasBlogList: false,
            nextBlog: null,
            prevBlog: null
        };
    },

    computed: {
        isLoggedIn: function isLoggedIn() {
            return this.$store.state.user.isLoggedIn;
        }
    },
    mounted: function mounted() {
        var _this = this;

        /*this.$api.getBlog(this.blogUrl).then((res)=>{
            this.blog = res.data.blog;
            this.init = true;
        });*/

        this.$bus.$on('blog-modal.open', function (data) {
            _this.noResults = null;
            _this.scrollContainer = _this.$refs.container;
            _this.$bus.$emit('modal.open', 'blog-modal');
            _this.blog = data.blog;
            _this.init = true;
            _this.showModal = true;

            // Used for prev/next
            _this.hasBlogList = false;
            _this.nextBlog = null;
            _this.prevBlog = null;
            _this.$bus.$emit('bloglist.exists', { currentBlog: _this.blog });
        });

        this.$bus.$on('blog-modal.close', function (data) {
            _this.noResults = null;
            _this.hasBlogList = false;
            _this.nextBlog = null;
            _this.prevBlog = null;
        });

        this.$bus.$on('postlist.noresults', function (data) {
            _this.noResults = data.type;
        });

        // List Prev/next
        this.$bus.$on('blog-modal.listExists', function (data) {
            _this.hasBlogList = true;
            if (data.nextBlog) _this.nextBlog = data.nextBlog;
            if (data.prevBlog) _this.prevBlog = data.prevBlog;
        });
    },

    methods: {
        displayVideo: function displayVideo() {
            var _this2 = this;

            if (this.displayVideoId) {
                this.$api.getPost(this.displayVideoId).then(function (res) {
                    _this2.$bus.$emit('playVideo', res.data.post);
                });
            }
        },
        closeModal: function closeModal() {
            this.showModal = false;
            this.$bus.$emit('blog-modal.close');
            this.$bus.$emit('modal.close', 'blog-modal');
        },
        loadNext: function loadNext() {
            this.$bus.$emit('blog-modal.open', { blog: this.nextBlog });
        },
        loadPrev: function loadPrev() {
            this.$bus.$emit('blog-modal.open', { blog: this.prevBlog });
        },
        sendMessage: function sendMessage() {
            this.$router.push({ name: 'MessageToBlog', params: { blogUrl: this.blog.url } });
            this.closeModal();
        }
    },
    components: {
        LoadingIndicator: __WEBPACK_IMPORTED_MODULE_5__ui_LoadingIndicator__["a" /* default */],
        Icon: __WEBPACK_IMPORTED_MODULE_2__ui_Icon__["a" /* default */],
        Posts: __WEBPACK_IMPORTED_MODULE_0__posts_PostList_vue__["a" /* default */],
        PostItem: __WEBPACK_IMPORTED_MODULE_1__posts_PostListItem_vue__["a" /* default */],
        BlogAvatar: __WEBPACK_IMPORTED_MODULE_3__ui_BlogAvatar__["a" /* default */],
        FollowButton: __WEBPACK_IMPORTED_MODULE_4__ui_buttons_FollowButton__["a" /* default */]
    }
});

/***/ }),

/***/ "ta6d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tzYf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogsPage_vue__ = __webpack_require__("TCb9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7508a193_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogsPage_vue__ = __webpack_require__("oGeQ");
function injectStyle (ssrContext) {
  __webpack_require__("kf+a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7508a193_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u/6j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'LoadingIndicator',
    props: ['name'],
    data: function data() {
        return {
            isLoading: false
        };
    },
    created: function created() {
        var _this = this;

        this.$bus.$on('loading', function (name) {
            if (name == _this.name) _this.isLoading = true;
        });
        this.$bus.$on('loaded', function (name) {
            if (name == _this.name) _this.isLoading = false;
        });
    },

    methods: {}
});

/***/ }),

/***/ "u2Iz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vol"},[_c('div',{staticClass:"btn-cont"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleMute()}}},[(_vm.isMuted)?_c('icon',{attrs:{"icon":"volume-mute"}}):_c('icon',{attrs:{"icon":"volume-up"}})],1)]),_vm._v(" "),_c('div',{staticClass:"bar-cont"},[_c('div',{ref:"outer",staticClass:"prog-bar",on:{"click":function($event){$event.preventDefault();_vm.setPosition($event)}}},[_c('div',{staticClass:"bar bar-outer"},[_c('div',{ref:"progbar",staticClass:"bar bar-inner",style:({width: _vm.progress})}),_vm._v(" "),_c('div',{staticClass:"pointer",style:({left:_vm.mousePos})})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uBMO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessengerDetailPage_vue__ = __webpack_require__("5aRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2649e6f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessengerDetailPage_vue__ = __webpack_require__("Gqr6");
function injectStyle (ssrContext) {
  __webpack_require__("Il6S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2649e6f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessengerDetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2649e6f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessengerDetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uxmV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro"},[_c('main-navigation'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.selected)?_c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("What kind of Porn do you like?")]),_vm._v(" "),_c('content-type-selector',{attrs:{"nav-class":"justify-content-center"}}),_vm._v(" "),_c('h2',[_vm._v("What are you most into?")]),_vm._v(" "),_c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-8"},[_c('nav',{staticClass:"nav nav-pills justify-content-center bordered"},_vm._l((_vm.tags),function(tag){return _c('a',{staticClass:"nav-link",class:{active: _vm.selectedTags.includes(tag)},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleTag(tag)}}},[_vm._v(_vm._s(tag))])}))])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg mt-5",on:{"click":function($event){$event.preventDefault();_vm.start($event)}}},[_vm._v("Get Started!")])],1):_c('div',[_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.backToTags($event)}}},[_c('icon',{attrs:{"icon":"chevron-left"}}),_vm._v(" Select Tags")],1),_vm._v(" "),_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":{name:'Dashboard'},"tag":"button"}},[_vm._v("Go to Dashboard "),_c('icon',{attrs:{"icon":"chevron-right"}})],1)],1),_vm._v(" "),_c('blog-list',{attrs:{"search":_vm.searchTags,"headline":"Pick a few blogs to follow"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v+Dv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PlayBtn_vue__ = __webpack_require__("Uum2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressBar_vue__ = __webpack_require__("3pv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VolumeControl_vue__ = __webpack_require__("86n6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: '',
    props: ['me', 'post', 'isMobile'],
    data: function data() {
        return {
            canAirplay: false,
            videoTag: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.videoTag = document.getElementById('mainPlayer');
        this.$bus.$on('player.close', function () {
            return _this.exitFullscreen();
        });
        //this.determineAirplay()
    },

    methods: {
        toggleFullScreen: function toggleFullScreen() {
            var pl = document.getElementById('mainPlayer');
            if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
                this.enterFullscreen(pl);
            } else {
                this.exitFullscreen();
            }
        },
        enterFullscreen: function enterFullscreen(element) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            }
        },
        exitFullscreen: function exitFullscreen() {
            if (window.fullscreen && document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        },
        determineAirplay: function determineAirplay() {
            if (window.WebKitPlaybackTargetAvailabilityEvent) {
                this.canAirplay = true;
            }
        },
        selectAirplayDevice: function selectAirplayDevice() {
            var pl = document.getElementById('mainPlayer');
            if (!window.WebKitPlaybackTargetAvailabilityEvent) return;
            pl.webkitShowPlaybackTargetPicker();
        },
        skip: function skip(time) {
            var ms = this.me.currentTime;
            var newTime = ms + time;
            console.log(ms, newTime);
            if (newTime > 0 && newTime < this.me.duration) this.me.currentTime = newTime;
        }
    },
    components: {
        PlayBtn: __WEBPACK_IMPORTED_MODULE_0__PlayBtn_vue__["a" /* default */],
        ProgressBar: __WEBPACK_IMPORTED_MODULE_1__ProgressBar_vue__["a" /* default */],
        VolumeControl: __WEBPACK_IMPORTED_MODULE_2__VolumeControl_vue__["a" /* default */],
        Icon: __WEBPACK_IMPORTED_MODULE_3__ui_Icon__["a" /* default */]
    }
});

/***/ }),

/***/ "v1Wd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Icon__ = __webpack_require__("/G2m");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PlayPauseBtn',
    props: ['me', 'post'],
    data: function data() {
        return {
            isPlaying: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$bus.$on('player.close', function () {
            _this.isPlaying = false;
            _this.$store.commit('player/setPause');
        });
        setTimeout(function () {
            _this.isPlaying = !_this.me.paused;
            _this.me.onclick = _this.togglePlay;
            _this.me.onplay = function (e) {
                _this.isPlaying = true;_this.$store.commit('player/setPlay');
            };
            _this.me.onpause = function (e) {
                _this.isPlaying = false;_this.$store.commit('player/setPause');
            };
            _this.me.onended = function (e) {
                _this.isPlaying = false;
                _this.$store.commit('player/setPause');
                _this.$bus.$emit('playNextVideo', _this.post);
            };
            _this.onerror = function (e) {
                _this.$bus.$emit('error', "Oh... there is something wrong with this video... I will skip it!");
                setTimeout(function () {
                    if (_this.isPlaying) {
                        _this.$bus.$emit('playNextVideo', _this.post);
                    }
                }, 3000);
            };
            _this.me.onloadstart = function (e) {
                _this.isPlaying = !_this.me.paused;
                if (_this.isPlaying) {
                    _this.$store.commit('player/setPlay');
                } else {
                    _this.$store.commit('player/setPause');
                }
            };
        }, 5);
    },


    methods: {
        togglePlay: function togglePlay() {
            if (this.isPlaying) {
                this.me.pause();
            } else {
                this.me.play();
            }
        }
    },
    components: {
        Icon: __WEBPACK_IMPORTED_MODULE_0__ui_Icon__["a" /* default */]
    }
});

/***/ }),

/***/ "v7gI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v81+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vG5f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_sweetalert__ = __webpack_require__("f1Fh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_BlogAvatar_vue__ = __webpack_require__("P0hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_buttons_FollowButton_vue__ = __webpack_require__("/caE");
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        blog: {
            defaults: {
                _id: 0,
                title: '',
                description: ''
            }
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        cleanDesc: function cleanDesc() {
            var div = document.createElement("div");
            div.innerHTML = this.blog.description || "";
            return div.textContent || div.innerText || "";
        }
    },
    created: function created() {},

    methods: {},
    components: {
        BlogAvatar: __WEBPACK_IMPORTED_MODULE_1__ui_BlogAvatar_vue__["a" /* default */],
        FollowButton: __WEBPACK_IMPORTED_MODULE_2__ui_buttons_FollowButton_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "vamd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('modal',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h2',[_vm._v("Share this Pimblr Post")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.closeShareModal()}}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"body"},slot:"body"},[_c('a',{staticClass:"shareBtn tumblr",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.shareTumblr($event)},"mouseover":function($event){_vm.hover='tumblr'}}},[_c('icon',{attrs:{"icon":"tumblr-square","collection":"fab","size":"4x"}})],1),_vm._v(" "),_c('a',{staticClass:"shareBtn facebook",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.shareFacebook($event)},"mouseover":function($event){_vm.hover='facebook'}}},[_c('icon',{attrs:{"icon":"facebook-square","collection":"fab","size":"4x"}})],1),_vm._v(" "),_c('a',{staticClass:"shareBtn twitter",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.shareTwitter($event)},"mouseover":function($event){_vm.hover='twitter'}}},[_c('icon',{attrs:{"icon":"twitter-square","collection":"fab","size":"4x"}})],1),_vm._v(" "),_c('a',{staticClass:"shareBtn pinterest",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.sharePinterest($event)},"mouseover":function($event){_vm.hover='pinterest'}}},[_c('icon',{attrs:{"icon":"pinterest-square","collection":"fab","size":"4x"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group-sm mt-2"},[_c('label',{staticClass:"col-form-label-sm"},[_vm._v("Post URL:")]),_vm._v(" "),_c('input',{staticClass:"form-control form-control-sm",domProps:{"value":_vm.getPostUrl()}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"share-img-container"},[_c('div',{style:({'background-image':_vm.imgPreview})}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBlurred),expression:"showBlurred"}],style:({'background-image':_vm.imgBlurred})})])],1),_vm._v(" "),_c('h5',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.post.post.title))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vj8g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vkcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressbar-cont"},[_c('div',{staticClass:"bar-cont"},[_c('div',{ref:"outer",staticClass:"prog-bar",on:{"click":function($event){$event.preventDefault();_vm.setPosition($event)}}},[_c('div',{staticClass:"bar bar-outer"},[_c('div',{ref:"progbar",staticClass:"bar bar-inner",style:({width: _vm.progress})}),_vm._v(" "),_c('div',{staticClass:"pointer",style:({left:_vm.mousePos})})])])]),_vm._v(" "),_c('div',{staticClass:"time-cont"},[_vm._v("\n        "+_vm._s(_vm.timeStr)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vuR9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
   screenSize: function screenSize() {
      var w = window;
      var d = document;
      var e = d.documentElement;
      var g = d.getElementsByTagName('body')[0];
      var x = w.innerWidth || e.clientWidth || g.clientWidth;
      var y = w.innerHeight || e.clientHeight || g.clientHeight;
      return { width: x, height: y };
   }
});

/***/ }),

/***/ "vwIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('fa-icon',{attrs:{"icon":[_vm.collection, _vm.icon],"size":_vm.size,"spin":_vm.spin,"pulse":_vm.pulse,"rotation":_vm.rotation}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w/TQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w1W4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w3EK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__("VH7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7dad08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__("Hcs3");
function injectStyle (ssrContext) {
  __webpack_require__("hjLe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7dad08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w3pE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"registerForm"}},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',[_vm._v("Registration")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",class:{error: _vm.mailCls},attrs:{"type":"text","placeholder":"E-Mail"},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},_vm.checkEmail]}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",class:{error: _vm.userCls},attrs:{"type":"text","placeholder":"Username"},domProps:{"value":(_vm.username)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.username=$event.target.value},_vm.checkUsername]}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",class:{error: _vm.pwCls},attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.password=$event.target.value},_vm.checkPassword]}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ageverification),expression:"ageverification"}],attrs:{"type":"checkbox","id":"agever","value":"1"},domProps:{"checked":Array.isArray(_vm.ageverification)?_vm._i(_vm.ageverification,"1")>-1:(_vm.ageverification)},on:{"change":function($event){var $$a=_vm.ageverification,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ageverification=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ageverification=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ageverification=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"agever"}},[_vm._v("I confirm that I am at least 18 years old")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termsaccepted),expression:"termsaccepted"}],attrs:{"type":"checkbox","id":"accept","value":"1"},domProps:{"checked":Array.isArray(_vm.termsaccepted)?_vm._i(_vm.termsaccepted,"1")>-1:(_vm.termsaccepted)},on:{"change":function($event){var $$a=_vm.termsaccepted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.termsaccepted=$$a.concat([$$v]))}else{$$i>-1&&(_vm.termsaccepted=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.termsaccepted=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"accept"}},[_vm._v("I Agree to the "),_c('router-link',{attrs:{"to":{name:'TermsConditions'},"target":"_blank"}},[_vm._v("Terms & Conditions")])],1)]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.register($event)}}},[_vm._v("Register")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Already registered? "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Log in here!")])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wMq3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ApiService__ = __webpack_require__("jZ0l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventBus__ = __webpack_require__("n2zA");



/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        isLoggedIn: false,
        token: null,
        data: { id: 0, name: '' },
        blogs: [],
        follows: [],
        tumblrAuth: {},
        unreadMessages: 0
    },
    getters: {
        token: function token(state) {
            return state.token;
        },
        isLoggedIn: function isLoggedIn(state) {
            return state.isLoggedIn;
        },
        follows: function follows(state) {
            return state.follows;
        },
        id: function id(state) {
            return state.data.id;
        },
        name: function name(state) {
            return state.data.name;
        },
        blogs: function blogs(state) {
            return state.blogs;
        },
        tumblrAuth: function tumblrAuth(state) {
            return state.tumblrAuth;
        },
        unreadMessages: function unreadMessages(state) {
            return state.unreadMessages;
        }
    },
    mutations: {
        setToken: function setToken(state, token) {
            localStorage.setItem('token', token);
            state.isLoggedIn = true;
            state.token = token;
            this.dispatch('user/updateBlogs');
        },
        unsetToken: function unsetToken(state) {
            localStorage.removeItem('token');
            state.isLoggedIn = false;
            state.token = null;
            __WEBPACK_IMPORTED_MODULE_1__services_EventBus__["a" /* default */].$emit('user.logout');
        },
        setData: function setData(state, data) {
            state.data.id = data._id;
            state.data.name = data.name;
        },
        updateBlogs: function updateBlogs(state, blogs) {
            state.blogs = blogs;
        },
        userFollows: function userFollows(state, followedBlogs) {
            state.follows = followedBlogs;
        },
        tumblrAuth: function tumblrAuth(state, auth) {
            state.tumblrAuth = auth;
        },
        setUnreadMessages: function setUnreadMessages(state, messageCount) {
            state.unreadMessages = messageCount;
        }
    },
    actions: {
        init: function init(ctx, token) {
            return __WEBPACK_IMPORTED_MODULE_0__services_ApiService__["a" /* default */].getUserInfo(token).then(function (res) {
                ctx.commit('setToken', res.data.token);
                ctx.commit('setData', res.data.user);
                ctx.commit('userFollows', res.data.user.follows);
                localStorage.setItem('token', res.data.token);
                __WEBPACK_IMPORTED_MODULE_1__services_EventBus__["a" /* default */].$emit('user.login');
            });
        },
        updateBlogs: function updateBlogs(ctx) {
            __WEBPACK_IMPORTED_MODULE_0__services_ApiService__["a" /* default */].getUserBlogs().then(function (res) {
                ctx.commit('updateBlogs', res.data.blogs);
            });
        },
        followBlog: function followBlog(ctx, blogUrl) {
            __WEBPACK_IMPORTED_MODULE_0__services_ApiService__["a" /* default */].toggleFollowBlog(blogUrl).then(function (res) {
                ctx.commit('userFollows', res.data.follows);
            });
        }
    }
});

/***/ }),

/***/ "wPy7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostToBlogButton_vue__ = __webpack_require__("Rxpt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a05e6ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostToBlogButton_vue__ = __webpack_require__("LH+o");
function injectStyle (ssrContext) {
  __webpack_require__("pH1w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a05e6ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostToBlogButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a05e6ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostToBlogButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wRPc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wSez":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "wgln":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation'),_vm._v(" "),_c('drop-down-header',{attrs:{"items":_vm.dropdownItems,"callback":_vm.changePostTypes}}),_vm._v(" "),_c('posts',{attrs:{"type":_vm.listType}}),_vm._v(" "),(_vm.noResults==='dashboard')?_c('centered-card',{staticClass:"text-center"},[_c('h4',[_vm._v("Oh, we are sorry! We did not find any posts for you!")]),_vm._v(" "),_c('p',[_vm._v("Maybe you should follow a few more "),_c('router-link',{attrs:{"to":{name:'Blogs'}}},[_vm._v("blogs")]),_vm._v("!\n            The more blogs you are following, the more posts you will get on your Dashboard.")],1)]):_vm._e(),_vm._v(" "),(_vm.noResults==='likes')?_c('centered-card',{staticClass:"text-center"},[_c('h4',[_vm._v("You do not have any favorite posts yet!")]),_vm._v(" "),_c('p',[_vm._v("For adding posts to your favorites, just hit the "),_c('icon',{attrs:{"icon":"heart"}}),_vm._v(" icon"),_c('br'),_vm._v("\n            on the lower right of a post or"),_c('br'),_vm._v("\n            on the top right of the player.")],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_MainNavigation_vue__ = __webpack_require__("HCAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_NotificationCenter_vue__ = __webpack_require__("DWzs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_player_Player_vue__ = __webpack_require__("Ag/t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_blogs_BlogModal__ = __webpack_require__("DqrW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_ShareModal_vue__ = __webpack_require__("HgfD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_BlogPickerDialog_vue__ = __webpack_require__("t4mB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_FeedbackWidget__ = __webpack_require__("0aoe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layout_SideNav__ = __webpack_require__("lz/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_content_HowToPostVideo__ = __webpack_require__("/bk7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_posts_PostInspector__ = __webpack_require__("YNeV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_layout_CookieBanner__ = __webpack_require__("yGO6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    metaInfo: {
        meta: [{ name: 'title', vmid: 'title', content: 'Pimblr - The new way of watching porn' }, { name: 'description', vmid: 'description', content: 'Pimblr is a community for sharing curated porn videos. Follow blogs with the same interests or create your own Pimblr Blog.' }, { property: 'og:title', content: 'Pimblr - The new way of watching porn' }, { property: 'og:site_name', content: 'Pimblr' }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: 'https://pimblr.com' }, { property: 'og:image', content: 'https://pimblr.com/static/LogoFlyer.png' }, { name: 'twitter:card', content: 'summary' }, { name: 'twitter:site', content: 'https://pimblr.com' }, { name: 'twitter:title', content: 'Pimblr - The new way of watching porn' }, { name: 'twitter:description', content: 'Pimblr is a community for sharing curated porn videos. Follow blogs with the same interests or create your own Pimblr Blog.' }, { itemprop: 'name', content: 'Pimblr - The new way of watching porn' }, { itemprop: 'description', content: 'Pimblr is a community for sharing curated porn videos. Follow blogs with the same interests or create your own Pimblr Blog.' }, { itemprop: 'image', content: 'https://pimblr.com/static/LogoFlyer.png' }],
        titleTemplate: function titleTemplate(titleChunk) {
            return titleChunk ? titleChunk + ' - Pimblr' : 'Pimblr';
        }
    },
    created: function created() {
        var _this = this;

        var token = localStorage.getItem('token');
        if (token) {
            this.$store.commit('user/setToken', token);
            this.$store.dispatch('user/init', token).then(function (res) {

                if (!localStorage.getItem('message_4ae46fb5619b')) {
                    _this.$nextTick(function () {
                        _this.$bus.$emit('ShowHowToPostVideo');
                    });
                    localStorage.setItem('message_4ae46fb5619b', '1');
                }
            }).catch(function (err) {
                _this.$store.state.waitForStore = true;
                _this.$router.push('/login');
            });
        }
    },

    components: {
        PostInspector: __WEBPACK_IMPORTED_MODULE_9__components_posts_PostInspector__["a" /* default */],
        HowToPostVideo: __WEBPACK_IMPORTED_MODULE_8__components_content_HowToPostVideo__["a" /* default */],
        SideNav: __WEBPACK_IMPORTED_MODULE_7__components_layout_SideNav__["a" /* default */],
        navigation: __WEBPACK_IMPORTED_MODULE_0__components_layout_MainNavigation_vue__["a" /* default */],
        NotificationCenter: __WEBPACK_IMPORTED_MODULE_1__components_layout_NotificationCenter_vue__["a" /* default */],
        Player: __WEBPACK_IMPORTED_MODULE_2__components_player_Player_vue__["a" /* default */],
        BlogModal: __WEBPACK_IMPORTED_MODULE_3__components_blogs_BlogModal__["a" /* default */],
        ShareModal: __WEBPACK_IMPORTED_MODULE_4__components_layout_ShareModal_vue__["a" /* default */],
        BlogPickerDialog: __WEBPACK_IMPORTED_MODULE_5__components_ui_BlogPickerDialog_vue__["a" /* default */],
        Feedback: __WEBPACK_IMPORTED_MODULE_6__components_layout_FeedbackWidget__["a" /* default */],
        CookeBanner: __WEBPACK_IMPORTED_MODULE_10__components_layout_CookieBanner__["a" /* default */]
    }
});

/***/ }),

/***/ "xOaP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('navigation'),_vm._v(" "),_c('blog-list',{attrs:{"searchQuery":_vm.searchQuery,"headline":"Search Results"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xPNs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xffA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ProgressBar',
    props: ['me', 'post'],
    data: function data() {
        return {
            position: 0,
            mpos: 50,
            timeStr: "0:00"
        };
    },

    computed: {
        progress: function progress() {
            return this.position + "%";
        },
        mousePos: function mousePos() {
            return this.mpos + "px";
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.me.onloadstart = function () {
                _this.init();
            };
            _this.me.onloadedmetadata = _this.loadedMeta;
            _this.me.ontimeupdate = function (e) {
                _this.calcProg();
            };
            _this.me.onwaiting = function (e) {
                _this.$bus.$emit('loading', 'posts.getVideoUrl');
            };
            _this.me.onplaying = function (e) {
                _this.$bus.$emit('loaded', 'posts.getVideoUrl');
            };
            _this.$refs['outer'].onmousemove = function (e) {
                _this.mpos = _this.getXpos(e);
            };
        }, 5);
    },

    methods: {
        init: function init() {
            this.timeStr = '0:00';
            if (this.me.duration) {
                this.timeStr = this.secToTime(this.me.currentTime) + " / " + this.secToTime(this.me.duration);
            }
        },
        calcProg: function calcProg() {
            var prog = 0;
            if (this.me.duration) {
                prog = this.me.currentTime / this.me.duration * 100;
                this.timeStr = this.secToTime(this.me.currentTime) + " / " + this.secToTime(this.me.duration);
            }
            this.$bus.$emit('player.progress', { progress: prog, time: this.timeStr });
            this.position = prog;
        },
        setPosition: function setPosition(event) {
            var pos = this.getXpos(event);
            var perc = pos / this.$refs['outer'].offsetWidth;
            this.me.currentTime = Math.round(perc * this.me.duration);
        },
        getXpos: function getXpos(event) {
            return event.clientX - this.$refs['outer'].offsetLeft;
        },
        secToTime: function secToTime(secs) {
            var d = new Date(0);
            d.setSeconds(secs);
            return d.getMinutes() + ":" + this.nStr(d.getSeconds());
        },
        nStr: function nStr(val) {
            var str = val.toString();
            if (str.length < 2) str = "0" + str;
            return str;
        },
        loadedMeta: function loadedMeta(e) {
            var _this2 = this;

            this.init();
            if (this.post.post.duration == 0) {
                var newDur = Math.round(this.me.duration);
                this.$api.updatePostDuration(this.post.post._id, newDur).then(function (res) {
                    _this2.post.post.duration = newDur;
                });
            }
        }
    }
});

/***/ }),

/***/ "xjOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"startPage"}},[_c('div',{staticClass:"container bg-image",attrs:{"id":"intro"}},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"jumbotron mt-5 pb-5"},[_vm._m(0),_vm._v(" "),_c('logo'),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',[_vm._v("To view this content and become part of our community you need to be at least")]),_vm._v(" "),_c('h2',[_vm._v("18 years old")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('router-link',{staticClass:"btn btn-outlined",attrs:{"to":{name:'Login'},"tag":"button"}},[_vm._v("  Login")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-outlined",attrs:{"to":{name:'Registration'},"tag":"button"}},[_vm._v("Register")])],1)])])]),_vm._v(" "),_c('section',{staticClass:"light"},[_c('div',{staticClass:"container"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 mb-5"},[_c('div',{staticClass:"text-center icon-light"},[_c('icon',{attrs:{"icon":"lightbulb","size":"5x"}})],1),_vm._v(" "),_c('h3',[_vm._v("The Idea")]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-5"},[_c('div',{staticClass:"text-center icon-light"},[_c('icon',{attrs:{"icon":"question","size":"5x"}})],1),_vm._v(" "),_c('h3',[_vm._v("How does it work")]),_vm._v(" "),_c('p',[_vm._v("On Pimblr you can create and follow blogs. A Pimblr Blog is a collection of videos on a specific topic,\n                        taste, fetish or whatever. So, if you find some blogs you like, you can follow them with only one click.\n                        From there on, you will find the latest videos of all your favorite blogs posted, right on your dashboard.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-5"},[_c('div',{staticClass:"text-center icon-light"},[_c('icon',{attrs:{"icon":"list","size":"5x"}})],1),_vm._v(" "),_c('h3',[_vm._v("Blog as Playlist")]),_vm._v(" "),_c('p',[_vm._v("A Blog can also seen as a simple playlist. And unlike a usual playlist, or a board in pinterest, a\n                        blog is always growing and never gets old! On your dashboard you will always see the latest posts\n                        from all blogs you are following so it's your personal Best-Of-Playlist!")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-5"},[_c('div',{staticClass:"text-center icon-light"},[_c('icon',{attrs:{"icon":"play-circle","size":"5x"}})],1),_vm._v(" "),_c('h3',[_vm._v("The endless Player")]),_vm._v(" "),_c('p',[_vm._v("We've created player, that plays the videos from your dashboard or any given Pimblr-Blog without\n                    stopping, one video right after the other. Furthermore it runs into the entire browser window so you get\n                    the maximum out of your screen.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-5"},[_c('div',{staticClass:"text-center icon-light"},[_c('icon',{attrs:{"icon":"mobile","size":"5x"}})],1),_vm._v(" "),_c('h3',[_vm._v("Web App")]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-5"},[_c('div',{staticClass:"text-center icon-light"},[_c('icon',{attrs:{"icon":"share-alt","size":"5x"}})],1),_vm._v(" "),_c('h3',[_vm._v("Share without upload")]),_vm._v(" "),_c('p',[_vm._v("On Pimblr you can share porn videos right from other supported portals with just a few clicks.\n                    There is no need to download and upload the video again. Copy & Paste the URL and you're done!\n                        Or try our Favelet to share videos with "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showSharing()}}},[_vm._v("just one click!")])])])])])]),_vm._v(" "),_c('section',{staticClass:"darker"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"mb-5"},[_vm._v("Why Pimblr is better than...")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"text-center color-tumblr"},[_c('icon',{attrs:{"icon":"tumblr","collection":"fab","size":"4x"}})],1),_vm._v(" "),_c('h3',[_vm._v("tumblr")]),_vm._v(" "),_c('p',[_vm._v("tumblr does not allow \"adult videos\" and since december 2018 tumblr is activly fighting\n                      nsfw content.\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"text-center color-twitter"},[_c('icon',{attrs:{"icon":"twitter","collection":"fab","size":"4x"}})],1),_vm._v(" "),_c('h3',[_vm._v("Twitter")]),_vm._v(" "),_c('p',[_vm._v("Twitter does allow adult content, but it limits videos to only 2 minutes and 20 seconds.\n                        Twitter Accounts are bound to persons, Pimblr allows Users to create many blogs, so\n                        they are way more specefic.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"text-center color-reddit"},[_c('icon',{attrs:{"icon":"reddit","collection":"fab","size":"4x"}})],1),_vm._v(" "),_c('h3',[_vm._v("Reddit")]),_vm._v(" "),_c('p',[_vm._v("Reddit has some really great subreddits, but the media integration is aweful.\n                        Most of the videos are converted to gif. It is also very hard to find the right subreddits.\n                        On Pimblr they are all in one place!\n                    ")])])])])]),_vm._v(" "),_c('section',{staticClass:"light"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"mb-3"},[_vm._v("Check out our Top 20 Blog Charts:")]),_vm._v(" "),_c('top20')],1)]),_vm._v(" "),_c('section',{staticClass:"light"},[_c('div',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{name:'TermsConditions'}}},[_vm._v("Terms and Conditions")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("Welcome to "),_c('span',{staticClass:"sr-only"},[_vm._v("Pimblr")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-md-center mb-5"},[_c('div',{staticClass:"col-md-6"},[_c('h2',{staticClass:"h1"},[_vm._v("What is Pimblr?")]),_vm._v(" "),_c('p',{staticClass:"lead text-center"},[_vm._v("Long story short, Pimblr is like tumblr or Twitter... but for porn videos only!")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("A new way of watching porn.")]),_vm._v(" The idea behind Pimblr is, that you do not have to search for porn anymore. You got it straight delivered to\n                        your dashbord! Every day or every hour you will find new videos from blogs you like on your dashbord, so\n                        just click play and enjoy!")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Pimblr uses the latest technology on mobile devices called "),_c('strong',[_vm._v("Progressive Web App.")]),_vm._v("\n                    This makes it possible to run Pimblr on your mobile or tablet like a native app. This is the easiest\n                    way to run a porn app even on iOS devices.\n                    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xtMH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostListItem_vue__ = __webpack_require__("5Fw7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0010a38c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostListItem_vue__ = __webpack_require__("gfnv");
function injectStyle (ssrContext) {
  __webpack_require__("y2UQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0010a38c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0010a38c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xy0H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SyncTublrPage_vue__ = __webpack_require__("S4Eb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91035306_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SyncTublrPage_vue__ = __webpack_require__("5h9F");
function injectStyle (ssrContext) {
  __webpack_require__("Fj/C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-91035306"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SyncTublrPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91035306_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SyncTublrPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y2UQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y2q9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y3vI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{open:_vm.isOpen, dark:(_vm.theme==='dark')},attrs:{"id":"post-inspector"}},[_c('a',{staticClass:"closer",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.pushClose($event)}}},[_c('icon',{attrs:{"icon":"times"}})],1),_vm._v(" "),_c('div',{staticClass:"scroll-container"},[(_vm.postExists)?_c('div',[(_vm.postExists)?_c('h4',[_vm._v(_vm._s(_vm.post.post.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"poweredby"},[_c('small',[_vm._v("powered by")]),_vm._v(" "),_c('portal-logo',{attrs:{"post":_vm.post,"mh":"20px","usebg":"true"}})],1),_vm._v(" "),(_vm.post.post.preview)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.post.post.preview}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('loading-indicator',{attrs:{"name":"post.extendedInfo"}}),_vm._v(" "),(_vm.postDataExists)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v("\n                    "+_vm._s(_vm.postData.likeCount)+" Like"),(_vm.postData.likeCount!=1)?_c('span',[_vm._v("s")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showTrail = !_vm.showTrail}}},[_vm._v("posted "+_vm._s(_vm.postData.blogs.length)+" time"),(_vm.postData.blogs.length!=1)?_c('span',[_vm._v("s")]):_vm._e()])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTrail),expression:"showTrail"}],staticClass:"trail-list"},_vm._l((_vm.postData.blogs),function(blog){return _c('div',{staticClass:"blog-item"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showBlog(blog)}}},[_c('blog-avatar',{attrs:{"blog":blog,"w":28,"h":28}}),_vm._v("  "+_vm._s(_vm._f("maxlen")(blog.title,30)))],1)])})),_vm._v(" "),_c('div',{staticClass:"commentForm"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Leave a Comment:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.commentStr),expression:"commentStr"}],staticClass:"form-control",attrs:{"placeholder":"Your Comment..."},domProps:{"value":(_vm.commentStr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.commentStr=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.commentStr.length===0 || _vm.isPostingComment},on:{"click":function($event){$event.preventDefault();_vm.postComment($event)}}},[(_vm.isPostingComment)?_c('icon',{attrs:{"icon":"circle-notch","spin":""}}):_vm._e(),_vm._v("\n                    Post\n                ")],1)]),_vm._v(" "),_c('div',{staticClass:"comments"},_vm._l((_vm.postData.comments),function(comment){return _c('div',{staticClass:"comment"},[_c('div',{staticClass:"author"},[_vm._v("\n                        "+_vm._s(comment.user.name)+"\n                        "),(_vm.isMine(comment))?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteComment(comment)}}},[_c('icon',{attrs:{"icon":"trash"}})],1):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n                        "+_vm._s(comment.text)+"\n                    ")])])}))]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yGO6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieBanner_vue__ = __webpack_require__("UFpK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7c4186_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieBanner_vue__ = __webpack_require__("R5QS");
function injectStyle (ssrContext) {
  __webpack_require__("I/Xl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7c4186_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zhx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar fixed-top navbar-expand-lg navbar-light bg-light-tr"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"navbar-brand"},[_c('a',{staticClass:"nav-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goBack()}}},[_c('icon',{attrs:{"icon":"chevron-left"}}),_vm._v(" Back")],1)]),_vm._v(" "),_c('div',{staticClass:" navbar-collapse d-none"},[_c('ul',{staticClass:"navbar-nav my-2 my-lg-0 mx-auto"},[_c('li',[_c('h4',{staticClass:"text-center pt-1"},[_vm._v(_vm._s(_vm.title))])])])]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler d-inline",attrs:{"type":"button"},on:{"click":function($event){_vm.toggleNav()}}},[_c('span',{staticClass:"navbar-toggler-icon"})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zxC5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ab6ea77a88a2f7c37acf.js